/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.tg = (function() {

    /**
     * Namespace tg.
     * @exports tg
     * @namespace
     */
    var tg = {};

    /**
     * 宏定义
     * @name tg.enCommand
     * @enum {number}
     * @property {number} MDM_GR_TOOLS_NULL=0 MDM_GR_TOOLS_NULL value
     * @property {number} MDM_GR_TOOLS_LOGIN=1 MDM_GR_TOOLS_LOGIN value
     * @property {number} SUB_GR_GAME_TOOLS_LOGIN=100 SUB_GR_GAME_TOOLS_LOGIN value
     * @property {number} SUB_GR_GAME_TOOLS_LOGIN_SUCCESS=101 SUB_GR_GAME_TOOLS_LOGIN_SUCCESS value
     * @property {number} SUB_GR_GAME_TOOLS_LOGIN_REG=200 SUB_GR_GAME_TOOLS_LOGIN_REG value
     * @property {number} SUB_GR_GAME_TOOLS_LOGIN_REG_SUCCESS=201 SUB_GR_GAME_TOOLS_LOGIN_REG_SUCCESS value
     * @property {number} SUB_GR_GAME_TOOLS_LOGIN_CHECK=220 SUB_GR_GAME_TOOLS_LOGIN_CHECK value
     * @property {number} SUB_GR_GAME_TOOLS_LOGIN_CHECK_SUCCESS=221 SUB_GR_GAME_TOOLS_LOGIN_CHECK_SUCCESS value
     * @property {number} SUB_GR_GAME_TOOLS_LOGIN_DELETE=400 SUB_GR_GAME_TOOLS_LOGIN_DELETE value
     * @property {number} SUB_GR_GAME_TOOLS_LOGIN_DELETE_SUCCESS=401 SUB_GR_GAME_TOOLS_LOGIN_DELETE_SUCCESS value
     * @property {number} SUB_GR_GAME_TOOLS_LOGIN_REFRESH=500 SUB_GR_GAME_TOOLS_LOGIN_REFRESH value
     * @property {number} SUB_GR_GAME_TOOLS_LOGIN_RESULT=501 SUB_GR_GAME_TOOLS_LOGIN_RESULT value
     * @property {number} SUB_GR_IM_SENDMESSAGE_UNLOCK=600 SUB_GR_IM_SENDMESSAGE_UNLOCK value
     * @property {number} SUB_GR_IM_SENDMESSAGE_UNLOCK_RESULT=601 SUB_GR_IM_SENDMESSAGE_UNLOCK_RESULT value
     * @property {number} SUB_GR_IM_NET_PROXY_ADD=700 SUB_GR_IM_NET_PROXY_ADD value
     * @property {number} SUB_GR_IM_NET_PROXY_QUERY=710 SUB_GR_IM_NET_PROXY_QUERY value
     * @property {number} SUB_GR_IM_NET_PROXY_LIST=711 SUB_GR_IM_NET_PROXY_LIST value
     * @property {number} SUB_GR_IM_NET_PROXY_DELETE=720 SUB_GR_IM_NET_PROXY_DELETE value
     * @property {number} SUB_GR_IM_NET_PROXY_CHECK=730 SUB_GR_IM_NET_PROXY_CHECK value
     * @property {number} SUB_GR_IM_NET_PROXY_USER_CHECK=740 SUB_GR_IM_NET_PROXY_USER_CHECK value
     * @property {number} SUB_GR_IM_NET_PROXY_USER_LIST=741 SUB_GR_IM_NET_PROXY_USER_LIST value
     * @property {number} SUB_GR_IM_NET_PROXY_ALLOCATE=750 SUB_GR_IM_NET_PROXY_ALLOCATE value
     * @property {number} SUB_GR_IM_NET_PROXY_USER_UPDATE=760 SUB_GR_IM_NET_PROXY_USER_UPDATE value
     * @property {number} MDM_GR_TOOLS_ACCOUNT=2 MDM_GR_TOOLS_ACCOUNT value
     * @property {number} SUB_GR_GAME_TOOLS_ACCOUNT_LIST=200 SUB_GR_GAME_TOOLS_ACCOUNT_LIST value
     * @property {number} SUB_GR_GAME_TOOLS_ACCOUNT_LIST_RESULT=201 SUB_GR_GAME_TOOLS_ACCOUNT_LIST_RESULT value
     * @property {number} SUB_GR_IM_TOOLS_ACCOUNT_LIST_ACK=210 SUB_GR_IM_TOOLS_ACCOUNT_LIST_ACK value
     * @property {number} SUB_GR_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT=211 SUB_GR_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT value
     * @property {number} SUB_GR_GAME_TOOLS_ACCOUNT_STATUS=300 SUB_GR_GAME_TOOLS_ACCOUNT_STATUS value
     * @property {number} MDM_GR_TOOLS_TELEGRAM=3 MDM_GR_TOOLS_TELEGRAM value
     * @property {number} SUB_GR_GAME_TOOLS_TELEGRAM_SEND=200 SUB_GR_GAME_TOOLS_TELEGRAM_SEND value
     * @property {number} SUB_GR_GAME_TOOLS_TELEGRAM_SEND_RESULT=201 SUB_GR_GAME_TOOLS_TELEGRAM_SEND_RESULT value
     * @property {number} SUB_GR_GAME_TOOLS_TELEGRAM_RECV=300 SUB_GR_GAME_TOOLS_TELEGRAM_RECV value
     * @property {number} SUB_GR_GAME_TOOLS_TELEGRAM_RECV_RESULT=301 SUB_GR_GAME_TOOLS_TELEGRAM_RECV_RESULT value
     * @property {number} SUB_GR_GAME_TOOLS_TELEGRAM_NEWMSG=302 SUB_GR_GAME_TOOLS_TELEGRAM_NEWMSG value
     * @property {number} SUB_GR_GAME_TOOLS_TELEGRAM_CUR_HISTORY=310 SUB_GR_GAME_TOOLS_TELEGRAM_CUR_HISTORY value
     * @property {number} SUB_GR_GAME_TOOLS_TELEGRAM_HISTORY_RESULT=311 SUB_GR_GAME_TOOLS_TELEGRAM_HISTORY_RESULT value
     * @property {number} SUB_GR_GAME_TOOLS_TELEGRAM_GET_CONTACTS=400 SUB_GR_GAME_TOOLS_TELEGRAM_GET_CONTACTS value
     * @property {number} SUB_GR_GAME_TOOLS_TELEGRAM_CONTACTS_LIST=401 SUB_GR_GAME_TOOLS_TELEGRAM_CONTACTS_LIST value
     * @property {number} SUB_GR_GAME_TOOLS_TELEGRAM_SEARCH=402 SUB_GR_GAME_TOOLS_TELEGRAM_SEARCH value
     * @property {number} SUB_GR_GAME_TOOLS_TELEGRAM_SEARCH_RESULT=403 SUB_GR_GAME_TOOLS_TELEGRAM_SEARCH_RESULT value
     * @property {number} SUB_GR_GAME_TOOLS_TELEGRAM_ADDUSER=404 SUB_GR_GAME_TOOLS_TELEGRAM_ADDUSER value
     * @property {number} SUB_GR_GAME_TOOLS_TELEGRAM_DELUSER=405 SUB_GR_GAME_TOOLS_TELEGRAM_DELUSER value
     * @property {number} SUB_GR_GAME_TOOLS_TELEGRAM_EDIT_USER=406 SUB_GR_GAME_TOOLS_TELEGRAM_EDIT_USER value
     * @property {number} SUB_GR_GAME_TOOLS_JOIN_GROUP=407 SUB_GR_GAME_TOOLS_JOIN_GROUP value
     * @property {number} SUB_GR_GAME_TOOLS_LEAVE_GROUP=408 SUB_GR_GAME_TOOLS_LEAVE_GROUP value
     * @property {number} MDM_GR_TOOLS_DATA_LOAD=4 MDM_GR_TOOLS_DATA_LOAD value
     * @property {number} SUB_GR_GAME_TOOLS_ACCOUNT_LOAD=200 SUB_GR_GAME_TOOLS_ACCOUNT_LOAD value
     * @property {number} SUB_GR_GAME_TOOLS_TELEGRAM_LOAD=300 SUB_GR_GAME_TOOLS_TELEGRAM_LOAD value
     * @property {number} SUB_GR_GAME_TOOLS_PRIVATE_DELETE=310 SUB_GR_GAME_TOOLS_PRIVATE_DELETE value
     * @property {number} SUB_GR_TELEGRAM_GET_ACCOUNTS=400 SUB_GR_TELEGRAM_GET_ACCOUNTS value
     * @property {number} SUB_GR_TELEGRAM_GET_LIST=401 SUB_GR_TELEGRAM_GET_LIST value
     * @property {number} MDM_GR_TASKS=5 MDM_GR_TASKS value
     * @property {number} MDM_GR_CREATE_TASK=500 MDM_GR_CREATE_TASK value
     * @property {number} MDM_GR_CREATE_TASK_RESULT=501 MDM_GR_CREATE_TASK_RESULT value
     * @property {number} MDM_GR_SELECT_TASK=502 MDM_GR_SELECT_TASK value
     * @property {number} MDM_GR_SELECT_TASK_RESULT=503 MDM_GR_SELECT_TASK_RESULT value
     * @property {number} MDM_GR_DELETE_TASK=504 MDM_GR_DELETE_TASK value
     * @property {number} MDM_GR_DELETE_TASK_RESULT=505 MDM_GR_DELETE_TASK_RESULT value
     * @property {number} MDM_GR_EXECUTE_TASK=506 MDM_GR_EXECUTE_TASK value
     * @property {number} MDM_GR_EXECUTE_TASK_RESULT=507 MDM_GR_EXECUTE_TASK_RESULT value
     * @property {number} MDM_GR_SELECT_TASK_LOG=508 MDM_GR_SELECT_TASK_LOG value
     * @property {number} MDM_GR_SELECT_TASK_LOG_RESULT=509 MDM_GR_SELECT_TASK_LOG_RESULT value
     * @property {number} MDM_GR_SELECT_TASK_LOG_EVENT=510 MDM_GR_SELECT_TASK_LOG_EVENT value
     * @property {number} MDM_GR_SELECT_TASK_LOG_EVENT_RESULT=511 MDM_GR_SELECT_TASK_LOG_EVENT_RESULT value
     * @property {number} SUB_GR_GAME_TOOLS_LOAD_RESULT=999 SUB_GR_GAME_TOOLS_LOAD_RESULT value
     */
    tg.enCommand = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MDM_GR_TOOLS_NULL"] = 0;
        values[valuesById[1] = "MDM_GR_TOOLS_LOGIN"] = 1;
        values[valuesById[100] = "SUB_GR_GAME_TOOLS_LOGIN"] = 100;
        values[valuesById[101] = "SUB_GR_GAME_TOOLS_LOGIN_SUCCESS"] = 101;
        values[valuesById[200] = "SUB_GR_GAME_TOOLS_LOGIN_REG"] = 200;
        values[valuesById[201] = "SUB_GR_GAME_TOOLS_LOGIN_REG_SUCCESS"] = 201;
        values[valuesById[220] = "SUB_GR_GAME_TOOLS_LOGIN_CHECK"] = 220;
        values[valuesById[221] = "SUB_GR_GAME_TOOLS_LOGIN_CHECK_SUCCESS"] = 221;
        values[valuesById[400] = "SUB_GR_GAME_TOOLS_LOGIN_DELETE"] = 400;
        values[valuesById[401] = "SUB_GR_GAME_TOOLS_LOGIN_DELETE_SUCCESS"] = 401;
        values[valuesById[500] = "SUB_GR_GAME_TOOLS_LOGIN_REFRESH"] = 500;
        values[valuesById[501] = "SUB_GR_GAME_TOOLS_LOGIN_RESULT"] = 501;
        values[valuesById[600] = "SUB_GR_IM_SENDMESSAGE_UNLOCK"] = 600;
        values[valuesById[601] = "SUB_GR_IM_SENDMESSAGE_UNLOCK_RESULT"] = 601;
        values[valuesById[700] = "SUB_GR_IM_NET_PROXY_ADD"] = 700;
        values[valuesById[710] = "SUB_GR_IM_NET_PROXY_QUERY"] = 710;
        values[valuesById[711] = "SUB_GR_IM_NET_PROXY_LIST"] = 711;
        values[valuesById[720] = "SUB_GR_IM_NET_PROXY_DELETE"] = 720;
        values[valuesById[730] = "SUB_GR_IM_NET_PROXY_CHECK"] = 730;
        values[valuesById[740] = "SUB_GR_IM_NET_PROXY_USER_CHECK"] = 740;
        values[valuesById[741] = "SUB_GR_IM_NET_PROXY_USER_LIST"] = 741;
        values[valuesById[750] = "SUB_GR_IM_NET_PROXY_ALLOCATE"] = 750;
        values[valuesById[760] = "SUB_GR_IM_NET_PROXY_USER_UPDATE"] = 760;
        values[valuesById[2] = "MDM_GR_TOOLS_ACCOUNT"] = 2;
        values["SUB_GR_GAME_TOOLS_ACCOUNT_LIST"] = 200;
        values["SUB_GR_GAME_TOOLS_ACCOUNT_LIST_RESULT"] = 201;
        values[valuesById[210] = "SUB_GR_IM_TOOLS_ACCOUNT_LIST_ACK"] = 210;
        values[valuesById[211] = "SUB_GR_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT"] = 211;
        values[valuesById[300] = "SUB_GR_GAME_TOOLS_ACCOUNT_STATUS"] = 300;
        values[valuesById[3] = "MDM_GR_TOOLS_TELEGRAM"] = 3;
        values["SUB_GR_GAME_TOOLS_TELEGRAM_SEND"] = 200;
        values["SUB_GR_GAME_TOOLS_TELEGRAM_SEND_RESULT"] = 201;
        values["SUB_GR_GAME_TOOLS_TELEGRAM_RECV"] = 300;
        values[valuesById[301] = "SUB_GR_GAME_TOOLS_TELEGRAM_RECV_RESULT"] = 301;
        values[valuesById[302] = "SUB_GR_GAME_TOOLS_TELEGRAM_NEWMSG"] = 302;
        values[valuesById[310] = "SUB_GR_GAME_TOOLS_TELEGRAM_CUR_HISTORY"] = 310;
        values[valuesById[311] = "SUB_GR_GAME_TOOLS_TELEGRAM_HISTORY_RESULT"] = 311;
        values["SUB_GR_GAME_TOOLS_TELEGRAM_GET_CONTACTS"] = 400;
        values["SUB_GR_GAME_TOOLS_TELEGRAM_CONTACTS_LIST"] = 401;
        values[valuesById[402] = "SUB_GR_GAME_TOOLS_TELEGRAM_SEARCH"] = 402;
        values[valuesById[403] = "SUB_GR_GAME_TOOLS_TELEGRAM_SEARCH_RESULT"] = 403;
        values[valuesById[404] = "SUB_GR_GAME_TOOLS_TELEGRAM_ADDUSER"] = 404;
        values[valuesById[405] = "SUB_GR_GAME_TOOLS_TELEGRAM_DELUSER"] = 405;
        values[valuesById[406] = "SUB_GR_GAME_TOOLS_TELEGRAM_EDIT_USER"] = 406;
        values[valuesById[407] = "SUB_GR_GAME_TOOLS_JOIN_GROUP"] = 407;
        values[valuesById[408] = "SUB_GR_GAME_TOOLS_LEAVE_GROUP"] = 408;
        values[valuesById[4] = "MDM_GR_TOOLS_DATA_LOAD"] = 4;
        values["SUB_GR_GAME_TOOLS_ACCOUNT_LOAD"] = 200;
        values["SUB_GR_GAME_TOOLS_TELEGRAM_LOAD"] = 300;
        values["SUB_GR_GAME_TOOLS_PRIVATE_DELETE"] = 310;
        values["SUB_GR_TELEGRAM_GET_ACCOUNTS"] = 400;
        values["SUB_GR_TELEGRAM_GET_LIST"] = 401;
        values[valuesById[5] = "MDM_GR_TASKS"] = 5;
        values["MDM_GR_CREATE_TASK"] = 500;
        values["MDM_GR_CREATE_TASK_RESULT"] = 501;
        values[valuesById[502] = "MDM_GR_SELECT_TASK"] = 502;
        values[valuesById[503] = "MDM_GR_SELECT_TASK_RESULT"] = 503;
        values[valuesById[504] = "MDM_GR_DELETE_TASK"] = 504;
        values[valuesById[505] = "MDM_GR_DELETE_TASK_RESULT"] = 505;
        values[valuesById[506] = "MDM_GR_EXECUTE_TASK"] = 506;
        values[valuesById[507] = "MDM_GR_EXECUTE_TASK_RESULT"] = 507;
        values[valuesById[508] = "MDM_GR_SELECT_TASK_LOG"] = 508;
        values[valuesById[509] = "MDM_GR_SELECT_TASK_LOG_RESULT"] = 509;
        values[valuesById[510] = "MDM_GR_SELECT_TASK_LOG_EVENT"] = 510;
        values[valuesById[511] = "MDM_GR_SELECT_TASK_LOG_EVENT_RESULT"] = 511;
        values[valuesById[999] = "SUB_GR_GAME_TOOLS_LOAD_RESULT"] = 999;
        return values;
    })();

    tg.operation_result = (function() {

        /**
         * Properties of an operation_result.
         * @memberof tg
         * @interface Ioperation_result
         * @property {number|null} [code] operation_result code
         * @property {string|null} [msg] operation_result msg
         */

        /**
         * Constructs a new operation_result.
         * @memberof tg
         * @classdesc Represents an operation_result.
         * @implements Ioperation_result
         * @constructor
         * @param {tg.Ioperation_result=} [properties] Properties to set
         */
        function operation_result(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * operation_result code.
         * @member {number} code
         * @memberof tg.operation_result
         * @instance
         */
        operation_result.prototype.code = 0;

        /**
         * operation_result msg.
         * @member {string} msg
         * @memberof tg.operation_result
         * @instance
         */
        operation_result.prototype.msg = "";

        /**
         * Creates a new operation_result instance using the specified properties.
         * @function create
         * @memberof tg.operation_result
         * @static
         * @param {tg.Ioperation_result=} [properties] Properties to set
         * @returns {tg.operation_result} operation_result instance
         */
        operation_result.create = function create(properties) {
            return new operation_result(properties);
        };

        /**
         * Encodes the specified operation_result message. Does not implicitly {@link tg.operation_result.verify|verify} messages.
         * @function encode
         * @memberof tg.operation_result
         * @static
         * @param {tg.Ioperation_result} message operation_result message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        operation_result.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
            if (message.msg != null && Object.hasOwnProperty.call(message, "msg"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.msg);
            return writer;
        };

        /**
         * Encodes the specified operation_result message, length delimited. Does not implicitly {@link tg.operation_result.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.operation_result
         * @static
         * @param {tg.Ioperation_result} message operation_result message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        operation_result.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an operation_result message from the specified reader or buffer.
         * @function decode
         * @memberof tg.operation_result
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.operation_result} operation_result
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        operation_result.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.operation_result();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.code = reader.int32();
                        break;
                    }
                case 2: {
                        message.msg = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an operation_result message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.operation_result
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.operation_result} operation_result
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        operation_result.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an operation_result message.
         * @function verify
         * @memberof tg.operation_result
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        operation_result.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code))
                    return "code: integer expected";
            if (message.msg != null && message.hasOwnProperty("msg"))
                if (!$util.isString(message.msg))
                    return "msg: string expected";
            return null;
        };

        /**
         * Creates an operation_result message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.operation_result
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.operation_result} operation_result
         */
        operation_result.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.operation_result)
                return object;
            var message = new $root.tg.operation_result();
            if (object.code != null)
                message.code = object.code | 0;
            if (object.msg != null)
                message.msg = String(object.msg);
            return message;
        };

        /**
         * Creates a plain object from an operation_result message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.operation_result
         * @static
         * @param {tg.operation_result} message operation_result
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        operation_result.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.code = 0;
                object.msg = "";
            }
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.msg != null && message.hasOwnProperty("msg"))
                object.msg = message.msg;
            return object;
        };

        /**
         * Converts this operation_result to JSON.
         * @function toJSON
         * @memberof tg.operation_result
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        operation_result.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for operation_result
         * @function getTypeUrl
         * @memberof tg.operation_result
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        operation_result.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.operation_result";
        };

        return operation_result;
    })();

    tg.proxy_info = (function() {

        /**
         * Properties of a proxy_info.
         * @memberof tg
         * @interface Iproxy_info
         * @property {number|null} [index] proxy_info index
         * @property {number|null} [status] proxy_info status
         * @property {string|null} [message] proxy_info message
         * @property {number|null} [proxy_type] proxy_info proxy_type
         * @property {number|null} [port] proxy_info port
         * @property {string|null} [address] proxy_info address
         * @property {string|null} [username] proxy_info username
         * @property {string|null} [password] proxy_info password
         * @property {string|null} [secret_key] proxy_info secret_key
         */

        /**
         * Constructs a new proxy_info.
         * @memberof tg
         * @classdesc Represents a proxy_info.
         * @implements Iproxy_info
         * @constructor
         * @param {tg.Iproxy_info=} [properties] Properties to set
         */
        function proxy_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * proxy_info index.
         * @member {number} index
         * @memberof tg.proxy_info
         * @instance
         */
        proxy_info.prototype.index = 0;

        /**
         * proxy_info status.
         * @member {number} status
         * @memberof tg.proxy_info
         * @instance
         */
        proxy_info.prototype.status = 0;

        /**
         * proxy_info message.
         * @member {string} message
         * @memberof tg.proxy_info
         * @instance
         */
        proxy_info.prototype.message = "";

        /**
         * proxy_info proxy_type.
         * @member {number} proxy_type
         * @memberof tg.proxy_info
         * @instance
         */
        proxy_info.prototype.proxy_type = 0;

        /**
         * proxy_info port.
         * @member {number} port
         * @memberof tg.proxy_info
         * @instance
         */
        proxy_info.prototype.port = 0;

        /**
         * proxy_info address.
         * @member {string} address
         * @memberof tg.proxy_info
         * @instance
         */
        proxy_info.prototype.address = "";

        /**
         * proxy_info username.
         * @member {string} username
         * @memberof tg.proxy_info
         * @instance
         */
        proxy_info.prototype.username = "";

        /**
         * proxy_info password.
         * @member {string} password
         * @memberof tg.proxy_info
         * @instance
         */
        proxy_info.prototype.password = "";

        /**
         * proxy_info secret_key.
         * @member {string} secret_key
         * @memberof tg.proxy_info
         * @instance
         */
        proxy_info.prototype.secret_key = "";

        /**
         * Creates a new proxy_info instance using the specified properties.
         * @function create
         * @memberof tg.proxy_info
         * @static
         * @param {tg.Iproxy_info=} [properties] Properties to set
         * @returns {tg.proxy_info} proxy_info instance
         */
        proxy_info.create = function create(properties) {
            return new proxy_info(properties);
        };

        /**
         * Encodes the specified proxy_info message. Does not implicitly {@link tg.proxy_info.verify|verify} messages.
         * @function encode
         * @memberof tg.proxy_info
         * @static
         * @param {tg.Iproxy_info} message proxy_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        proxy_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.index);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            if (message.proxy_type != null && Object.hasOwnProperty.call(message, "proxy_type"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.proxy_type);
            if (message.port != null && Object.hasOwnProperty.call(message, "port"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.port);
            if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.address);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.username);
            if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.password);
            if (message.secret_key != null && Object.hasOwnProperty.call(message, "secret_key"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.secret_key);
            return writer;
        };

        /**
         * Encodes the specified proxy_info message, length delimited. Does not implicitly {@link tg.proxy_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.proxy_info
         * @static
         * @param {tg.Iproxy_info} message proxy_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        proxy_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a proxy_info message from the specified reader or buffer.
         * @function decode
         * @memberof tg.proxy_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.proxy_info} proxy_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        proxy_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.proxy_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.index = reader.int32();
                        break;
                    }
                case 2: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                case 4: {
                        message.proxy_type = reader.int32();
                        break;
                    }
                case 5: {
                        message.port = reader.int32();
                        break;
                    }
                case 6: {
                        message.address = reader.string();
                        break;
                    }
                case 7: {
                        message.username = reader.string();
                        break;
                    }
                case 8: {
                        message.password = reader.string();
                        break;
                    }
                case 9: {
                        message.secret_key = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a proxy_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.proxy_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.proxy_info} proxy_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        proxy_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a proxy_info message.
         * @function verify
         * @memberof tg.proxy_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        proxy_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.index != null && message.hasOwnProperty("index"))
                if (!$util.isInteger(message.index))
                    return "index: integer expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status))
                    return "status: integer expected";
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            if (message.proxy_type != null && message.hasOwnProperty("proxy_type"))
                if (!$util.isInteger(message.proxy_type))
                    return "proxy_type: integer expected";
            if (message.port != null && message.hasOwnProperty("port"))
                if (!$util.isInteger(message.port))
                    return "port: integer expected";
            if (message.address != null && message.hasOwnProperty("address"))
                if (!$util.isString(message.address))
                    return "address: string expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.password != null && message.hasOwnProperty("password"))
                if (!$util.isString(message.password))
                    return "password: string expected";
            if (message.secret_key != null && message.hasOwnProperty("secret_key"))
                if (!$util.isString(message.secret_key))
                    return "secret_key: string expected";
            return null;
        };

        /**
         * Creates a proxy_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.proxy_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.proxy_info} proxy_info
         */
        proxy_info.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.proxy_info)
                return object;
            var message = new $root.tg.proxy_info();
            if (object.index != null)
                message.index = object.index | 0;
            if (object.status != null)
                message.status = object.status | 0;
            if (object.message != null)
                message.message = String(object.message);
            if (object.proxy_type != null)
                message.proxy_type = object.proxy_type | 0;
            if (object.port != null)
                message.port = object.port | 0;
            if (object.address != null)
                message.address = String(object.address);
            if (object.username != null)
                message.username = String(object.username);
            if (object.password != null)
                message.password = String(object.password);
            if (object.secret_key != null)
                message.secret_key = String(object.secret_key);
            return message;
        };

        /**
         * Creates a plain object from a proxy_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.proxy_info
         * @static
         * @param {tg.proxy_info} message proxy_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        proxy_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.index = 0;
                object.status = 0;
                object.message = "";
                object.proxy_type = 0;
                object.port = 0;
                object.address = "";
                object.username = "";
                object.password = "";
                object.secret_key = "";
            }
            if (message.index != null && message.hasOwnProperty("index"))
                object.index = message.index;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            if (message.proxy_type != null && message.hasOwnProperty("proxy_type"))
                object.proxy_type = message.proxy_type;
            if (message.port != null && message.hasOwnProperty("port"))
                object.port = message.port;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.password != null && message.hasOwnProperty("password"))
                object.password = message.password;
            if (message.secret_key != null && message.hasOwnProperty("secret_key"))
                object.secret_key = message.secret_key;
            return object;
        };

        /**
         * Converts this proxy_info to JSON.
         * @function toJSON
         * @memberof tg.proxy_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        proxy_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for proxy_info
         * @function getTypeUrl
         * @memberof tg.proxy_info
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        proxy_info.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.proxy_info";
        };

        return proxy_info;
    })();

    tg.CMD_SC_GAME_TOOLS_LOGIN = (function() {

        /**
         * Properties of a CMD_SC_GAME_TOOLS_LOGIN.
         * @memberof tg
         * @interface ICMD_SC_GAME_TOOLS_LOGIN
         * @property {string|null} [account] CMD_SC_GAME_TOOLS_LOGIN account
         * @property {string|null} [password] CMD_SC_GAME_TOOLS_LOGIN password
         * @property {string|null} [token] CMD_SC_GAME_TOOLS_LOGIN token
         */

        /**
         * Constructs a new CMD_SC_GAME_TOOLS_LOGIN.
         * @memberof tg
         * @classdesc Represents a CMD_SC_GAME_TOOLS_LOGIN.
         * @implements ICMD_SC_GAME_TOOLS_LOGIN
         * @constructor
         * @param {tg.ICMD_SC_GAME_TOOLS_LOGIN=} [properties] Properties to set
         */
        function CMD_SC_GAME_TOOLS_LOGIN(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_SC_GAME_TOOLS_LOGIN account.
         * @member {string} account
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN
         * @instance
         */
        CMD_SC_GAME_TOOLS_LOGIN.prototype.account = "";

        /**
         * CMD_SC_GAME_TOOLS_LOGIN password.
         * @member {string} password
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN
         * @instance
         */
        CMD_SC_GAME_TOOLS_LOGIN.prototype.password = "";

        /**
         * CMD_SC_GAME_TOOLS_LOGIN token.
         * @member {string} token
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN
         * @instance
         */
        CMD_SC_GAME_TOOLS_LOGIN.prototype.token = "";

        /**
         * Creates a new CMD_SC_GAME_TOOLS_LOGIN instance using the specified properties.
         * @function create
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN
         * @static
         * @param {tg.ICMD_SC_GAME_TOOLS_LOGIN=} [properties] Properties to set
         * @returns {tg.CMD_SC_GAME_TOOLS_LOGIN} CMD_SC_GAME_TOOLS_LOGIN instance
         */
        CMD_SC_GAME_TOOLS_LOGIN.create = function create(properties) {
            return new CMD_SC_GAME_TOOLS_LOGIN(properties);
        };

        /**
         * Encodes the specified CMD_SC_GAME_TOOLS_LOGIN message. Does not implicitly {@link tg.CMD_SC_GAME_TOOLS_LOGIN.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN
         * @static
         * @param {tg.ICMD_SC_GAME_TOOLS_LOGIN} message CMD_SC_GAME_TOOLS_LOGIN message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_GAME_TOOLS_LOGIN.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.account);
            if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.password);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.token);
            return writer;
        };

        /**
         * Encodes the specified CMD_SC_GAME_TOOLS_LOGIN message, length delimited. Does not implicitly {@link tg.CMD_SC_GAME_TOOLS_LOGIN.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN
         * @static
         * @param {tg.ICMD_SC_GAME_TOOLS_LOGIN} message CMD_SC_GAME_TOOLS_LOGIN message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_GAME_TOOLS_LOGIN.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_SC_GAME_TOOLS_LOGIN message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_SC_GAME_TOOLS_LOGIN} CMD_SC_GAME_TOOLS_LOGIN
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_GAME_TOOLS_LOGIN.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_SC_GAME_TOOLS_LOGIN();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.account = reader.string();
                        break;
                    }
                case 2: {
                        message.password = reader.string();
                        break;
                    }
                case 3: {
                        message.token = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_SC_GAME_TOOLS_LOGIN message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_SC_GAME_TOOLS_LOGIN} CMD_SC_GAME_TOOLS_LOGIN
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_GAME_TOOLS_LOGIN.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_SC_GAME_TOOLS_LOGIN message.
         * @function verify
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_SC_GAME_TOOLS_LOGIN.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isString(message.account))
                    return "account: string expected";
            if (message.password != null && message.hasOwnProperty("password"))
                if (!$util.isString(message.password))
                    return "password: string expected";
            if (message.token != null && message.hasOwnProperty("token"))
                if (!$util.isString(message.token))
                    return "token: string expected";
            return null;
        };

        /**
         * Creates a CMD_SC_GAME_TOOLS_LOGIN message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_SC_GAME_TOOLS_LOGIN} CMD_SC_GAME_TOOLS_LOGIN
         */
        CMD_SC_GAME_TOOLS_LOGIN.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_SC_GAME_TOOLS_LOGIN)
                return object;
            var message = new $root.tg.CMD_SC_GAME_TOOLS_LOGIN();
            if (object.account != null)
                message.account = String(object.account);
            if (object.password != null)
                message.password = String(object.password);
            if (object.token != null)
                message.token = String(object.token);
            return message;
        };

        /**
         * Creates a plain object from a CMD_SC_GAME_TOOLS_LOGIN message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN
         * @static
         * @param {tg.CMD_SC_GAME_TOOLS_LOGIN} message CMD_SC_GAME_TOOLS_LOGIN
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_SC_GAME_TOOLS_LOGIN.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.account = "";
                object.password = "";
                object.token = "";
            }
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            if (message.password != null && message.hasOwnProperty("password"))
                object.password = message.password;
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = message.token;
            return object;
        };

        /**
         * Converts this CMD_SC_GAME_TOOLS_LOGIN to JSON.
         * @function toJSON
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_SC_GAME_TOOLS_LOGIN.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_SC_GAME_TOOLS_LOGIN
         * @function getTypeUrl
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_SC_GAME_TOOLS_LOGIN.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_SC_GAME_TOOLS_LOGIN";
        };

        return CMD_SC_GAME_TOOLS_LOGIN;
    })();

    tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE = (function() {

        /**
         * Properties of a CMD_SC_GAME_TOOLS_LOGIN_RESPONSE.
         * @memberof tg
         * @interface ICMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         * @property {string|null} [account] CMD_SC_GAME_TOOLS_LOGIN_RESPONSE account
         * @property {string|null} [session] CMD_SC_GAME_TOOLS_LOGIN_RESPONSE session
         * @property {string|null} [token] CMD_SC_GAME_TOOLS_LOGIN_RESPONSE token
         */

        /**
         * Constructs a new CMD_SC_GAME_TOOLS_LOGIN_RESPONSE.
         * @memberof tg
         * @classdesc Represents a CMD_SC_GAME_TOOLS_LOGIN_RESPONSE.
         * @implements ICMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         * @constructor
         * @param {tg.ICMD_SC_GAME_TOOLS_LOGIN_RESPONSE=} [properties] Properties to set
         */
        function CMD_SC_GAME_TOOLS_LOGIN_RESPONSE(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_SC_GAME_TOOLS_LOGIN_RESPONSE account.
         * @member {string} account
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         * @instance
         */
        CMD_SC_GAME_TOOLS_LOGIN_RESPONSE.prototype.account = "";

        /**
         * CMD_SC_GAME_TOOLS_LOGIN_RESPONSE session.
         * @member {string} session
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         * @instance
         */
        CMD_SC_GAME_TOOLS_LOGIN_RESPONSE.prototype.session = "";

        /**
         * CMD_SC_GAME_TOOLS_LOGIN_RESPONSE token.
         * @member {string} token
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         * @instance
         */
        CMD_SC_GAME_TOOLS_LOGIN_RESPONSE.prototype.token = "";

        /**
         * Creates a new CMD_SC_GAME_TOOLS_LOGIN_RESPONSE instance using the specified properties.
         * @function create
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         * @static
         * @param {tg.ICMD_SC_GAME_TOOLS_LOGIN_RESPONSE=} [properties] Properties to set
         * @returns {tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE} CMD_SC_GAME_TOOLS_LOGIN_RESPONSE instance
         */
        CMD_SC_GAME_TOOLS_LOGIN_RESPONSE.create = function create(properties) {
            return new CMD_SC_GAME_TOOLS_LOGIN_RESPONSE(properties);
        };

        /**
         * Encodes the specified CMD_SC_GAME_TOOLS_LOGIN_RESPONSE message. Does not implicitly {@link tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         * @static
         * @param {tg.ICMD_SC_GAME_TOOLS_LOGIN_RESPONSE} message CMD_SC_GAME_TOOLS_LOGIN_RESPONSE message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_GAME_TOOLS_LOGIN_RESPONSE.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.account);
            if (message.session != null && Object.hasOwnProperty.call(message, "session"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.session);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.token);
            return writer;
        };

        /**
         * Encodes the specified CMD_SC_GAME_TOOLS_LOGIN_RESPONSE message, length delimited. Does not implicitly {@link tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         * @static
         * @param {tg.ICMD_SC_GAME_TOOLS_LOGIN_RESPONSE} message CMD_SC_GAME_TOOLS_LOGIN_RESPONSE message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_GAME_TOOLS_LOGIN_RESPONSE.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_SC_GAME_TOOLS_LOGIN_RESPONSE message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE} CMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_GAME_TOOLS_LOGIN_RESPONSE.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.account = reader.string();
                        break;
                    }
                case 2: {
                        message.session = reader.string();
                        break;
                    }
                case 3: {
                        message.token = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_SC_GAME_TOOLS_LOGIN_RESPONSE message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE} CMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_GAME_TOOLS_LOGIN_RESPONSE.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_SC_GAME_TOOLS_LOGIN_RESPONSE message.
         * @function verify
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_SC_GAME_TOOLS_LOGIN_RESPONSE.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isString(message.account))
                    return "account: string expected";
            if (message.session != null && message.hasOwnProperty("session"))
                if (!$util.isString(message.session))
                    return "session: string expected";
            if (message.token != null && message.hasOwnProperty("token"))
                if (!$util.isString(message.token))
                    return "token: string expected";
            return null;
        };

        /**
         * Creates a CMD_SC_GAME_TOOLS_LOGIN_RESPONSE message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE} CMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         */
        CMD_SC_GAME_TOOLS_LOGIN_RESPONSE.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE)
                return object;
            var message = new $root.tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE();
            if (object.account != null)
                message.account = String(object.account);
            if (object.session != null)
                message.session = String(object.session);
            if (object.token != null)
                message.token = String(object.token);
            return message;
        };

        /**
         * Creates a plain object from a CMD_SC_GAME_TOOLS_LOGIN_RESPONSE message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         * @static
         * @param {tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE} message CMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_SC_GAME_TOOLS_LOGIN_RESPONSE.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.account = "";
                object.session = "";
                object.token = "";
            }
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            if (message.session != null && message.hasOwnProperty("session"))
                object.session = message.session;
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = message.token;
            return object;
        };

        /**
         * Converts this CMD_SC_GAME_TOOLS_LOGIN_RESPONSE to JSON.
         * @function toJSON
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_SC_GAME_TOOLS_LOGIN_RESPONSE.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         * @function getTypeUrl
         * @memberof tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_SC_GAME_TOOLS_LOGIN_RESPONSE.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE";
        };

        return CMD_SC_GAME_TOOLS_LOGIN_RESPONSE;
    })();

    tg.CMD_CS_GAME_TOOLS_LOGIN_REG = (function() {

        /**
         * Properties of a CMD_CS_GAME_TOOLS_LOGIN_REG.
         * @memberof tg
         * @interface ICMD_CS_GAME_TOOLS_LOGIN_REG
         * @property {string|null} [account] CMD_CS_GAME_TOOLS_LOGIN_REG account
         * @property {string|null} [phoneNum] CMD_CS_GAME_TOOLS_LOGIN_REG phoneNum
         */

        /**
         * Constructs a new CMD_CS_GAME_TOOLS_LOGIN_REG.
         * @memberof tg
         * @classdesc Represents a CMD_CS_GAME_TOOLS_LOGIN_REG.
         * @implements ICMD_CS_GAME_TOOLS_LOGIN_REG
         * @constructor
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_REG=} [properties] Properties to set
         */
        function CMD_CS_GAME_TOOLS_LOGIN_REG(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_GAME_TOOLS_LOGIN_REG account.
         * @member {string} account
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG
         * @instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG.prototype.account = "";

        /**
         * CMD_CS_GAME_TOOLS_LOGIN_REG phoneNum.
         * @member {string} phoneNum
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG
         * @instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG.prototype.phoneNum = "";

        /**
         * Creates a new CMD_CS_GAME_TOOLS_LOGIN_REG instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_REG=} [properties] Properties to set
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_REG} CMD_CS_GAME_TOOLS_LOGIN_REG instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG.create = function create(properties) {
            return new CMD_CS_GAME_TOOLS_LOGIN_REG(properties);
        };

        /**
         * Encodes the specified CMD_CS_GAME_TOOLS_LOGIN_REG message. Does not implicitly {@link tg.CMD_CS_GAME_TOOLS_LOGIN_REG.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_REG} message CMD_CS_GAME_TOOLS_LOGIN_REG message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.account);
            if (message.phoneNum != null && Object.hasOwnProperty.call(message, "phoneNum"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.phoneNum);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_GAME_TOOLS_LOGIN_REG message, length delimited. Does not implicitly {@link tg.CMD_CS_GAME_TOOLS_LOGIN_REG.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_REG} message CMD_CS_GAME_TOOLS_LOGIN_REG message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_GAME_TOOLS_LOGIN_REG message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_REG} CMD_CS_GAME_TOOLS_LOGIN_REG
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_GAME_TOOLS_LOGIN_REG();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.account = reader.string();
                        break;
                    }
                case 2: {
                        message.phoneNum = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_GAME_TOOLS_LOGIN_REG message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_REG} CMD_CS_GAME_TOOLS_LOGIN_REG
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_GAME_TOOLS_LOGIN_REG message.
         * @function verify
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isString(message.account))
                    return "account: string expected";
            if (message.phoneNum != null && message.hasOwnProperty("phoneNum"))
                if (!$util.isString(message.phoneNum))
                    return "phoneNum: string expected";
            return null;
        };

        /**
         * Creates a CMD_CS_GAME_TOOLS_LOGIN_REG message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_REG} CMD_CS_GAME_TOOLS_LOGIN_REG
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_GAME_TOOLS_LOGIN_REG)
                return object;
            var message = new $root.tg.CMD_CS_GAME_TOOLS_LOGIN_REG();
            if (object.account != null)
                message.account = String(object.account);
            if (object.phoneNum != null)
                message.phoneNum = String(object.phoneNum);
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_GAME_TOOLS_LOGIN_REG message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG
         * @static
         * @param {tg.CMD_CS_GAME_TOOLS_LOGIN_REG} message CMD_CS_GAME_TOOLS_LOGIN_REG
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.account = "";
                object.phoneNum = "";
            }
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            if (message.phoneNum != null && message.hasOwnProperty("phoneNum"))
                object.phoneNum = message.phoneNum;
            return object;
        };

        /**
         * Converts this CMD_CS_GAME_TOOLS_LOGIN_REG to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_GAME_TOOLS_LOGIN_REG
         * @function getTypeUrl
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_GAME_TOOLS_LOGIN_REG";
        };

        return CMD_CS_GAME_TOOLS_LOGIN_REG;
    })();

    tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT = (function() {

        /**
         * Properties of a CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT.
         * @memberof tg
         * @interface ICMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         * @property {string|null} [phoneNum] CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT phoneNum
         * @property {number|null} [nCode] CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT nCode
         * @property {string|null} [strResult] CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT strResult
         */

        /**
         * Constructs a new CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT.
         * @memberof tg
         * @classdesc Represents a CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT.
         * @implements ICMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         * @constructor
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_REG_RESULT=} [properties] Properties to set
         */
        function CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT phoneNum.
         * @member {string} phoneNum
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         * @instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT.prototype.phoneNum = "";

        /**
         * CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT nCode.
         * @member {number} nCode
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         * @instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT.prototype.nCode = 0;

        /**
         * CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT strResult.
         * @member {string} strResult
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         * @instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT.prototype.strResult = "";

        /**
         * Creates a new CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_REG_RESULT=} [properties] Properties to set
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT} CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT.create = function create(properties) {
            return new CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT(properties);
        };

        /**
         * Encodes the specified CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT message. Does not implicitly {@link tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_REG_RESULT} message CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.phoneNum != null && Object.hasOwnProperty.call(message, "phoneNum"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.phoneNum);
            if (message.nCode != null && Object.hasOwnProperty.call(message, "nCode"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nCode);
            if (message.strResult != null && Object.hasOwnProperty.call(message, "strResult"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.strResult);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT message, length delimited. Does not implicitly {@link tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_REG_RESULT} message CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT} CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.phoneNum = reader.string();
                        break;
                    }
                case 2: {
                        message.nCode = reader.int32();
                        break;
                    }
                case 3: {
                        message.strResult = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT} CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT message.
         * @function verify
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.phoneNum != null && message.hasOwnProperty("phoneNum"))
                if (!$util.isString(message.phoneNum))
                    return "phoneNum: string expected";
            if (message.nCode != null && message.hasOwnProperty("nCode"))
                if (!$util.isInteger(message.nCode))
                    return "nCode: integer expected";
            if (message.strResult != null && message.hasOwnProperty("strResult"))
                if (!$util.isString(message.strResult))
                    return "strResult: string expected";
            return null;
        };

        /**
         * Creates a CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT} CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT)
                return object;
            var message = new $root.tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT();
            if (object.phoneNum != null)
                message.phoneNum = String(object.phoneNum);
            if (object.nCode != null)
                message.nCode = object.nCode | 0;
            if (object.strResult != null)
                message.strResult = String(object.strResult);
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         * @static
         * @param {tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT} message CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.phoneNum = "";
                object.nCode = 0;
                object.strResult = "";
            }
            if (message.phoneNum != null && message.hasOwnProperty("phoneNum"))
                object.phoneNum = message.phoneNum;
            if (message.nCode != null && message.hasOwnProperty("nCode"))
                object.nCode = message.nCode;
            if (message.strResult != null && message.hasOwnProperty("strResult"))
                object.strResult = message.strResult;
            return object;
        };

        /**
         * Converts this CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         * @function getTypeUrl
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT";
        };

        return CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT;
    })();

    tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK = (function() {

        /**
         * Properties of a CMD_CS_GAME_TOOLS_LOGIN_CHECK.
         * @memberof tg
         * @interface ICMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @property {string|null} [account] CMD_CS_GAME_TOOLS_LOGIN_CHECK account
         * @property {string|null} [phoneNum] CMD_CS_GAME_TOOLS_LOGIN_CHECK phoneNum
         * @property {string|null} [password] CMD_CS_GAME_TOOLS_LOGIN_CHECK password
         * @property {string|null} [strCheck] CMD_CS_GAME_TOOLS_LOGIN_CHECK strCheck
         */

        /**
         * Constructs a new CMD_CS_GAME_TOOLS_LOGIN_CHECK.
         * @memberof tg
         * @classdesc Represents a CMD_CS_GAME_TOOLS_LOGIN_CHECK.
         * @implements ICMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @constructor
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_CHECK=} [properties] Properties to set
         */
        function CMD_CS_GAME_TOOLS_LOGIN_CHECK(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_GAME_TOOLS_LOGIN_CHECK account.
         * @member {string} account
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK.prototype.account = "";

        /**
         * CMD_CS_GAME_TOOLS_LOGIN_CHECK phoneNum.
         * @member {string} phoneNum
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK.prototype.phoneNum = "";

        /**
         * CMD_CS_GAME_TOOLS_LOGIN_CHECK password.
         * @member {string} password
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK.prototype.password = "";

        /**
         * CMD_CS_GAME_TOOLS_LOGIN_CHECK strCheck.
         * @member {string} strCheck
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK.prototype.strCheck = "";

        /**
         * Creates a new CMD_CS_GAME_TOOLS_LOGIN_CHECK instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_CHECK=} [properties] Properties to set
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK} CMD_CS_GAME_TOOLS_LOGIN_CHECK instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK.create = function create(properties) {
            return new CMD_CS_GAME_TOOLS_LOGIN_CHECK(properties);
        };

        /**
         * Encodes the specified CMD_CS_GAME_TOOLS_LOGIN_CHECK message. Does not implicitly {@link tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_CHECK} message CMD_CS_GAME_TOOLS_LOGIN_CHECK message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.account);
            if (message.phoneNum != null && Object.hasOwnProperty.call(message, "phoneNum"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.phoneNum);
            if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.password);
            if (message.strCheck != null && Object.hasOwnProperty.call(message, "strCheck"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.strCheck);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_GAME_TOOLS_LOGIN_CHECK message, length delimited. Does not implicitly {@link tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_CHECK} message CMD_CS_GAME_TOOLS_LOGIN_CHECK message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_GAME_TOOLS_LOGIN_CHECK message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK} CMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.account = reader.string();
                        break;
                    }
                case 2: {
                        message.phoneNum = reader.string();
                        break;
                    }
                case 3: {
                        message.password = reader.string();
                        break;
                    }
                case 4: {
                        message.strCheck = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_GAME_TOOLS_LOGIN_CHECK message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK} CMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_GAME_TOOLS_LOGIN_CHECK message.
         * @function verify
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isString(message.account))
                    return "account: string expected";
            if (message.phoneNum != null && message.hasOwnProperty("phoneNum"))
                if (!$util.isString(message.phoneNum))
                    return "phoneNum: string expected";
            if (message.password != null && message.hasOwnProperty("password"))
                if (!$util.isString(message.password))
                    return "password: string expected";
            if (message.strCheck != null && message.hasOwnProperty("strCheck"))
                if (!$util.isString(message.strCheck))
                    return "strCheck: string expected";
            return null;
        };

        /**
         * Creates a CMD_CS_GAME_TOOLS_LOGIN_CHECK message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK} CMD_CS_GAME_TOOLS_LOGIN_CHECK
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK)
                return object;
            var message = new $root.tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK();
            if (object.account != null)
                message.account = String(object.account);
            if (object.phoneNum != null)
                message.phoneNum = String(object.phoneNum);
            if (object.password != null)
                message.password = String(object.password);
            if (object.strCheck != null)
                message.strCheck = String(object.strCheck);
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_GAME_TOOLS_LOGIN_CHECK message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @static
         * @param {tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK} message CMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.account = "";
                object.phoneNum = "";
                object.password = "";
                object.strCheck = "";
            }
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            if (message.phoneNum != null && message.hasOwnProperty("phoneNum"))
                object.phoneNum = message.phoneNum;
            if (message.password != null && message.hasOwnProperty("password"))
                object.password = message.password;
            if (message.strCheck != null && message.hasOwnProperty("strCheck"))
                object.strCheck = message.strCheck;
            return object;
        };

        /**
         * Converts this CMD_CS_GAME_TOOLS_LOGIN_CHECK to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @function getTypeUrl
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK";
        };

        return CMD_CS_GAME_TOOLS_LOGIN_CHECK;
    })();

    tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT = (function() {

        /**
         * Properties of a CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT.
         * @memberof tg
         * @interface ICMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @property {string|null} [strAccount] CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT strAccount
         * @property {string|null} [strCheck] CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT strCheck
         * @property {number|null} [nCode] CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT nCode
         * @property {string|null} [strResult] CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT strResult
         */

        /**
         * Constructs a new CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT.
         * @memberof tg
         * @classdesc Represents a CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT.
         * @implements ICMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @constructor
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT=} [properties] Properties to set
         */
        function CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT strAccount.
         * @member {string} strAccount
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT.prototype.strAccount = "";

        /**
         * CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT strCheck.
         * @member {string} strCheck
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT.prototype.strCheck = "";

        /**
         * CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT nCode.
         * @member {number} nCode
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT.prototype.nCode = 0;

        /**
         * CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT strResult.
         * @member {string} strResult
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT.prototype.strResult = "";

        /**
         * Creates a new CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT=} [properties] Properties to set
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT} CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT.create = function create(properties) {
            return new CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT(properties);
        };

        /**
         * Encodes the specified CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT message. Does not implicitly {@link tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT} message CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.strAccount != null && Object.hasOwnProperty.call(message, "strAccount"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.strAccount);
            if (message.strCheck != null && Object.hasOwnProperty.call(message, "strCheck"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.strCheck);
            if (message.nCode != null && Object.hasOwnProperty.call(message, "nCode"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.nCode);
            if (message.strResult != null && Object.hasOwnProperty.call(message, "strResult"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.strResult);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT message, length delimited. Does not implicitly {@link tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT} message CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT} CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.strAccount = reader.string();
                        break;
                    }
                case 2: {
                        message.strCheck = reader.string();
                        break;
                    }
                case 3: {
                        message.nCode = reader.int32();
                        break;
                    }
                case 4: {
                        message.strResult = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT} CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT message.
         * @function verify
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.strAccount != null && message.hasOwnProperty("strAccount"))
                if (!$util.isString(message.strAccount))
                    return "strAccount: string expected";
            if (message.strCheck != null && message.hasOwnProperty("strCheck"))
                if (!$util.isString(message.strCheck))
                    return "strCheck: string expected";
            if (message.nCode != null && message.hasOwnProperty("nCode"))
                if (!$util.isInteger(message.nCode))
                    return "nCode: integer expected";
            if (message.strResult != null && message.hasOwnProperty("strResult"))
                if (!$util.isString(message.strResult))
                    return "strResult: string expected";
            return null;
        };

        /**
         * Creates a CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT} CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT)
                return object;
            var message = new $root.tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT();
            if (object.strAccount != null)
                message.strAccount = String(object.strAccount);
            if (object.strCheck != null)
                message.strCheck = String(object.strCheck);
            if (object.nCode != null)
                message.nCode = object.nCode | 0;
            if (object.strResult != null)
                message.strResult = String(object.strResult);
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @static
         * @param {tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT} message CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.strAccount = "";
                object.strCheck = "";
                object.nCode = 0;
                object.strResult = "";
            }
            if (message.strAccount != null && message.hasOwnProperty("strAccount"))
                object.strAccount = message.strAccount;
            if (message.strCheck != null && message.hasOwnProperty("strCheck"))
                object.strCheck = message.strCheck;
            if (message.nCode != null && message.hasOwnProperty("nCode"))
                object.nCode = message.nCode;
            if (message.strResult != null && message.hasOwnProperty("strResult"))
                object.strResult = message.strResult;
            return object;
        };

        /**
         * Converts this CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @function getTypeUrl
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT";
        };

        return CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT;
    })();

    tg.CMD_CS_IM_DELETE_ACCOUNT = (function() {

        /**
         * Properties of a CMD_CS_IM_DELETE_ACCOUNT.
         * @memberof tg
         * @interface ICMD_CS_IM_DELETE_ACCOUNT
         * @property {string|null} [account] CMD_CS_IM_DELETE_ACCOUNT account
         * @property {string|null} [phoneNum] CMD_CS_IM_DELETE_ACCOUNT phoneNum
         */

        /**
         * Constructs a new CMD_CS_IM_DELETE_ACCOUNT.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_DELETE_ACCOUNT.
         * @implements ICMD_CS_IM_DELETE_ACCOUNT
         * @constructor
         * @param {tg.ICMD_CS_IM_DELETE_ACCOUNT=} [properties] Properties to set
         */
        function CMD_CS_IM_DELETE_ACCOUNT(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_DELETE_ACCOUNT account.
         * @member {string} account
         * @memberof tg.CMD_CS_IM_DELETE_ACCOUNT
         * @instance
         */
        CMD_CS_IM_DELETE_ACCOUNT.prototype.account = "";

        /**
         * CMD_CS_IM_DELETE_ACCOUNT phoneNum.
         * @member {string} phoneNum
         * @memberof tg.CMD_CS_IM_DELETE_ACCOUNT
         * @instance
         */
        CMD_CS_IM_DELETE_ACCOUNT.prototype.phoneNum = "";

        /**
         * Creates a new CMD_CS_IM_DELETE_ACCOUNT instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_DELETE_ACCOUNT
         * @static
         * @param {tg.ICMD_CS_IM_DELETE_ACCOUNT=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_DELETE_ACCOUNT} CMD_CS_IM_DELETE_ACCOUNT instance
         */
        CMD_CS_IM_DELETE_ACCOUNT.create = function create(properties) {
            return new CMD_CS_IM_DELETE_ACCOUNT(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_DELETE_ACCOUNT message. Does not implicitly {@link tg.CMD_CS_IM_DELETE_ACCOUNT.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_DELETE_ACCOUNT
         * @static
         * @param {tg.ICMD_CS_IM_DELETE_ACCOUNT} message CMD_CS_IM_DELETE_ACCOUNT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_DELETE_ACCOUNT.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.account);
            if (message.phoneNum != null && Object.hasOwnProperty.call(message, "phoneNum"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.phoneNum);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_DELETE_ACCOUNT message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_DELETE_ACCOUNT.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_DELETE_ACCOUNT
         * @static
         * @param {tg.ICMD_CS_IM_DELETE_ACCOUNT} message CMD_CS_IM_DELETE_ACCOUNT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_DELETE_ACCOUNT.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_DELETE_ACCOUNT message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_DELETE_ACCOUNT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_DELETE_ACCOUNT} CMD_CS_IM_DELETE_ACCOUNT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_DELETE_ACCOUNT.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_DELETE_ACCOUNT();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.account = reader.string();
                        break;
                    }
                case 2: {
                        message.phoneNum = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_DELETE_ACCOUNT message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_DELETE_ACCOUNT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_DELETE_ACCOUNT} CMD_CS_IM_DELETE_ACCOUNT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_DELETE_ACCOUNT.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_DELETE_ACCOUNT message.
         * @function verify
         * @memberof tg.CMD_CS_IM_DELETE_ACCOUNT
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_DELETE_ACCOUNT.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isString(message.account))
                    return "account: string expected";
            if (message.phoneNum != null && message.hasOwnProperty("phoneNum"))
                if (!$util.isString(message.phoneNum))
                    return "phoneNum: string expected";
            return null;
        };

        /**
         * Creates a CMD_CS_IM_DELETE_ACCOUNT message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_DELETE_ACCOUNT
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_DELETE_ACCOUNT} CMD_CS_IM_DELETE_ACCOUNT
         */
        CMD_CS_IM_DELETE_ACCOUNT.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_DELETE_ACCOUNT)
                return object;
            var message = new $root.tg.CMD_CS_IM_DELETE_ACCOUNT();
            if (object.account != null)
                message.account = String(object.account);
            if (object.phoneNum != null)
                message.phoneNum = String(object.phoneNum);
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_DELETE_ACCOUNT message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_DELETE_ACCOUNT
         * @static
         * @param {tg.CMD_CS_IM_DELETE_ACCOUNT} message CMD_CS_IM_DELETE_ACCOUNT
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_DELETE_ACCOUNT.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.account = "";
                object.phoneNum = "";
            }
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            if (message.phoneNum != null && message.hasOwnProperty("phoneNum"))
                object.phoneNum = message.phoneNum;
            return object;
        };

        /**
         * Converts this CMD_CS_IM_DELETE_ACCOUNT to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_DELETE_ACCOUNT
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_DELETE_ACCOUNT.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_DELETE_ACCOUNT
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_DELETE_ACCOUNT
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_DELETE_ACCOUNT.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_DELETE_ACCOUNT";
        };

        return CMD_CS_IM_DELETE_ACCOUNT;
    })();

    tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT = (function() {

        /**
         * Properties of a CMD_SC_IM_DELETE_ACCOUNT_RESULT.
         * @memberof tg
         * @interface ICMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @property {string|null} [account] CMD_SC_IM_DELETE_ACCOUNT_RESULT account
         * @property {string|null} [phoneNum] CMD_SC_IM_DELETE_ACCOUNT_RESULT phoneNum
         * @property {number|null} [code] CMD_SC_IM_DELETE_ACCOUNT_RESULT code
         * @property {string|null} [reason] CMD_SC_IM_DELETE_ACCOUNT_RESULT reason
         */

        /**
         * Constructs a new CMD_SC_IM_DELETE_ACCOUNT_RESULT.
         * @memberof tg
         * @classdesc Represents a CMD_SC_IM_DELETE_ACCOUNT_RESULT.
         * @implements ICMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @constructor
         * @param {tg.ICMD_SC_IM_DELETE_ACCOUNT_RESULT=} [properties] Properties to set
         */
        function CMD_SC_IM_DELETE_ACCOUNT_RESULT(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_SC_IM_DELETE_ACCOUNT_RESULT account.
         * @member {string} account
         * @memberof tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @instance
         */
        CMD_SC_IM_DELETE_ACCOUNT_RESULT.prototype.account = "";

        /**
         * CMD_SC_IM_DELETE_ACCOUNT_RESULT phoneNum.
         * @member {string} phoneNum
         * @memberof tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @instance
         */
        CMD_SC_IM_DELETE_ACCOUNT_RESULT.prototype.phoneNum = "";

        /**
         * CMD_SC_IM_DELETE_ACCOUNT_RESULT code.
         * @member {number} code
         * @memberof tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @instance
         */
        CMD_SC_IM_DELETE_ACCOUNT_RESULT.prototype.code = 0;

        /**
         * CMD_SC_IM_DELETE_ACCOUNT_RESULT reason.
         * @member {string} reason
         * @memberof tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @instance
         */
        CMD_SC_IM_DELETE_ACCOUNT_RESULT.prototype.reason = "";

        /**
         * Creates a new CMD_SC_IM_DELETE_ACCOUNT_RESULT instance using the specified properties.
         * @function create
         * @memberof tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @static
         * @param {tg.ICMD_SC_IM_DELETE_ACCOUNT_RESULT=} [properties] Properties to set
         * @returns {tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT} CMD_SC_IM_DELETE_ACCOUNT_RESULT instance
         */
        CMD_SC_IM_DELETE_ACCOUNT_RESULT.create = function create(properties) {
            return new CMD_SC_IM_DELETE_ACCOUNT_RESULT(properties);
        };

        /**
         * Encodes the specified CMD_SC_IM_DELETE_ACCOUNT_RESULT message. Does not implicitly {@link tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @static
         * @param {tg.ICMD_SC_IM_DELETE_ACCOUNT_RESULT} message CMD_SC_IM_DELETE_ACCOUNT_RESULT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_IM_DELETE_ACCOUNT_RESULT.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.account);
            if (message.phoneNum != null && Object.hasOwnProperty.call(message, "phoneNum"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.phoneNum);
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.code);
            if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.reason);
            return writer;
        };

        /**
         * Encodes the specified CMD_SC_IM_DELETE_ACCOUNT_RESULT message, length delimited. Does not implicitly {@link tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @static
         * @param {tg.ICMD_SC_IM_DELETE_ACCOUNT_RESULT} message CMD_SC_IM_DELETE_ACCOUNT_RESULT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_IM_DELETE_ACCOUNT_RESULT.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_SC_IM_DELETE_ACCOUNT_RESULT message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT} CMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_IM_DELETE_ACCOUNT_RESULT.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.account = reader.string();
                        break;
                    }
                case 2: {
                        message.phoneNum = reader.string();
                        break;
                    }
                case 3: {
                        message.code = reader.int32();
                        break;
                    }
                case 4: {
                        message.reason = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_SC_IM_DELETE_ACCOUNT_RESULT message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT} CMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_IM_DELETE_ACCOUNT_RESULT.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_SC_IM_DELETE_ACCOUNT_RESULT message.
         * @function verify
         * @memberof tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_SC_IM_DELETE_ACCOUNT_RESULT.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isString(message.account))
                    return "account: string expected";
            if (message.phoneNum != null && message.hasOwnProperty("phoneNum"))
                if (!$util.isString(message.phoneNum))
                    return "phoneNum: string expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code))
                    return "code: integer expected";
            if (message.reason != null && message.hasOwnProperty("reason"))
                if (!$util.isString(message.reason))
                    return "reason: string expected";
            return null;
        };

        /**
         * Creates a CMD_SC_IM_DELETE_ACCOUNT_RESULT message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT} CMD_SC_IM_DELETE_ACCOUNT_RESULT
         */
        CMD_SC_IM_DELETE_ACCOUNT_RESULT.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT)
                return object;
            var message = new $root.tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT();
            if (object.account != null)
                message.account = String(object.account);
            if (object.phoneNum != null)
                message.phoneNum = String(object.phoneNum);
            if (object.code != null)
                message.code = object.code | 0;
            if (object.reason != null)
                message.reason = String(object.reason);
            return message;
        };

        /**
         * Creates a plain object from a CMD_SC_IM_DELETE_ACCOUNT_RESULT message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @static
         * @param {tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT} message CMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_SC_IM_DELETE_ACCOUNT_RESULT.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.account = "";
                object.phoneNum = "";
                object.code = 0;
                object.reason = "";
            }
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            if (message.phoneNum != null && message.hasOwnProperty("phoneNum"))
                object.phoneNum = message.phoneNum;
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.reason != null && message.hasOwnProperty("reason"))
                object.reason = message.reason;
            return object;
        };

        /**
         * Converts this CMD_SC_IM_DELETE_ACCOUNT_RESULT to JSON.
         * @function toJSON
         * @memberof tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_SC_IM_DELETE_ACCOUNT_RESULT.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @function getTypeUrl
         * @memberof tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_SC_IM_DELETE_ACCOUNT_RESULT.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT";
        };

        return CMD_SC_IM_DELETE_ACCOUNT_RESULT;
    })();

    tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH = (function() {

        /**
         * Properties of a CMD_CS_GAME_TOOLS_LOGIN_REFRESH.
         * @memberof tg
         * @interface ICMD_CS_GAME_TOOLS_LOGIN_REFRESH
         * @property {string|null} [account] CMD_CS_GAME_TOOLS_LOGIN_REFRESH account
         */

        /**
         * Constructs a new CMD_CS_GAME_TOOLS_LOGIN_REFRESH.
         * @memberof tg
         * @classdesc Represents a CMD_CS_GAME_TOOLS_LOGIN_REFRESH.
         * @implements ICMD_CS_GAME_TOOLS_LOGIN_REFRESH
         * @constructor
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_REFRESH=} [properties] Properties to set
         */
        function CMD_CS_GAME_TOOLS_LOGIN_REFRESH(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_GAME_TOOLS_LOGIN_REFRESH account.
         * @member {string} account
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH
         * @instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_REFRESH.prototype.account = "";

        /**
         * Creates a new CMD_CS_GAME_TOOLS_LOGIN_REFRESH instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_REFRESH=} [properties] Properties to set
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH} CMD_CS_GAME_TOOLS_LOGIN_REFRESH instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_REFRESH.create = function create(properties) {
            return new CMD_CS_GAME_TOOLS_LOGIN_REFRESH(properties);
        };

        /**
         * Encodes the specified CMD_CS_GAME_TOOLS_LOGIN_REFRESH message. Does not implicitly {@link tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_REFRESH} message CMD_CS_GAME_TOOLS_LOGIN_REFRESH message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_GAME_TOOLS_LOGIN_REFRESH.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.account);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_GAME_TOOLS_LOGIN_REFRESH message, length delimited. Does not implicitly {@link tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_REFRESH} message CMD_CS_GAME_TOOLS_LOGIN_REFRESH message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_GAME_TOOLS_LOGIN_REFRESH.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_GAME_TOOLS_LOGIN_REFRESH message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH} CMD_CS_GAME_TOOLS_LOGIN_REFRESH
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_GAME_TOOLS_LOGIN_REFRESH.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.account = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_GAME_TOOLS_LOGIN_REFRESH message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH} CMD_CS_GAME_TOOLS_LOGIN_REFRESH
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_GAME_TOOLS_LOGIN_REFRESH.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_GAME_TOOLS_LOGIN_REFRESH message.
         * @function verify
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_GAME_TOOLS_LOGIN_REFRESH.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isString(message.account))
                    return "account: string expected";
            return null;
        };

        /**
         * Creates a CMD_CS_GAME_TOOLS_LOGIN_REFRESH message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH} CMD_CS_GAME_TOOLS_LOGIN_REFRESH
         */
        CMD_CS_GAME_TOOLS_LOGIN_REFRESH.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH)
                return object;
            var message = new $root.tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH();
            if (object.account != null)
                message.account = String(object.account);
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_GAME_TOOLS_LOGIN_REFRESH message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH
         * @static
         * @param {tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH} message CMD_CS_GAME_TOOLS_LOGIN_REFRESH
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_GAME_TOOLS_LOGIN_REFRESH.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.account = "";
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            return object;
        };

        /**
         * Converts this CMD_CS_GAME_TOOLS_LOGIN_REFRESH to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_GAME_TOOLS_LOGIN_REFRESH.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_GAME_TOOLS_LOGIN_REFRESH
         * @function getTypeUrl
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_GAME_TOOLS_LOGIN_REFRESH.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_GAME_TOOLS_LOGIN_REFRESH";
        };

        return CMD_CS_GAME_TOOLS_LOGIN_REFRESH;
    })();

    tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT = (function() {

        /**
         * Properties of a CMD_CS_GAME_TOOLS_LOGIN_RESULT.
         * @memberof tg
         * @interface ICMD_CS_GAME_TOOLS_LOGIN_RESULT
         * @property {Array.<tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.IAccountInfo>|null} [list] CMD_CS_GAME_TOOLS_LOGIN_RESULT list
         */

        /**
         * Constructs a new CMD_CS_GAME_TOOLS_LOGIN_RESULT.
         * @memberof tg
         * @classdesc Represents a CMD_CS_GAME_TOOLS_LOGIN_RESULT.
         * @implements ICMD_CS_GAME_TOOLS_LOGIN_RESULT
         * @constructor
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_RESULT=} [properties] Properties to set
         */
        function CMD_CS_GAME_TOOLS_LOGIN_RESULT(properties) {
            this.list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_GAME_TOOLS_LOGIN_RESULT list.
         * @member {Array.<tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.IAccountInfo>} list
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT
         * @instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_RESULT.prototype.list = $util.emptyArray;

        /**
         * Creates a new CMD_CS_GAME_TOOLS_LOGIN_RESULT instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_RESULT=} [properties] Properties to set
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT} CMD_CS_GAME_TOOLS_LOGIN_RESULT instance
         */
        CMD_CS_GAME_TOOLS_LOGIN_RESULT.create = function create(properties) {
            return new CMD_CS_GAME_TOOLS_LOGIN_RESULT(properties);
        };

        /**
         * Encodes the specified CMD_CS_GAME_TOOLS_LOGIN_RESULT message. Does not implicitly {@link tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_RESULT} message CMD_CS_GAME_TOOLS_LOGIN_RESULT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_GAME_TOOLS_LOGIN_RESULT.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.list != null && message.list.length)
                for (var i = 0; i < message.list.length; ++i)
                    $root.tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_GAME_TOOLS_LOGIN_RESULT message, length delimited. Does not implicitly {@link tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_LOGIN_RESULT} message CMD_CS_GAME_TOOLS_LOGIN_RESULT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_GAME_TOOLS_LOGIN_RESULT.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_GAME_TOOLS_LOGIN_RESULT message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT} CMD_CS_GAME_TOOLS_LOGIN_RESULT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_GAME_TOOLS_LOGIN_RESULT.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_GAME_TOOLS_LOGIN_RESULT message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT} CMD_CS_GAME_TOOLS_LOGIN_RESULT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_GAME_TOOLS_LOGIN_RESULT.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_GAME_TOOLS_LOGIN_RESULT message.
         * @function verify
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_GAME_TOOLS_LOGIN_RESULT.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.list != null && message.hasOwnProperty("list")) {
                if (!Array.isArray(message.list))
                    return "list: array expected";
                for (var i = 0; i < message.list.length; ++i) {
                    var error = $root.tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo.verify(message.list[i]);
                    if (error)
                        return "list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CMD_CS_GAME_TOOLS_LOGIN_RESULT message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT} CMD_CS_GAME_TOOLS_LOGIN_RESULT
         */
        CMD_CS_GAME_TOOLS_LOGIN_RESULT.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT)
                return object;
            var message = new $root.tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT();
            if (object.list) {
                if (!Array.isArray(object.list))
                    throw TypeError(".tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.list: array expected");
                message.list = [];
                for (var i = 0; i < object.list.length; ++i) {
                    if (typeof object.list[i] !== "object")
                        throw TypeError(".tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.list: object expected");
                    message.list[i] = $root.tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo.fromObject(object.list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_GAME_TOOLS_LOGIN_RESULT message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT
         * @static
         * @param {tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT} message CMD_CS_GAME_TOOLS_LOGIN_RESULT
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_GAME_TOOLS_LOGIN_RESULT.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.list = [];
            if (message.list && message.list.length) {
                object.list = [];
                for (var j = 0; j < message.list.length; ++j)
                    object.list[j] = $root.tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo.toObject(message.list[j], options);
            }
            return object;
        };

        /**
         * Converts this CMD_CS_GAME_TOOLS_LOGIN_RESULT to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_GAME_TOOLS_LOGIN_RESULT.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_GAME_TOOLS_LOGIN_RESULT
         * @function getTypeUrl
         * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_GAME_TOOLS_LOGIN_RESULT.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT";
        };

        CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo = (function() {

            /**
             * Properties of an AccountInfo.
             * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT
             * @interface IAccountInfo
             * @property {string|null} [account] AccountInfo account
             * @property {number|null} [status] AccountInfo status
             */

            /**
             * Constructs a new AccountInfo.
             * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT
             * @classdesc Represents an AccountInfo.
             * @implements IAccountInfo
             * @constructor
             * @param {tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.IAccountInfo=} [properties] Properties to set
             */
            function AccountInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AccountInfo account.
             * @member {string} account
             * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo
             * @instance
             */
            AccountInfo.prototype.account = "";

            /**
             * AccountInfo status.
             * @member {number} status
             * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo
             * @instance
             */
            AccountInfo.prototype.status = 0;

            /**
             * Creates a new AccountInfo instance using the specified properties.
             * @function create
             * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo
             * @static
             * @param {tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.IAccountInfo=} [properties] Properties to set
             * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo} AccountInfo instance
             */
            AccountInfo.create = function create(properties) {
                return new AccountInfo(properties);
            };

            /**
             * Encodes the specified AccountInfo message. Does not implicitly {@link tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo.verify|verify} messages.
             * @function encode
             * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo
             * @static
             * @param {tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.IAccountInfo} message AccountInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AccountInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.account);
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
                return writer;
            };

            /**
             * Encodes the specified AccountInfo message, length delimited. Does not implicitly {@link tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo
             * @static
             * @param {tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.IAccountInfo} message AccountInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AccountInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AccountInfo message from the specified reader or buffer.
             * @function decode
             * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo} AccountInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AccountInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.account = reader.string();
                            break;
                        }
                    case 2: {
                            message.status = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AccountInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo} AccountInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AccountInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AccountInfo message.
             * @function verify
             * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AccountInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.account != null && message.hasOwnProperty("account"))
                    if (!$util.isString(message.account))
                        return "account: string expected";
                if (message.status != null && message.hasOwnProperty("status"))
                    if (!$util.isInteger(message.status))
                        return "status: integer expected";
                return null;
            };

            /**
             * Creates an AccountInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo} AccountInfo
             */
            AccountInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo)
                    return object;
                var message = new $root.tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo();
                if (object.account != null)
                    message.account = String(object.account);
                if (object.status != null)
                    message.status = object.status | 0;
                return message;
            };

            /**
             * Creates a plain object from an AccountInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo
             * @static
             * @param {tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo} message AccountInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AccountInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.account = "";
                    object.status = 0;
                }
                if (message.account != null && message.hasOwnProperty("account"))
                    object.account = message.account;
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = message.status;
                return object;
            };

            /**
             * Converts this AccountInfo to JSON.
             * @function toJSON
             * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AccountInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for AccountInfo
             * @function getTypeUrl
             * @memberof tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            AccountInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tg.CMD_CS_GAME_TOOLS_LOGIN_RESULT.AccountInfo";
            };

            return AccountInfo;
        })();

        return CMD_CS_GAME_TOOLS_LOGIN_RESULT;
    })();

    tg.CMD_CS_IM_SENDMESSAGE_UNLOCK = (function() {

        /**
         * Properties of a CMD_CS_IM_SENDMESSAGE_UNLOCK.
         * @memberof tg
         * @interface ICMD_CS_IM_SENDMESSAGE_UNLOCK
         * @property {string|null} [admin] CMD_CS_IM_SENDMESSAGE_UNLOCK admin
         * @property {string|null} [phone] CMD_CS_IM_SENDMESSAGE_UNLOCK phone
         * @property {string|null} [msg] CMD_CS_IM_SENDMESSAGE_UNLOCK msg
         */

        /**
         * Constructs a new CMD_CS_IM_SENDMESSAGE_UNLOCK.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_SENDMESSAGE_UNLOCK.
         * @implements ICMD_CS_IM_SENDMESSAGE_UNLOCK
         * @constructor
         * @param {tg.ICMD_CS_IM_SENDMESSAGE_UNLOCK=} [properties] Properties to set
         */
        function CMD_CS_IM_SENDMESSAGE_UNLOCK(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_SENDMESSAGE_UNLOCK admin.
         * @member {string} admin
         * @memberof tg.CMD_CS_IM_SENDMESSAGE_UNLOCK
         * @instance
         */
        CMD_CS_IM_SENDMESSAGE_UNLOCK.prototype.admin = "";

        /**
         * CMD_CS_IM_SENDMESSAGE_UNLOCK phone.
         * @member {string} phone
         * @memberof tg.CMD_CS_IM_SENDMESSAGE_UNLOCK
         * @instance
         */
        CMD_CS_IM_SENDMESSAGE_UNLOCK.prototype.phone = "";

        /**
         * CMD_CS_IM_SENDMESSAGE_UNLOCK msg.
         * @member {string} msg
         * @memberof tg.CMD_CS_IM_SENDMESSAGE_UNLOCK
         * @instance
         */
        CMD_CS_IM_SENDMESSAGE_UNLOCK.prototype.msg = "";

        /**
         * Creates a new CMD_CS_IM_SENDMESSAGE_UNLOCK instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_SENDMESSAGE_UNLOCK
         * @static
         * @param {tg.ICMD_CS_IM_SENDMESSAGE_UNLOCK=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_SENDMESSAGE_UNLOCK} CMD_CS_IM_SENDMESSAGE_UNLOCK instance
         */
        CMD_CS_IM_SENDMESSAGE_UNLOCK.create = function create(properties) {
            return new CMD_CS_IM_SENDMESSAGE_UNLOCK(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_SENDMESSAGE_UNLOCK message. Does not implicitly {@link tg.CMD_CS_IM_SENDMESSAGE_UNLOCK.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_SENDMESSAGE_UNLOCK
         * @static
         * @param {tg.ICMD_CS_IM_SENDMESSAGE_UNLOCK} message CMD_CS_IM_SENDMESSAGE_UNLOCK message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_SENDMESSAGE_UNLOCK.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.admin != null && Object.hasOwnProperty.call(message, "admin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.admin);
            if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.phone);
            if (message.msg != null && Object.hasOwnProperty.call(message, "msg"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.msg);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_SENDMESSAGE_UNLOCK message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_SENDMESSAGE_UNLOCK.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_SENDMESSAGE_UNLOCK
         * @static
         * @param {tg.ICMD_CS_IM_SENDMESSAGE_UNLOCK} message CMD_CS_IM_SENDMESSAGE_UNLOCK message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_SENDMESSAGE_UNLOCK.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_SENDMESSAGE_UNLOCK message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_SENDMESSAGE_UNLOCK
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_SENDMESSAGE_UNLOCK} CMD_CS_IM_SENDMESSAGE_UNLOCK
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_SENDMESSAGE_UNLOCK.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_SENDMESSAGE_UNLOCK();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.admin = reader.string();
                        break;
                    }
                case 2: {
                        message.phone = reader.string();
                        break;
                    }
                case 3: {
                        message.msg = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_SENDMESSAGE_UNLOCK message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_SENDMESSAGE_UNLOCK
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_SENDMESSAGE_UNLOCK} CMD_CS_IM_SENDMESSAGE_UNLOCK
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_SENDMESSAGE_UNLOCK.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_SENDMESSAGE_UNLOCK message.
         * @function verify
         * @memberof tg.CMD_CS_IM_SENDMESSAGE_UNLOCK
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_SENDMESSAGE_UNLOCK.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.admin != null && message.hasOwnProperty("admin"))
                if (!$util.isString(message.admin))
                    return "admin: string expected";
            if (message.phone != null && message.hasOwnProperty("phone"))
                if (!$util.isString(message.phone))
                    return "phone: string expected";
            if (message.msg != null && message.hasOwnProperty("msg"))
                if (!$util.isString(message.msg))
                    return "msg: string expected";
            return null;
        };

        /**
         * Creates a CMD_CS_IM_SENDMESSAGE_UNLOCK message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_SENDMESSAGE_UNLOCK
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_SENDMESSAGE_UNLOCK} CMD_CS_IM_SENDMESSAGE_UNLOCK
         */
        CMD_CS_IM_SENDMESSAGE_UNLOCK.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_SENDMESSAGE_UNLOCK)
                return object;
            var message = new $root.tg.CMD_CS_IM_SENDMESSAGE_UNLOCK();
            if (object.admin != null)
                message.admin = String(object.admin);
            if (object.phone != null)
                message.phone = String(object.phone);
            if (object.msg != null)
                message.msg = String(object.msg);
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_SENDMESSAGE_UNLOCK message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_SENDMESSAGE_UNLOCK
         * @static
         * @param {tg.CMD_CS_IM_SENDMESSAGE_UNLOCK} message CMD_CS_IM_SENDMESSAGE_UNLOCK
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_SENDMESSAGE_UNLOCK.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.admin = "";
                object.phone = "";
                object.msg = "";
            }
            if (message.admin != null && message.hasOwnProperty("admin"))
                object.admin = message.admin;
            if (message.phone != null && message.hasOwnProperty("phone"))
                object.phone = message.phone;
            if (message.msg != null && message.hasOwnProperty("msg"))
                object.msg = message.msg;
            return object;
        };

        /**
         * Converts this CMD_CS_IM_SENDMESSAGE_UNLOCK to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_SENDMESSAGE_UNLOCK
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_SENDMESSAGE_UNLOCK.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_SENDMESSAGE_UNLOCK
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_SENDMESSAGE_UNLOCK
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_SENDMESSAGE_UNLOCK.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_SENDMESSAGE_UNLOCK";
        };

        return CMD_CS_IM_SENDMESSAGE_UNLOCK;
    })();

    tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT = (function() {

        /**
         * Properties of a CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT.
         * @memberof tg
         * @interface ICMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         * @property {string|null} [phone] CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT phone
         * @property {number|null} [code] CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT code
         * @property {string|null} [reason] CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT reason
         */

        /**
         * Constructs a new CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT.
         * @memberof tg
         * @classdesc Represents a CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT.
         * @implements ICMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         * @constructor
         * @param {tg.ICMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT=} [properties] Properties to set
         */
        function CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT phone.
         * @member {string} phone
         * @memberof tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         * @instance
         */
        CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT.prototype.phone = "";

        /**
         * CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT code.
         * @member {number} code
         * @memberof tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         * @instance
         */
        CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT.prototype.code = 0;

        /**
         * CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT reason.
         * @member {string} reason
         * @memberof tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         * @instance
         */
        CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT.prototype.reason = "";

        /**
         * Creates a new CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT instance using the specified properties.
         * @function create
         * @memberof tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         * @static
         * @param {tg.ICMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT=} [properties] Properties to set
         * @returns {tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT} CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT instance
         */
        CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT.create = function create(properties) {
            return new CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT(properties);
        };

        /**
         * Encodes the specified CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT message. Does not implicitly {@link tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         * @static
         * @param {tg.ICMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT} message CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.phone);
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.code);
            if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.reason);
            return writer;
        };

        /**
         * Encodes the specified CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT message, length delimited. Does not implicitly {@link tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         * @static
         * @param {tg.ICMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT} message CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT} CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.phone = reader.string();
                        break;
                    }
                case 2: {
                        message.code = reader.int32();
                        break;
                    }
                case 3: {
                        message.reason = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT} CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT message.
         * @function verify
         * @memberof tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.phone != null && message.hasOwnProperty("phone"))
                if (!$util.isString(message.phone))
                    return "phone: string expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code))
                    return "code: integer expected";
            if (message.reason != null && message.hasOwnProperty("reason"))
                if (!$util.isString(message.reason))
                    return "reason: string expected";
            return null;
        };

        /**
         * Creates a CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT} CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         */
        CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT)
                return object;
            var message = new $root.tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT();
            if (object.phone != null)
                message.phone = String(object.phone);
            if (object.code != null)
                message.code = object.code | 0;
            if (object.reason != null)
                message.reason = String(object.reason);
            return message;
        };

        /**
         * Creates a plain object from a CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         * @static
         * @param {tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT} message CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.phone = "";
                object.code = 0;
                object.reason = "";
            }
            if (message.phone != null && message.hasOwnProperty("phone"))
                object.phone = message.phone;
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.reason != null && message.hasOwnProperty("reason"))
                object.reason = message.reason;
            return object;
        };

        /**
         * Converts this CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT to JSON.
         * @function toJSON
         * @memberof tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         * @function getTypeUrl
         * @memberof tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT";
        };

        return CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT;
    })();

    tg.CMD_CS_IM_NET_PROXY_ADD = (function() {

        /**
         * Properties of a CMD_CS_IM_NET_PROXY_ADD.
         * @memberof tg
         * @interface ICMD_CS_IM_NET_PROXY_ADD
         * @property {tg.Iproxy_info|null} [data] CMD_CS_IM_NET_PROXY_ADD data
         */

        /**
         * Constructs a new CMD_CS_IM_NET_PROXY_ADD.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_NET_PROXY_ADD.
         * @implements ICMD_CS_IM_NET_PROXY_ADD
         * @constructor
         * @param {tg.ICMD_CS_IM_NET_PROXY_ADD=} [properties] Properties to set
         */
        function CMD_CS_IM_NET_PROXY_ADD(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_NET_PROXY_ADD data.
         * @member {tg.Iproxy_info|null|undefined} data
         * @memberof tg.CMD_CS_IM_NET_PROXY_ADD
         * @instance
         */
        CMD_CS_IM_NET_PROXY_ADD.prototype.data = null;

        /**
         * Creates a new CMD_CS_IM_NET_PROXY_ADD instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_NET_PROXY_ADD
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_ADD=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_NET_PROXY_ADD} CMD_CS_IM_NET_PROXY_ADD instance
         */
        CMD_CS_IM_NET_PROXY_ADD.create = function create(properties) {
            return new CMD_CS_IM_NET_PROXY_ADD(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_NET_PROXY_ADD message. Does not implicitly {@link tg.CMD_CS_IM_NET_PROXY_ADD.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_NET_PROXY_ADD
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_ADD} message CMD_CS_IM_NET_PROXY_ADD message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_NET_PROXY_ADD.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                $root.tg.proxy_info.encode(message.data, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_NET_PROXY_ADD message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_NET_PROXY_ADD.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_NET_PROXY_ADD
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_ADD} message CMD_CS_IM_NET_PROXY_ADD message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_NET_PROXY_ADD.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_NET_PROXY_ADD message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_NET_PROXY_ADD
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_NET_PROXY_ADD} CMD_CS_IM_NET_PROXY_ADD
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_NET_PROXY_ADD.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_NET_PROXY_ADD();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.data = $root.tg.proxy_info.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_NET_PROXY_ADD message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_NET_PROXY_ADD
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_NET_PROXY_ADD} CMD_CS_IM_NET_PROXY_ADD
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_NET_PROXY_ADD.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_NET_PROXY_ADD message.
         * @function verify
         * @memberof tg.CMD_CS_IM_NET_PROXY_ADD
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_NET_PROXY_ADD.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.data != null && message.hasOwnProperty("data")) {
                var error = $root.tg.proxy_info.verify(message.data);
                if (error)
                    return "data." + error;
            }
            return null;
        };

        /**
         * Creates a CMD_CS_IM_NET_PROXY_ADD message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_NET_PROXY_ADD
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_NET_PROXY_ADD} CMD_CS_IM_NET_PROXY_ADD
         */
        CMD_CS_IM_NET_PROXY_ADD.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_NET_PROXY_ADD)
                return object;
            var message = new $root.tg.CMD_CS_IM_NET_PROXY_ADD();
            if (object.data != null) {
                if (typeof object.data !== "object")
                    throw TypeError(".tg.CMD_CS_IM_NET_PROXY_ADD.data: object expected");
                message.data = $root.tg.proxy_info.fromObject(object.data);
            }
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_NET_PROXY_ADD message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_NET_PROXY_ADD
         * @static
         * @param {tg.CMD_CS_IM_NET_PROXY_ADD} message CMD_CS_IM_NET_PROXY_ADD
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_NET_PROXY_ADD.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.data = null;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = $root.tg.proxy_info.toObject(message.data, options);
            return object;
        };

        /**
         * Converts this CMD_CS_IM_NET_PROXY_ADD to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_NET_PROXY_ADD
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_NET_PROXY_ADD.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_NET_PROXY_ADD
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_NET_PROXY_ADD
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_NET_PROXY_ADD.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_NET_PROXY_ADD";
        };

        return CMD_CS_IM_NET_PROXY_ADD;
    })();

    tg.CMD_CS_IM_NET_PROXY_QUERY = (function() {

        /**
         * Properties of a CMD_CS_IM_NET_PROXY_QUERY.
         * @memberof tg
         * @interface ICMD_CS_IM_NET_PROXY_QUERY
         * @property {string|null} [admin] CMD_CS_IM_NET_PROXY_QUERY admin
         */

        /**
         * Constructs a new CMD_CS_IM_NET_PROXY_QUERY.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_NET_PROXY_QUERY.
         * @implements ICMD_CS_IM_NET_PROXY_QUERY
         * @constructor
         * @param {tg.ICMD_CS_IM_NET_PROXY_QUERY=} [properties] Properties to set
         */
        function CMD_CS_IM_NET_PROXY_QUERY(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_NET_PROXY_QUERY admin.
         * @member {string} admin
         * @memberof tg.CMD_CS_IM_NET_PROXY_QUERY
         * @instance
         */
        CMD_CS_IM_NET_PROXY_QUERY.prototype.admin = "";

        /**
         * Creates a new CMD_CS_IM_NET_PROXY_QUERY instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_NET_PROXY_QUERY
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_QUERY=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_NET_PROXY_QUERY} CMD_CS_IM_NET_PROXY_QUERY instance
         */
        CMD_CS_IM_NET_PROXY_QUERY.create = function create(properties) {
            return new CMD_CS_IM_NET_PROXY_QUERY(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_NET_PROXY_QUERY message. Does not implicitly {@link tg.CMD_CS_IM_NET_PROXY_QUERY.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_NET_PROXY_QUERY
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_QUERY} message CMD_CS_IM_NET_PROXY_QUERY message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_NET_PROXY_QUERY.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.admin != null && Object.hasOwnProperty.call(message, "admin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.admin);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_NET_PROXY_QUERY message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_NET_PROXY_QUERY.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_NET_PROXY_QUERY
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_QUERY} message CMD_CS_IM_NET_PROXY_QUERY message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_NET_PROXY_QUERY.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_NET_PROXY_QUERY message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_NET_PROXY_QUERY
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_NET_PROXY_QUERY} CMD_CS_IM_NET_PROXY_QUERY
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_NET_PROXY_QUERY.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_NET_PROXY_QUERY();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.admin = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_NET_PROXY_QUERY message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_NET_PROXY_QUERY
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_NET_PROXY_QUERY} CMD_CS_IM_NET_PROXY_QUERY
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_NET_PROXY_QUERY.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_NET_PROXY_QUERY message.
         * @function verify
         * @memberof tg.CMD_CS_IM_NET_PROXY_QUERY
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_NET_PROXY_QUERY.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.admin != null && message.hasOwnProperty("admin"))
                if (!$util.isString(message.admin))
                    return "admin: string expected";
            return null;
        };

        /**
         * Creates a CMD_CS_IM_NET_PROXY_QUERY message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_NET_PROXY_QUERY
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_NET_PROXY_QUERY} CMD_CS_IM_NET_PROXY_QUERY
         */
        CMD_CS_IM_NET_PROXY_QUERY.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_NET_PROXY_QUERY)
                return object;
            var message = new $root.tg.CMD_CS_IM_NET_PROXY_QUERY();
            if (object.admin != null)
                message.admin = String(object.admin);
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_NET_PROXY_QUERY message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_NET_PROXY_QUERY
         * @static
         * @param {tg.CMD_CS_IM_NET_PROXY_QUERY} message CMD_CS_IM_NET_PROXY_QUERY
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_NET_PROXY_QUERY.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.admin = "";
            if (message.admin != null && message.hasOwnProperty("admin"))
                object.admin = message.admin;
            return object;
        };

        /**
         * Converts this CMD_CS_IM_NET_PROXY_QUERY to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_NET_PROXY_QUERY
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_NET_PROXY_QUERY.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_NET_PROXY_QUERY
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_NET_PROXY_QUERY
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_NET_PROXY_QUERY.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_NET_PROXY_QUERY";
        };

        return CMD_CS_IM_NET_PROXY_QUERY;
    })();

    tg.CMD_SC_IM_NET_PROXY_LIST = (function() {

        /**
         * Properties of a CMD_SC_IM_NET_PROXY_LIST.
         * @memberof tg
         * @interface ICMD_SC_IM_NET_PROXY_LIST
         * @property {number|null} [code] CMD_SC_IM_NET_PROXY_LIST code
         * @property {string|null} [msg] CMD_SC_IM_NET_PROXY_LIST msg
         * @property {Array.<tg.Iproxy_info>|null} [list] CMD_SC_IM_NET_PROXY_LIST list
         */

        /**
         * Constructs a new CMD_SC_IM_NET_PROXY_LIST.
         * @memberof tg
         * @classdesc Represents a CMD_SC_IM_NET_PROXY_LIST.
         * @implements ICMD_SC_IM_NET_PROXY_LIST
         * @constructor
         * @param {tg.ICMD_SC_IM_NET_PROXY_LIST=} [properties] Properties to set
         */
        function CMD_SC_IM_NET_PROXY_LIST(properties) {
            this.list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_SC_IM_NET_PROXY_LIST code.
         * @member {number} code
         * @memberof tg.CMD_SC_IM_NET_PROXY_LIST
         * @instance
         */
        CMD_SC_IM_NET_PROXY_LIST.prototype.code = 0;

        /**
         * CMD_SC_IM_NET_PROXY_LIST msg.
         * @member {string} msg
         * @memberof tg.CMD_SC_IM_NET_PROXY_LIST
         * @instance
         */
        CMD_SC_IM_NET_PROXY_LIST.prototype.msg = "";

        /**
         * CMD_SC_IM_NET_PROXY_LIST list.
         * @member {Array.<tg.Iproxy_info>} list
         * @memberof tg.CMD_SC_IM_NET_PROXY_LIST
         * @instance
         */
        CMD_SC_IM_NET_PROXY_LIST.prototype.list = $util.emptyArray;

        /**
         * Creates a new CMD_SC_IM_NET_PROXY_LIST instance using the specified properties.
         * @function create
         * @memberof tg.CMD_SC_IM_NET_PROXY_LIST
         * @static
         * @param {tg.ICMD_SC_IM_NET_PROXY_LIST=} [properties] Properties to set
         * @returns {tg.CMD_SC_IM_NET_PROXY_LIST} CMD_SC_IM_NET_PROXY_LIST instance
         */
        CMD_SC_IM_NET_PROXY_LIST.create = function create(properties) {
            return new CMD_SC_IM_NET_PROXY_LIST(properties);
        };

        /**
         * Encodes the specified CMD_SC_IM_NET_PROXY_LIST message. Does not implicitly {@link tg.CMD_SC_IM_NET_PROXY_LIST.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_SC_IM_NET_PROXY_LIST
         * @static
         * @param {tg.ICMD_SC_IM_NET_PROXY_LIST} message CMD_SC_IM_NET_PROXY_LIST message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_IM_NET_PROXY_LIST.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
            if (message.msg != null && Object.hasOwnProperty.call(message, "msg"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.msg);
            if (message.list != null && message.list.length)
                for (var i = 0; i < message.list.length; ++i)
                    $root.tg.proxy_info.encode(message.list[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CMD_SC_IM_NET_PROXY_LIST message, length delimited. Does not implicitly {@link tg.CMD_SC_IM_NET_PROXY_LIST.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_SC_IM_NET_PROXY_LIST
         * @static
         * @param {tg.ICMD_SC_IM_NET_PROXY_LIST} message CMD_SC_IM_NET_PROXY_LIST message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_IM_NET_PROXY_LIST.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_SC_IM_NET_PROXY_LIST message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_SC_IM_NET_PROXY_LIST
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_SC_IM_NET_PROXY_LIST} CMD_SC_IM_NET_PROXY_LIST
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_IM_NET_PROXY_LIST.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_SC_IM_NET_PROXY_LIST();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.code = reader.int32();
                        break;
                    }
                case 2: {
                        message.msg = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.tg.proxy_info.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_SC_IM_NET_PROXY_LIST message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_SC_IM_NET_PROXY_LIST
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_SC_IM_NET_PROXY_LIST} CMD_SC_IM_NET_PROXY_LIST
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_IM_NET_PROXY_LIST.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_SC_IM_NET_PROXY_LIST message.
         * @function verify
         * @memberof tg.CMD_SC_IM_NET_PROXY_LIST
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_SC_IM_NET_PROXY_LIST.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code))
                    return "code: integer expected";
            if (message.msg != null && message.hasOwnProperty("msg"))
                if (!$util.isString(message.msg))
                    return "msg: string expected";
            if (message.list != null && message.hasOwnProperty("list")) {
                if (!Array.isArray(message.list))
                    return "list: array expected";
                for (var i = 0; i < message.list.length; ++i) {
                    var error = $root.tg.proxy_info.verify(message.list[i]);
                    if (error)
                        return "list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CMD_SC_IM_NET_PROXY_LIST message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_SC_IM_NET_PROXY_LIST
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_SC_IM_NET_PROXY_LIST} CMD_SC_IM_NET_PROXY_LIST
         */
        CMD_SC_IM_NET_PROXY_LIST.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_SC_IM_NET_PROXY_LIST)
                return object;
            var message = new $root.tg.CMD_SC_IM_NET_PROXY_LIST();
            if (object.code != null)
                message.code = object.code | 0;
            if (object.msg != null)
                message.msg = String(object.msg);
            if (object.list) {
                if (!Array.isArray(object.list))
                    throw TypeError(".tg.CMD_SC_IM_NET_PROXY_LIST.list: array expected");
                message.list = [];
                for (var i = 0; i < object.list.length; ++i) {
                    if (typeof object.list[i] !== "object")
                        throw TypeError(".tg.CMD_SC_IM_NET_PROXY_LIST.list: object expected");
                    message.list[i] = $root.tg.proxy_info.fromObject(object.list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CMD_SC_IM_NET_PROXY_LIST message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_SC_IM_NET_PROXY_LIST
         * @static
         * @param {tg.CMD_SC_IM_NET_PROXY_LIST} message CMD_SC_IM_NET_PROXY_LIST
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_SC_IM_NET_PROXY_LIST.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.list = [];
            if (options.defaults) {
                object.code = 0;
                object.msg = "";
            }
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.msg != null && message.hasOwnProperty("msg"))
                object.msg = message.msg;
            if (message.list && message.list.length) {
                object.list = [];
                for (var j = 0; j < message.list.length; ++j)
                    object.list[j] = $root.tg.proxy_info.toObject(message.list[j], options);
            }
            return object;
        };

        /**
         * Converts this CMD_SC_IM_NET_PROXY_LIST to JSON.
         * @function toJSON
         * @memberof tg.CMD_SC_IM_NET_PROXY_LIST
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_SC_IM_NET_PROXY_LIST.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_SC_IM_NET_PROXY_LIST
         * @function getTypeUrl
         * @memberof tg.CMD_SC_IM_NET_PROXY_LIST
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_SC_IM_NET_PROXY_LIST.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_SC_IM_NET_PROXY_LIST";
        };

        return CMD_SC_IM_NET_PROXY_LIST;
    })();

    tg.CMD_CS_IM_NET_PROXY_DELETE = (function() {

        /**
         * Properties of a CMD_CS_IM_NET_PROXY_DELETE.
         * @memberof tg
         * @interface ICMD_CS_IM_NET_PROXY_DELETE
         * @property {Array.<number>|null} [index] CMD_CS_IM_NET_PROXY_DELETE index
         * @property {string|null} [admin] CMD_CS_IM_NET_PROXY_DELETE admin
         */

        /**
         * Constructs a new CMD_CS_IM_NET_PROXY_DELETE.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_NET_PROXY_DELETE.
         * @implements ICMD_CS_IM_NET_PROXY_DELETE
         * @constructor
         * @param {tg.ICMD_CS_IM_NET_PROXY_DELETE=} [properties] Properties to set
         */
        function CMD_CS_IM_NET_PROXY_DELETE(properties) {
            this.index = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_NET_PROXY_DELETE index.
         * @member {Array.<number>} index
         * @memberof tg.CMD_CS_IM_NET_PROXY_DELETE
         * @instance
         */
        CMD_CS_IM_NET_PROXY_DELETE.prototype.index = $util.emptyArray;

        /**
         * CMD_CS_IM_NET_PROXY_DELETE admin.
         * @member {string} admin
         * @memberof tg.CMD_CS_IM_NET_PROXY_DELETE
         * @instance
         */
        CMD_CS_IM_NET_PROXY_DELETE.prototype.admin = "";

        /**
         * Creates a new CMD_CS_IM_NET_PROXY_DELETE instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_NET_PROXY_DELETE
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_DELETE=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_NET_PROXY_DELETE} CMD_CS_IM_NET_PROXY_DELETE instance
         */
        CMD_CS_IM_NET_PROXY_DELETE.create = function create(properties) {
            return new CMD_CS_IM_NET_PROXY_DELETE(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_NET_PROXY_DELETE message. Does not implicitly {@link tg.CMD_CS_IM_NET_PROXY_DELETE.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_NET_PROXY_DELETE
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_DELETE} message CMD_CS_IM_NET_PROXY_DELETE message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_NET_PROXY_DELETE.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.index != null && message.index.length) {
                writer.uint32(/* id 1, wireType 2 =*/10).fork();
                for (var i = 0; i < message.index.length; ++i)
                    writer.int32(message.index[i]);
                writer.ldelim();
            }
            if (message.admin != null && Object.hasOwnProperty.call(message, "admin"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.admin);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_NET_PROXY_DELETE message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_NET_PROXY_DELETE.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_NET_PROXY_DELETE
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_DELETE} message CMD_CS_IM_NET_PROXY_DELETE message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_NET_PROXY_DELETE.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_NET_PROXY_DELETE message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_NET_PROXY_DELETE
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_NET_PROXY_DELETE} CMD_CS_IM_NET_PROXY_DELETE
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_NET_PROXY_DELETE.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_NET_PROXY_DELETE();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.index && message.index.length))
                            message.index = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.index.push(reader.int32());
                        } else
                            message.index.push(reader.int32());
                        break;
                    }
                case 2: {
                        message.admin = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_NET_PROXY_DELETE message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_NET_PROXY_DELETE
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_NET_PROXY_DELETE} CMD_CS_IM_NET_PROXY_DELETE
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_NET_PROXY_DELETE.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_NET_PROXY_DELETE message.
         * @function verify
         * @memberof tg.CMD_CS_IM_NET_PROXY_DELETE
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_NET_PROXY_DELETE.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.index != null && message.hasOwnProperty("index")) {
                if (!Array.isArray(message.index))
                    return "index: array expected";
                for (var i = 0; i < message.index.length; ++i)
                    if (!$util.isInteger(message.index[i]))
                        return "index: integer[] expected";
            }
            if (message.admin != null && message.hasOwnProperty("admin"))
                if (!$util.isString(message.admin))
                    return "admin: string expected";
            return null;
        };

        /**
         * Creates a CMD_CS_IM_NET_PROXY_DELETE message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_NET_PROXY_DELETE
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_NET_PROXY_DELETE} CMD_CS_IM_NET_PROXY_DELETE
         */
        CMD_CS_IM_NET_PROXY_DELETE.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_NET_PROXY_DELETE)
                return object;
            var message = new $root.tg.CMD_CS_IM_NET_PROXY_DELETE();
            if (object.index) {
                if (!Array.isArray(object.index))
                    throw TypeError(".tg.CMD_CS_IM_NET_PROXY_DELETE.index: array expected");
                message.index = [];
                for (var i = 0; i < object.index.length; ++i)
                    message.index[i] = object.index[i] | 0;
            }
            if (object.admin != null)
                message.admin = String(object.admin);
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_NET_PROXY_DELETE message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_NET_PROXY_DELETE
         * @static
         * @param {tg.CMD_CS_IM_NET_PROXY_DELETE} message CMD_CS_IM_NET_PROXY_DELETE
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_NET_PROXY_DELETE.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.index = [];
            if (options.defaults)
                object.admin = "";
            if (message.index && message.index.length) {
                object.index = [];
                for (var j = 0; j < message.index.length; ++j)
                    object.index[j] = message.index[j];
            }
            if (message.admin != null && message.hasOwnProperty("admin"))
                object.admin = message.admin;
            return object;
        };

        /**
         * Converts this CMD_CS_IM_NET_PROXY_DELETE to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_NET_PROXY_DELETE
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_NET_PROXY_DELETE.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_NET_PROXY_DELETE
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_NET_PROXY_DELETE
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_NET_PROXY_DELETE.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_NET_PROXY_DELETE";
        };

        return CMD_CS_IM_NET_PROXY_DELETE;
    })();

    tg.CMD_CS_IM_NET_PROXY_CHECK = (function() {

        /**
         * Properties of a CMD_CS_IM_NET_PROXY_CHECK.
         * @memberof tg
         * @interface ICMD_CS_IM_NET_PROXY_CHECK
         * @property {string|null} [phoneNum] CMD_CS_IM_NET_PROXY_CHECK phoneNum
         * @property {Array.<tg.Iproxy_info>|null} [list] CMD_CS_IM_NET_PROXY_CHECK list
         */

        /**
         * Constructs a new CMD_CS_IM_NET_PROXY_CHECK.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_NET_PROXY_CHECK.
         * @implements ICMD_CS_IM_NET_PROXY_CHECK
         * @constructor
         * @param {tg.ICMD_CS_IM_NET_PROXY_CHECK=} [properties] Properties to set
         */
        function CMD_CS_IM_NET_PROXY_CHECK(properties) {
            this.list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_NET_PROXY_CHECK phoneNum.
         * @member {string} phoneNum
         * @memberof tg.CMD_CS_IM_NET_PROXY_CHECK
         * @instance
         */
        CMD_CS_IM_NET_PROXY_CHECK.prototype.phoneNum = "";

        /**
         * CMD_CS_IM_NET_PROXY_CHECK list.
         * @member {Array.<tg.Iproxy_info>} list
         * @memberof tg.CMD_CS_IM_NET_PROXY_CHECK
         * @instance
         */
        CMD_CS_IM_NET_PROXY_CHECK.prototype.list = $util.emptyArray;

        /**
         * Creates a new CMD_CS_IM_NET_PROXY_CHECK instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_NET_PROXY_CHECK
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_CHECK=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_NET_PROXY_CHECK} CMD_CS_IM_NET_PROXY_CHECK instance
         */
        CMD_CS_IM_NET_PROXY_CHECK.create = function create(properties) {
            return new CMD_CS_IM_NET_PROXY_CHECK(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_NET_PROXY_CHECK message. Does not implicitly {@link tg.CMD_CS_IM_NET_PROXY_CHECK.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_NET_PROXY_CHECK
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_CHECK} message CMD_CS_IM_NET_PROXY_CHECK message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_NET_PROXY_CHECK.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.phoneNum != null && Object.hasOwnProperty.call(message, "phoneNum"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.phoneNum);
            if (message.list != null && message.list.length)
                for (var i = 0; i < message.list.length; ++i)
                    $root.tg.proxy_info.encode(message.list[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_NET_PROXY_CHECK message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_NET_PROXY_CHECK.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_NET_PROXY_CHECK
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_CHECK} message CMD_CS_IM_NET_PROXY_CHECK message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_NET_PROXY_CHECK.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_NET_PROXY_CHECK message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_NET_PROXY_CHECK
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_NET_PROXY_CHECK} CMD_CS_IM_NET_PROXY_CHECK
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_NET_PROXY_CHECK.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_NET_PROXY_CHECK();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.phoneNum = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.tg.proxy_info.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_NET_PROXY_CHECK message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_NET_PROXY_CHECK
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_NET_PROXY_CHECK} CMD_CS_IM_NET_PROXY_CHECK
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_NET_PROXY_CHECK.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_NET_PROXY_CHECK message.
         * @function verify
         * @memberof tg.CMD_CS_IM_NET_PROXY_CHECK
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_NET_PROXY_CHECK.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.phoneNum != null && message.hasOwnProperty("phoneNum"))
                if (!$util.isString(message.phoneNum))
                    return "phoneNum: string expected";
            if (message.list != null && message.hasOwnProperty("list")) {
                if (!Array.isArray(message.list))
                    return "list: array expected";
                for (var i = 0; i < message.list.length; ++i) {
                    var error = $root.tg.proxy_info.verify(message.list[i]);
                    if (error)
                        return "list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CMD_CS_IM_NET_PROXY_CHECK message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_NET_PROXY_CHECK
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_NET_PROXY_CHECK} CMD_CS_IM_NET_PROXY_CHECK
         */
        CMD_CS_IM_NET_PROXY_CHECK.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_NET_PROXY_CHECK)
                return object;
            var message = new $root.tg.CMD_CS_IM_NET_PROXY_CHECK();
            if (object.phoneNum != null)
                message.phoneNum = String(object.phoneNum);
            if (object.list) {
                if (!Array.isArray(object.list))
                    throw TypeError(".tg.CMD_CS_IM_NET_PROXY_CHECK.list: array expected");
                message.list = [];
                for (var i = 0; i < object.list.length; ++i) {
                    if (typeof object.list[i] !== "object")
                        throw TypeError(".tg.CMD_CS_IM_NET_PROXY_CHECK.list: object expected");
                    message.list[i] = $root.tg.proxy_info.fromObject(object.list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_NET_PROXY_CHECK message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_NET_PROXY_CHECK
         * @static
         * @param {tg.CMD_CS_IM_NET_PROXY_CHECK} message CMD_CS_IM_NET_PROXY_CHECK
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_NET_PROXY_CHECK.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.list = [];
            if (options.defaults)
                object.phoneNum = "";
            if (message.phoneNum != null && message.hasOwnProperty("phoneNum"))
                object.phoneNum = message.phoneNum;
            if (message.list && message.list.length) {
                object.list = [];
                for (var j = 0; j < message.list.length; ++j)
                    object.list[j] = $root.tg.proxy_info.toObject(message.list[j], options);
            }
            return object;
        };

        /**
         * Converts this CMD_CS_IM_NET_PROXY_CHECK to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_NET_PROXY_CHECK
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_NET_PROXY_CHECK.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_NET_PROXY_CHECK
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_NET_PROXY_CHECK
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_NET_PROXY_CHECK.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_NET_PROXY_CHECK";
        };

        return CMD_CS_IM_NET_PROXY_CHECK;
    })();

    tg.CMD_CS_IM_NET_PROXY_USER_CHECK = (function() {

        /**
         * Properties of a CMD_CS_IM_NET_PROXY_USER_CHECK.
         * @memberof tg
         * @interface ICMD_CS_IM_NET_PROXY_USER_CHECK
         * @property {string|null} [admin] CMD_CS_IM_NET_PROXY_USER_CHECK admin
         */

        /**
         * Constructs a new CMD_CS_IM_NET_PROXY_USER_CHECK.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_NET_PROXY_USER_CHECK.
         * @implements ICMD_CS_IM_NET_PROXY_USER_CHECK
         * @constructor
         * @param {tg.ICMD_CS_IM_NET_PROXY_USER_CHECK=} [properties] Properties to set
         */
        function CMD_CS_IM_NET_PROXY_USER_CHECK(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_NET_PROXY_USER_CHECK admin.
         * @member {string} admin
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_CHECK
         * @instance
         */
        CMD_CS_IM_NET_PROXY_USER_CHECK.prototype.admin = "";

        /**
         * Creates a new CMD_CS_IM_NET_PROXY_USER_CHECK instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_CHECK
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_USER_CHECK=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_NET_PROXY_USER_CHECK} CMD_CS_IM_NET_PROXY_USER_CHECK instance
         */
        CMD_CS_IM_NET_PROXY_USER_CHECK.create = function create(properties) {
            return new CMD_CS_IM_NET_PROXY_USER_CHECK(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_NET_PROXY_USER_CHECK message. Does not implicitly {@link tg.CMD_CS_IM_NET_PROXY_USER_CHECK.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_CHECK
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_USER_CHECK} message CMD_CS_IM_NET_PROXY_USER_CHECK message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_NET_PROXY_USER_CHECK.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.admin != null && Object.hasOwnProperty.call(message, "admin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.admin);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_NET_PROXY_USER_CHECK message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_NET_PROXY_USER_CHECK.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_CHECK
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_USER_CHECK} message CMD_CS_IM_NET_PROXY_USER_CHECK message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_NET_PROXY_USER_CHECK.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_NET_PROXY_USER_CHECK message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_CHECK
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_NET_PROXY_USER_CHECK} CMD_CS_IM_NET_PROXY_USER_CHECK
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_NET_PROXY_USER_CHECK.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_NET_PROXY_USER_CHECK();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.admin = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_NET_PROXY_USER_CHECK message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_CHECK
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_NET_PROXY_USER_CHECK} CMD_CS_IM_NET_PROXY_USER_CHECK
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_NET_PROXY_USER_CHECK.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_NET_PROXY_USER_CHECK message.
         * @function verify
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_CHECK
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_NET_PROXY_USER_CHECK.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.admin != null && message.hasOwnProperty("admin"))
                if (!$util.isString(message.admin))
                    return "admin: string expected";
            return null;
        };

        /**
         * Creates a CMD_CS_IM_NET_PROXY_USER_CHECK message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_CHECK
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_NET_PROXY_USER_CHECK} CMD_CS_IM_NET_PROXY_USER_CHECK
         */
        CMD_CS_IM_NET_PROXY_USER_CHECK.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_NET_PROXY_USER_CHECK)
                return object;
            var message = new $root.tg.CMD_CS_IM_NET_PROXY_USER_CHECK();
            if (object.admin != null)
                message.admin = String(object.admin);
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_NET_PROXY_USER_CHECK message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_CHECK
         * @static
         * @param {tg.CMD_CS_IM_NET_PROXY_USER_CHECK} message CMD_CS_IM_NET_PROXY_USER_CHECK
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_NET_PROXY_USER_CHECK.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.admin = "";
            if (message.admin != null && message.hasOwnProperty("admin"))
                object.admin = message.admin;
            return object;
        };

        /**
         * Converts this CMD_CS_IM_NET_PROXY_USER_CHECK to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_CHECK
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_NET_PROXY_USER_CHECK.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_NET_PROXY_USER_CHECK
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_CHECK
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_NET_PROXY_USER_CHECK.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_NET_PROXY_USER_CHECK";
        };

        return CMD_CS_IM_NET_PROXY_USER_CHECK;
    })();

    tg.CMD_SC_IM_NET_PROXY_USER_LIST = (function() {

        /**
         * Properties of a CMD_SC_IM_NET_PROXY_USER_LIST.
         * @memberof tg
         * @interface ICMD_SC_IM_NET_PROXY_USER_LIST
         * @property {Array.<tg.CMD_SC_IM_NET_PROXY_USER_LIST.Inet_userlst>|null} [data] CMD_SC_IM_NET_PROXY_USER_LIST data
         */

        /**
         * Constructs a new CMD_SC_IM_NET_PROXY_USER_LIST.
         * @memberof tg
         * @classdesc Represents a CMD_SC_IM_NET_PROXY_USER_LIST.
         * @implements ICMD_SC_IM_NET_PROXY_USER_LIST
         * @constructor
         * @param {tg.ICMD_SC_IM_NET_PROXY_USER_LIST=} [properties] Properties to set
         */
        function CMD_SC_IM_NET_PROXY_USER_LIST(properties) {
            this.data = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_SC_IM_NET_PROXY_USER_LIST data.
         * @member {Array.<tg.CMD_SC_IM_NET_PROXY_USER_LIST.Inet_userlst>} data
         * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST
         * @instance
         */
        CMD_SC_IM_NET_PROXY_USER_LIST.prototype.data = $util.emptyArray;

        /**
         * Creates a new CMD_SC_IM_NET_PROXY_USER_LIST instance using the specified properties.
         * @function create
         * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST
         * @static
         * @param {tg.ICMD_SC_IM_NET_PROXY_USER_LIST=} [properties] Properties to set
         * @returns {tg.CMD_SC_IM_NET_PROXY_USER_LIST} CMD_SC_IM_NET_PROXY_USER_LIST instance
         */
        CMD_SC_IM_NET_PROXY_USER_LIST.create = function create(properties) {
            return new CMD_SC_IM_NET_PROXY_USER_LIST(properties);
        };

        /**
         * Encodes the specified CMD_SC_IM_NET_PROXY_USER_LIST message. Does not implicitly {@link tg.CMD_SC_IM_NET_PROXY_USER_LIST.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST
         * @static
         * @param {tg.ICMD_SC_IM_NET_PROXY_USER_LIST} message CMD_SC_IM_NET_PROXY_USER_LIST message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_IM_NET_PROXY_USER_LIST.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.data != null && message.data.length)
                for (var i = 0; i < message.data.length; ++i)
                    $root.tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst.encode(message.data[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CMD_SC_IM_NET_PROXY_USER_LIST message, length delimited. Does not implicitly {@link tg.CMD_SC_IM_NET_PROXY_USER_LIST.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST
         * @static
         * @param {tg.ICMD_SC_IM_NET_PROXY_USER_LIST} message CMD_SC_IM_NET_PROXY_USER_LIST message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_IM_NET_PROXY_USER_LIST.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_SC_IM_NET_PROXY_USER_LIST message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_SC_IM_NET_PROXY_USER_LIST} CMD_SC_IM_NET_PROXY_USER_LIST
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_IM_NET_PROXY_USER_LIST.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_SC_IM_NET_PROXY_USER_LIST();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.data && message.data.length))
                            message.data = [];
                        message.data.push($root.tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_SC_IM_NET_PROXY_USER_LIST message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_SC_IM_NET_PROXY_USER_LIST} CMD_SC_IM_NET_PROXY_USER_LIST
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_IM_NET_PROXY_USER_LIST.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_SC_IM_NET_PROXY_USER_LIST message.
         * @function verify
         * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_SC_IM_NET_PROXY_USER_LIST.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.data != null && message.hasOwnProperty("data")) {
                if (!Array.isArray(message.data))
                    return "data: array expected";
                for (var i = 0; i < message.data.length; ++i) {
                    var error = $root.tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst.verify(message.data[i]);
                    if (error)
                        return "data." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CMD_SC_IM_NET_PROXY_USER_LIST message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_SC_IM_NET_PROXY_USER_LIST} CMD_SC_IM_NET_PROXY_USER_LIST
         */
        CMD_SC_IM_NET_PROXY_USER_LIST.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_SC_IM_NET_PROXY_USER_LIST)
                return object;
            var message = new $root.tg.CMD_SC_IM_NET_PROXY_USER_LIST();
            if (object.data) {
                if (!Array.isArray(object.data))
                    throw TypeError(".tg.CMD_SC_IM_NET_PROXY_USER_LIST.data: array expected");
                message.data = [];
                for (var i = 0; i < object.data.length; ++i) {
                    if (typeof object.data[i] !== "object")
                        throw TypeError(".tg.CMD_SC_IM_NET_PROXY_USER_LIST.data: object expected");
                    message.data[i] = $root.tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst.fromObject(object.data[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CMD_SC_IM_NET_PROXY_USER_LIST message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST
         * @static
         * @param {tg.CMD_SC_IM_NET_PROXY_USER_LIST} message CMD_SC_IM_NET_PROXY_USER_LIST
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_SC_IM_NET_PROXY_USER_LIST.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.data = [];
            if (message.data && message.data.length) {
                object.data = [];
                for (var j = 0; j < message.data.length; ++j)
                    object.data[j] = $root.tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst.toObject(message.data[j], options);
            }
            return object;
        };

        /**
         * Converts this CMD_SC_IM_NET_PROXY_USER_LIST to JSON.
         * @function toJSON
         * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_SC_IM_NET_PROXY_USER_LIST.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_SC_IM_NET_PROXY_USER_LIST
         * @function getTypeUrl
         * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_SC_IM_NET_PROXY_USER_LIST.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_SC_IM_NET_PROXY_USER_LIST";
        };

        CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst = (function() {

            /**
             * Properties of a net_userlst.
             * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST
             * @interface Inet_userlst
             * @property {number|null} [valid] net_userlst valid
             * @property {number|null} [proxy_type] net_userlst proxy_type
             * @property {number|null} [proxy_id] net_userlst proxy_id
             * @property {number|null} [proxy_port] net_userlst proxy_port
             * @property {string|null} [proxy_adress] net_userlst proxy_adress
             * @property {string|null} [phoneNum] net_userlst phoneNum
             */

            /**
             * Constructs a new net_userlst.
             * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST
             * @classdesc Represents a net_userlst.
             * @implements Inet_userlst
             * @constructor
             * @param {tg.CMD_SC_IM_NET_PROXY_USER_LIST.Inet_userlst=} [properties] Properties to set
             */
            function net_userlst(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * net_userlst valid.
             * @member {number} valid
             * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst
             * @instance
             */
            net_userlst.prototype.valid = 0;

            /**
             * net_userlst proxy_type.
             * @member {number} proxy_type
             * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst
             * @instance
             */
            net_userlst.prototype.proxy_type = 0;

            /**
             * net_userlst proxy_id.
             * @member {number} proxy_id
             * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst
             * @instance
             */
            net_userlst.prototype.proxy_id = 0;

            /**
             * net_userlst proxy_port.
             * @member {number} proxy_port
             * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst
             * @instance
             */
            net_userlst.prototype.proxy_port = 0;

            /**
             * net_userlst proxy_adress.
             * @member {string} proxy_adress
             * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst
             * @instance
             */
            net_userlst.prototype.proxy_adress = "";

            /**
             * net_userlst phoneNum.
             * @member {string} phoneNum
             * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst
             * @instance
             */
            net_userlst.prototype.phoneNum = "";

            /**
             * Creates a new net_userlst instance using the specified properties.
             * @function create
             * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst
             * @static
             * @param {tg.CMD_SC_IM_NET_PROXY_USER_LIST.Inet_userlst=} [properties] Properties to set
             * @returns {tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst} net_userlst instance
             */
            net_userlst.create = function create(properties) {
                return new net_userlst(properties);
            };

            /**
             * Encodes the specified net_userlst message. Does not implicitly {@link tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst.verify|verify} messages.
             * @function encode
             * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst
             * @static
             * @param {tg.CMD_SC_IM_NET_PROXY_USER_LIST.Inet_userlst} message net_userlst message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            net_userlst.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.valid != null && Object.hasOwnProperty.call(message, "valid"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.valid);
                if (message.proxy_type != null && Object.hasOwnProperty.call(message, "proxy_type"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.proxy_type);
                if (message.proxy_id != null && Object.hasOwnProperty.call(message, "proxy_id"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.proxy_id);
                if (message.proxy_port != null && Object.hasOwnProperty.call(message, "proxy_port"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.proxy_port);
                if (message.proxy_adress != null && Object.hasOwnProperty.call(message, "proxy_adress"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.proxy_adress);
                if (message.phoneNum != null && Object.hasOwnProperty.call(message, "phoneNum"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.phoneNum);
                return writer;
            };

            /**
             * Encodes the specified net_userlst message, length delimited. Does not implicitly {@link tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst
             * @static
             * @param {tg.CMD_SC_IM_NET_PROXY_USER_LIST.Inet_userlst} message net_userlst message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            net_userlst.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a net_userlst message from the specified reader or buffer.
             * @function decode
             * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst} net_userlst
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            net_userlst.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.valid = reader.int32();
                            break;
                        }
                    case 2: {
                            message.proxy_type = reader.int32();
                            break;
                        }
                    case 3: {
                            message.proxy_id = reader.int32();
                            break;
                        }
                    case 4: {
                            message.proxy_port = reader.int32();
                            break;
                        }
                    case 5: {
                            message.proxy_adress = reader.string();
                            break;
                        }
                    case 6: {
                            message.phoneNum = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a net_userlst message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst} net_userlst
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            net_userlst.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a net_userlst message.
             * @function verify
             * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            net_userlst.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.valid != null && message.hasOwnProperty("valid"))
                    if (!$util.isInteger(message.valid))
                        return "valid: integer expected";
                if (message.proxy_type != null && message.hasOwnProperty("proxy_type"))
                    if (!$util.isInteger(message.proxy_type))
                        return "proxy_type: integer expected";
                if (message.proxy_id != null && message.hasOwnProperty("proxy_id"))
                    if (!$util.isInteger(message.proxy_id))
                        return "proxy_id: integer expected";
                if (message.proxy_port != null && message.hasOwnProperty("proxy_port"))
                    if (!$util.isInteger(message.proxy_port))
                        return "proxy_port: integer expected";
                if (message.proxy_adress != null && message.hasOwnProperty("proxy_adress"))
                    if (!$util.isString(message.proxy_adress))
                        return "proxy_adress: string expected";
                if (message.phoneNum != null && message.hasOwnProperty("phoneNum"))
                    if (!$util.isString(message.phoneNum))
                        return "phoneNum: string expected";
                return null;
            };

            /**
             * Creates a net_userlst message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst} net_userlst
             */
            net_userlst.fromObject = function fromObject(object) {
                if (object instanceof $root.tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst)
                    return object;
                var message = new $root.tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst();
                if (object.valid != null)
                    message.valid = object.valid | 0;
                if (object.proxy_type != null)
                    message.proxy_type = object.proxy_type | 0;
                if (object.proxy_id != null)
                    message.proxy_id = object.proxy_id | 0;
                if (object.proxy_port != null)
                    message.proxy_port = object.proxy_port | 0;
                if (object.proxy_adress != null)
                    message.proxy_adress = String(object.proxy_adress);
                if (object.phoneNum != null)
                    message.phoneNum = String(object.phoneNum);
                return message;
            };

            /**
             * Creates a plain object from a net_userlst message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst
             * @static
             * @param {tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst} message net_userlst
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            net_userlst.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.valid = 0;
                    object.proxy_type = 0;
                    object.proxy_id = 0;
                    object.proxy_port = 0;
                    object.proxy_adress = "";
                    object.phoneNum = "";
                }
                if (message.valid != null && message.hasOwnProperty("valid"))
                    object.valid = message.valid;
                if (message.proxy_type != null && message.hasOwnProperty("proxy_type"))
                    object.proxy_type = message.proxy_type;
                if (message.proxy_id != null && message.hasOwnProperty("proxy_id"))
                    object.proxy_id = message.proxy_id;
                if (message.proxy_port != null && message.hasOwnProperty("proxy_port"))
                    object.proxy_port = message.proxy_port;
                if (message.proxy_adress != null && message.hasOwnProperty("proxy_adress"))
                    object.proxy_adress = message.proxy_adress;
                if (message.phoneNum != null && message.hasOwnProperty("phoneNum"))
                    object.phoneNum = message.phoneNum;
                return object;
            };

            /**
             * Converts this net_userlst to JSON.
             * @function toJSON
             * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            net_userlst.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for net_userlst
             * @function getTypeUrl
             * @memberof tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            net_userlst.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tg.CMD_SC_IM_NET_PROXY_USER_LIST.net_userlst";
            };

            return net_userlst;
        })();

        return CMD_SC_IM_NET_PROXY_USER_LIST;
    })();

    tg.CMD_CS_IM_NET_PROXY_ALLOCATE = (function() {

        /**
         * Properties of a CMD_CS_IM_NET_PROXY_ALLOCATE.
         * @memberof tg
         * @interface ICMD_CS_IM_NET_PROXY_ALLOCATE
         * @property {string|null} [admin] CMD_CS_IM_NET_PROXY_ALLOCATE admin
         * @property {string|null} [phoneNum] CMD_CS_IM_NET_PROXY_ALLOCATE phoneNum
         * @property {number|null} [proxyId] CMD_CS_IM_NET_PROXY_ALLOCATE proxyId
         */

        /**
         * Constructs a new CMD_CS_IM_NET_PROXY_ALLOCATE.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_NET_PROXY_ALLOCATE.
         * @implements ICMD_CS_IM_NET_PROXY_ALLOCATE
         * @constructor
         * @param {tg.ICMD_CS_IM_NET_PROXY_ALLOCATE=} [properties] Properties to set
         */
        function CMD_CS_IM_NET_PROXY_ALLOCATE(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_NET_PROXY_ALLOCATE admin.
         * @member {string} admin
         * @memberof tg.CMD_CS_IM_NET_PROXY_ALLOCATE
         * @instance
         */
        CMD_CS_IM_NET_PROXY_ALLOCATE.prototype.admin = "";

        /**
         * CMD_CS_IM_NET_PROXY_ALLOCATE phoneNum.
         * @member {string} phoneNum
         * @memberof tg.CMD_CS_IM_NET_PROXY_ALLOCATE
         * @instance
         */
        CMD_CS_IM_NET_PROXY_ALLOCATE.prototype.phoneNum = "";

        /**
         * CMD_CS_IM_NET_PROXY_ALLOCATE proxyId.
         * @member {number} proxyId
         * @memberof tg.CMD_CS_IM_NET_PROXY_ALLOCATE
         * @instance
         */
        CMD_CS_IM_NET_PROXY_ALLOCATE.prototype.proxyId = 0;

        /**
         * Creates a new CMD_CS_IM_NET_PROXY_ALLOCATE instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_NET_PROXY_ALLOCATE
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_ALLOCATE=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_NET_PROXY_ALLOCATE} CMD_CS_IM_NET_PROXY_ALLOCATE instance
         */
        CMD_CS_IM_NET_PROXY_ALLOCATE.create = function create(properties) {
            return new CMD_CS_IM_NET_PROXY_ALLOCATE(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_NET_PROXY_ALLOCATE message. Does not implicitly {@link tg.CMD_CS_IM_NET_PROXY_ALLOCATE.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_NET_PROXY_ALLOCATE
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_ALLOCATE} message CMD_CS_IM_NET_PROXY_ALLOCATE message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_NET_PROXY_ALLOCATE.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.admin != null && Object.hasOwnProperty.call(message, "admin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.admin);
            if (message.phoneNum != null && Object.hasOwnProperty.call(message, "phoneNum"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.phoneNum);
            if (message.proxyId != null && Object.hasOwnProperty.call(message, "proxyId"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.proxyId);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_NET_PROXY_ALLOCATE message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_NET_PROXY_ALLOCATE.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_NET_PROXY_ALLOCATE
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_ALLOCATE} message CMD_CS_IM_NET_PROXY_ALLOCATE message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_NET_PROXY_ALLOCATE.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_NET_PROXY_ALLOCATE message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_NET_PROXY_ALLOCATE
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_NET_PROXY_ALLOCATE} CMD_CS_IM_NET_PROXY_ALLOCATE
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_NET_PROXY_ALLOCATE.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_NET_PROXY_ALLOCATE();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.admin = reader.string();
                        break;
                    }
                case 2: {
                        message.phoneNum = reader.string();
                        break;
                    }
                case 3: {
                        message.proxyId = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_NET_PROXY_ALLOCATE message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_NET_PROXY_ALLOCATE
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_NET_PROXY_ALLOCATE} CMD_CS_IM_NET_PROXY_ALLOCATE
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_NET_PROXY_ALLOCATE.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_NET_PROXY_ALLOCATE message.
         * @function verify
         * @memberof tg.CMD_CS_IM_NET_PROXY_ALLOCATE
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_NET_PROXY_ALLOCATE.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.admin != null && message.hasOwnProperty("admin"))
                if (!$util.isString(message.admin))
                    return "admin: string expected";
            if (message.phoneNum != null && message.hasOwnProperty("phoneNum"))
                if (!$util.isString(message.phoneNum))
                    return "phoneNum: string expected";
            if (message.proxyId != null && message.hasOwnProperty("proxyId"))
                if (!$util.isInteger(message.proxyId))
                    return "proxyId: integer expected";
            return null;
        };

        /**
         * Creates a CMD_CS_IM_NET_PROXY_ALLOCATE message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_NET_PROXY_ALLOCATE
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_NET_PROXY_ALLOCATE} CMD_CS_IM_NET_PROXY_ALLOCATE
         */
        CMD_CS_IM_NET_PROXY_ALLOCATE.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_NET_PROXY_ALLOCATE)
                return object;
            var message = new $root.tg.CMD_CS_IM_NET_PROXY_ALLOCATE();
            if (object.admin != null)
                message.admin = String(object.admin);
            if (object.phoneNum != null)
                message.phoneNum = String(object.phoneNum);
            if (object.proxyId != null)
                message.proxyId = object.proxyId | 0;
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_NET_PROXY_ALLOCATE message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_NET_PROXY_ALLOCATE
         * @static
         * @param {tg.CMD_CS_IM_NET_PROXY_ALLOCATE} message CMD_CS_IM_NET_PROXY_ALLOCATE
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_NET_PROXY_ALLOCATE.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.admin = "";
                object.phoneNum = "";
                object.proxyId = 0;
            }
            if (message.admin != null && message.hasOwnProperty("admin"))
                object.admin = message.admin;
            if (message.phoneNum != null && message.hasOwnProperty("phoneNum"))
                object.phoneNum = message.phoneNum;
            if (message.proxyId != null && message.hasOwnProperty("proxyId"))
                object.proxyId = message.proxyId;
            return object;
        };

        /**
         * Converts this CMD_CS_IM_NET_PROXY_ALLOCATE to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_NET_PROXY_ALLOCATE
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_NET_PROXY_ALLOCATE.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_NET_PROXY_ALLOCATE
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_NET_PROXY_ALLOCATE
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_NET_PROXY_ALLOCATE.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_NET_PROXY_ALLOCATE";
        };

        return CMD_CS_IM_NET_PROXY_ALLOCATE;
    })();

    tg.CMD_CS_IM_NET_PROXY_USER_UPDATE = (function() {

        /**
         * Properties of a CMD_CS_IM_NET_PROXY_USER_UPDATE.
         * @memberof tg
         * @interface ICMD_CS_IM_NET_PROXY_USER_UPDATE
         * @property {string|null} [admin] CMD_CS_IM_NET_PROXY_USER_UPDATE admin
         * @property {string|null} [phoneNum] CMD_CS_IM_NET_PROXY_USER_UPDATE phoneNum
         * @property {number|null} [proxyId] CMD_CS_IM_NET_PROXY_USER_UPDATE proxyId
         */

        /**
         * Constructs a new CMD_CS_IM_NET_PROXY_USER_UPDATE.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_NET_PROXY_USER_UPDATE.
         * @implements ICMD_CS_IM_NET_PROXY_USER_UPDATE
         * @constructor
         * @param {tg.ICMD_CS_IM_NET_PROXY_USER_UPDATE=} [properties] Properties to set
         */
        function CMD_CS_IM_NET_PROXY_USER_UPDATE(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_NET_PROXY_USER_UPDATE admin.
         * @member {string} admin
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_UPDATE
         * @instance
         */
        CMD_CS_IM_NET_PROXY_USER_UPDATE.prototype.admin = "";

        /**
         * CMD_CS_IM_NET_PROXY_USER_UPDATE phoneNum.
         * @member {string} phoneNum
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_UPDATE
         * @instance
         */
        CMD_CS_IM_NET_PROXY_USER_UPDATE.prototype.phoneNum = "";

        /**
         * CMD_CS_IM_NET_PROXY_USER_UPDATE proxyId.
         * @member {number} proxyId
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_UPDATE
         * @instance
         */
        CMD_CS_IM_NET_PROXY_USER_UPDATE.prototype.proxyId = 0;

        /**
         * Creates a new CMD_CS_IM_NET_PROXY_USER_UPDATE instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_UPDATE
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_USER_UPDATE=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_NET_PROXY_USER_UPDATE} CMD_CS_IM_NET_PROXY_USER_UPDATE instance
         */
        CMD_CS_IM_NET_PROXY_USER_UPDATE.create = function create(properties) {
            return new CMD_CS_IM_NET_PROXY_USER_UPDATE(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_NET_PROXY_USER_UPDATE message. Does not implicitly {@link tg.CMD_CS_IM_NET_PROXY_USER_UPDATE.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_UPDATE
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_USER_UPDATE} message CMD_CS_IM_NET_PROXY_USER_UPDATE message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_NET_PROXY_USER_UPDATE.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.admin != null && Object.hasOwnProperty.call(message, "admin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.admin);
            if (message.phoneNum != null && Object.hasOwnProperty.call(message, "phoneNum"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.phoneNum);
            if (message.proxyId != null && Object.hasOwnProperty.call(message, "proxyId"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.proxyId);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_NET_PROXY_USER_UPDATE message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_NET_PROXY_USER_UPDATE.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_UPDATE
         * @static
         * @param {tg.ICMD_CS_IM_NET_PROXY_USER_UPDATE} message CMD_CS_IM_NET_PROXY_USER_UPDATE message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_NET_PROXY_USER_UPDATE.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_NET_PROXY_USER_UPDATE message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_UPDATE
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_NET_PROXY_USER_UPDATE} CMD_CS_IM_NET_PROXY_USER_UPDATE
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_NET_PROXY_USER_UPDATE.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_NET_PROXY_USER_UPDATE();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.admin = reader.string();
                        break;
                    }
                case 2: {
                        message.phoneNum = reader.string();
                        break;
                    }
                case 3: {
                        message.proxyId = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_NET_PROXY_USER_UPDATE message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_UPDATE
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_NET_PROXY_USER_UPDATE} CMD_CS_IM_NET_PROXY_USER_UPDATE
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_NET_PROXY_USER_UPDATE.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_NET_PROXY_USER_UPDATE message.
         * @function verify
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_UPDATE
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_NET_PROXY_USER_UPDATE.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.admin != null && message.hasOwnProperty("admin"))
                if (!$util.isString(message.admin))
                    return "admin: string expected";
            if (message.phoneNum != null && message.hasOwnProperty("phoneNum"))
                if (!$util.isString(message.phoneNum))
                    return "phoneNum: string expected";
            if (message.proxyId != null && message.hasOwnProperty("proxyId"))
                if (!$util.isInteger(message.proxyId))
                    return "proxyId: integer expected";
            return null;
        };

        /**
         * Creates a CMD_CS_IM_NET_PROXY_USER_UPDATE message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_UPDATE
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_NET_PROXY_USER_UPDATE} CMD_CS_IM_NET_PROXY_USER_UPDATE
         */
        CMD_CS_IM_NET_PROXY_USER_UPDATE.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_NET_PROXY_USER_UPDATE)
                return object;
            var message = new $root.tg.CMD_CS_IM_NET_PROXY_USER_UPDATE();
            if (object.admin != null)
                message.admin = String(object.admin);
            if (object.phoneNum != null)
                message.phoneNum = String(object.phoneNum);
            if (object.proxyId != null)
                message.proxyId = object.proxyId | 0;
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_NET_PROXY_USER_UPDATE message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_UPDATE
         * @static
         * @param {tg.CMD_CS_IM_NET_PROXY_USER_UPDATE} message CMD_CS_IM_NET_PROXY_USER_UPDATE
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_NET_PROXY_USER_UPDATE.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.admin = "";
                object.phoneNum = "";
                object.proxyId = 0;
            }
            if (message.admin != null && message.hasOwnProperty("admin"))
                object.admin = message.admin;
            if (message.phoneNum != null && message.hasOwnProperty("phoneNum"))
                object.phoneNum = message.phoneNum;
            if (message.proxyId != null && message.hasOwnProperty("proxyId"))
                object.proxyId = message.proxyId;
            return object;
        };

        /**
         * Converts this CMD_CS_IM_NET_PROXY_USER_UPDATE to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_UPDATE
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_NET_PROXY_USER_UPDATE.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_NET_PROXY_USER_UPDATE
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_NET_PROXY_USER_UPDATE
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_NET_PROXY_USER_UPDATE.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_NET_PROXY_USER_UPDATE";
        };

        return CMD_CS_IM_NET_PROXY_USER_UPDATE;
    })();

    tg.CMD_CS_IM_ACCOUNT_LIST_REQ = (function() {

        /**
         * Properties of a CMD_CS_IM_ACCOUNT_LIST_REQ.
         * @memberof tg
         * @interface ICMD_CS_IM_ACCOUNT_LIST_REQ
         * @property {string|null} [strAccount] CMD_CS_IM_ACCOUNT_LIST_REQ strAccount
         */

        /**
         * Constructs a new CMD_CS_IM_ACCOUNT_LIST_REQ.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_ACCOUNT_LIST_REQ.
         * @implements ICMD_CS_IM_ACCOUNT_LIST_REQ
         * @constructor
         * @param {tg.ICMD_CS_IM_ACCOUNT_LIST_REQ=} [properties] Properties to set
         */
        function CMD_CS_IM_ACCOUNT_LIST_REQ(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_ACCOUNT_LIST_REQ strAccount.
         * @member {string} strAccount
         * @memberof tg.CMD_CS_IM_ACCOUNT_LIST_REQ
         * @instance
         */
        CMD_CS_IM_ACCOUNT_LIST_REQ.prototype.strAccount = "";

        /**
         * Creates a new CMD_CS_IM_ACCOUNT_LIST_REQ instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_ACCOUNT_LIST_REQ
         * @static
         * @param {tg.ICMD_CS_IM_ACCOUNT_LIST_REQ=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_ACCOUNT_LIST_REQ} CMD_CS_IM_ACCOUNT_LIST_REQ instance
         */
        CMD_CS_IM_ACCOUNT_LIST_REQ.create = function create(properties) {
            return new CMD_CS_IM_ACCOUNT_LIST_REQ(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_ACCOUNT_LIST_REQ message. Does not implicitly {@link tg.CMD_CS_IM_ACCOUNT_LIST_REQ.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_ACCOUNT_LIST_REQ
         * @static
         * @param {tg.ICMD_CS_IM_ACCOUNT_LIST_REQ} message CMD_CS_IM_ACCOUNT_LIST_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_ACCOUNT_LIST_REQ.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.strAccount != null && Object.hasOwnProperty.call(message, "strAccount"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.strAccount);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_ACCOUNT_LIST_REQ message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_ACCOUNT_LIST_REQ.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_ACCOUNT_LIST_REQ
         * @static
         * @param {tg.ICMD_CS_IM_ACCOUNT_LIST_REQ} message CMD_CS_IM_ACCOUNT_LIST_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_ACCOUNT_LIST_REQ.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_ACCOUNT_LIST_REQ message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_ACCOUNT_LIST_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_ACCOUNT_LIST_REQ} CMD_CS_IM_ACCOUNT_LIST_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_ACCOUNT_LIST_REQ.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_ACCOUNT_LIST_REQ();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.strAccount = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_ACCOUNT_LIST_REQ message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_ACCOUNT_LIST_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_ACCOUNT_LIST_REQ} CMD_CS_IM_ACCOUNT_LIST_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_ACCOUNT_LIST_REQ.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_ACCOUNT_LIST_REQ message.
         * @function verify
         * @memberof tg.CMD_CS_IM_ACCOUNT_LIST_REQ
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_ACCOUNT_LIST_REQ.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.strAccount != null && message.hasOwnProperty("strAccount"))
                if (!$util.isString(message.strAccount))
                    return "strAccount: string expected";
            return null;
        };

        /**
         * Creates a CMD_CS_IM_ACCOUNT_LIST_REQ message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_ACCOUNT_LIST_REQ
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_ACCOUNT_LIST_REQ} CMD_CS_IM_ACCOUNT_LIST_REQ
         */
        CMD_CS_IM_ACCOUNT_LIST_REQ.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_ACCOUNT_LIST_REQ)
                return object;
            var message = new $root.tg.CMD_CS_IM_ACCOUNT_LIST_REQ();
            if (object.strAccount != null)
                message.strAccount = String(object.strAccount);
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_ACCOUNT_LIST_REQ message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_ACCOUNT_LIST_REQ
         * @static
         * @param {tg.CMD_CS_IM_ACCOUNT_LIST_REQ} message CMD_CS_IM_ACCOUNT_LIST_REQ
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_ACCOUNT_LIST_REQ.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.strAccount = "";
            if (message.strAccount != null && message.hasOwnProperty("strAccount"))
                object.strAccount = message.strAccount;
            return object;
        };

        /**
         * Converts this CMD_CS_IM_ACCOUNT_LIST_REQ to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_ACCOUNT_LIST_REQ
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_ACCOUNT_LIST_REQ.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_ACCOUNT_LIST_REQ
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_ACCOUNT_LIST_REQ
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_ACCOUNT_LIST_REQ.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_ACCOUNT_LIST_REQ";
        };

        return CMD_CS_IM_ACCOUNT_LIST_REQ;
    })();

    tg.CMD_GAME_TOOLS_ACCOUNT_INF = (function() {

        /**
         * Properties of a CMD_GAME_TOOLS_ACCOUNT_INF.
         * @memberof tg
         * @interface ICMD_GAME_TOOLS_ACCOUNT_INF
         * @property {string|null} [strAccount] CMD_GAME_TOOLS_ACCOUNT_INF strAccount
         * @property {string|null} [strCheck] CMD_GAME_TOOLS_ACCOUNT_INF strCheck
         * @property {string|null} [strStatus] CMD_GAME_TOOLS_ACCOUNT_INF strStatus
         */

        /**
         * Constructs a new CMD_GAME_TOOLS_ACCOUNT_INF.
         * @memberof tg
         * @classdesc Represents a CMD_GAME_TOOLS_ACCOUNT_INF.
         * @implements ICMD_GAME_TOOLS_ACCOUNT_INF
         * @constructor
         * @param {tg.ICMD_GAME_TOOLS_ACCOUNT_INF=} [properties] Properties to set
         */
        function CMD_GAME_TOOLS_ACCOUNT_INF(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_GAME_TOOLS_ACCOUNT_INF strAccount.
         * @member {string} strAccount
         * @memberof tg.CMD_GAME_TOOLS_ACCOUNT_INF
         * @instance
         */
        CMD_GAME_TOOLS_ACCOUNT_INF.prototype.strAccount = "";

        /**
         * CMD_GAME_TOOLS_ACCOUNT_INF strCheck.
         * @member {string} strCheck
         * @memberof tg.CMD_GAME_TOOLS_ACCOUNT_INF
         * @instance
         */
        CMD_GAME_TOOLS_ACCOUNT_INF.prototype.strCheck = "";

        /**
         * CMD_GAME_TOOLS_ACCOUNT_INF strStatus.
         * @member {string} strStatus
         * @memberof tg.CMD_GAME_TOOLS_ACCOUNT_INF
         * @instance
         */
        CMD_GAME_TOOLS_ACCOUNT_INF.prototype.strStatus = "";

        /**
         * Creates a new CMD_GAME_TOOLS_ACCOUNT_INF instance using the specified properties.
         * @function create
         * @memberof tg.CMD_GAME_TOOLS_ACCOUNT_INF
         * @static
         * @param {tg.ICMD_GAME_TOOLS_ACCOUNT_INF=} [properties] Properties to set
         * @returns {tg.CMD_GAME_TOOLS_ACCOUNT_INF} CMD_GAME_TOOLS_ACCOUNT_INF instance
         */
        CMD_GAME_TOOLS_ACCOUNT_INF.create = function create(properties) {
            return new CMD_GAME_TOOLS_ACCOUNT_INF(properties);
        };

        /**
         * Encodes the specified CMD_GAME_TOOLS_ACCOUNT_INF message. Does not implicitly {@link tg.CMD_GAME_TOOLS_ACCOUNT_INF.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_GAME_TOOLS_ACCOUNT_INF
         * @static
         * @param {tg.ICMD_GAME_TOOLS_ACCOUNT_INF} message CMD_GAME_TOOLS_ACCOUNT_INF message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_GAME_TOOLS_ACCOUNT_INF.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.strAccount != null && Object.hasOwnProperty.call(message, "strAccount"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.strAccount);
            if (message.strCheck != null && Object.hasOwnProperty.call(message, "strCheck"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.strCheck);
            if (message.strStatus != null && Object.hasOwnProperty.call(message, "strStatus"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.strStatus);
            return writer;
        };

        /**
         * Encodes the specified CMD_GAME_TOOLS_ACCOUNT_INF message, length delimited. Does not implicitly {@link tg.CMD_GAME_TOOLS_ACCOUNT_INF.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_GAME_TOOLS_ACCOUNT_INF
         * @static
         * @param {tg.ICMD_GAME_TOOLS_ACCOUNT_INF} message CMD_GAME_TOOLS_ACCOUNT_INF message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_GAME_TOOLS_ACCOUNT_INF.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_GAME_TOOLS_ACCOUNT_INF message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_GAME_TOOLS_ACCOUNT_INF
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_GAME_TOOLS_ACCOUNT_INF} CMD_GAME_TOOLS_ACCOUNT_INF
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_GAME_TOOLS_ACCOUNT_INF.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_GAME_TOOLS_ACCOUNT_INF();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.strAccount = reader.string();
                        break;
                    }
                case 2: {
                        message.strCheck = reader.string();
                        break;
                    }
                case 3: {
                        message.strStatus = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_GAME_TOOLS_ACCOUNT_INF message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_GAME_TOOLS_ACCOUNT_INF
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_GAME_TOOLS_ACCOUNT_INF} CMD_GAME_TOOLS_ACCOUNT_INF
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_GAME_TOOLS_ACCOUNT_INF.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_GAME_TOOLS_ACCOUNT_INF message.
         * @function verify
         * @memberof tg.CMD_GAME_TOOLS_ACCOUNT_INF
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_GAME_TOOLS_ACCOUNT_INF.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.strAccount != null && message.hasOwnProperty("strAccount"))
                if (!$util.isString(message.strAccount))
                    return "strAccount: string expected";
            if (message.strCheck != null && message.hasOwnProperty("strCheck"))
                if (!$util.isString(message.strCheck))
                    return "strCheck: string expected";
            if (message.strStatus != null && message.hasOwnProperty("strStatus"))
                if (!$util.isString(message.strStatus))
                    return "strStatus: string expected";
            return null;
        };

        /**
         * Creates a CMD_GAME_TOOLS_ACCOUNT_INF message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_GAME_TOOLS_ACCOUNT_INF
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_GAME_TOOLS_ACCOUNT_INF} CMD_GAME_TOOLS_ACCOUNT_INF
         */
        CMD_GAME_TOOLS_ACCOUNT_INF.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_GAME_TOOLS_ACCOUNT_INF)
                return object;
            var message = new $root.tg.CMD_GAME_TOOLS_ACCOUNT_INF();
            if (object.strAccount != null)
                message.strAccount = String(object.strAccount);
            if (object.strCheck != null)
                message.strCheck = String(object.strCheck);
            if (object.strStatus != null)
                message.strStatus = String(object.strStatus);
            return message;
        };

        /**
         * Creates a plain object from a CMD_GAME_TOOLS_ACCOUNT_INF message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_GAME_TOOLS_ACCOUNT_INF
         * @static
         * @param {tg.CMD_GAME_TOOLS_ACCOUNT_INF} message CMD_GAME_TOOLS_ACCOUNT_INF
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_GAME_TOOLS_ACCOUNT_INF.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.strAccount = "";
                object.strCheck = "";
                object.strStatus = "";
            }
            if (message.strAccount != null && message.hasOwnProperty("strAccount"))
                object.strAccount = message.strAccount;
            if (message.strCheck != null && message.hasOwnProperty("strCheck"))
                object.strCheck = message.strCheck;
            if (message.strStatus != null && message.hasOwnProperty("strStatus"))
                object.strStatus = message.strStatus;
            return object;
        };

        /**
         * Converts this CMD_GAME_TOOLS_ACCOUNT_INF to JSON.
         * @function toJSON
         * @memberof tg.CMD_GAME_TOOLS_ACCOUNT_INF
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_GAME_TOOLS_ACCOUNT_INF.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_GAME_TOOLS_ACCOUNT_INF
         * @function getTypeUrl
         * @memberof tg.CMD_GAME_TOOLS_ACCOUNT_INF
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_GAME_TOOLS_ACCOUNT_INF.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_GAME_TOOLS_ACCOUNT_INF";
        };

        return CMD_GAME_TOOLS_ACCOUNT_INF;
    })();

    tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST = (function() {

        /**
         * Properties of a CMD_CS_GAME_TOOLS_ACCOUNT_LIST.
         * @memberof tg
         * @interface ICMD_CS_GAME_TOOLS_ACCOUNT_LIST
         * @property {Array.<tg.ICMD_GAME_TOOLS_ACCOUNT_INF>|null} [list] CMD_CS_GAME_TOOLS_ACCOUNT_LIST list
         */

        /**
         * Constructs a new CMD_CS_GAME_TOOLS_ACCOUNT_LIST.
         * @memberof tg
         * @classdesc Represents a CMD_CS_GAME_TOOLS_ACCOUNT_LIST.
         * @implements ICMD_CS_GAME_TOOLS_ACCOUNT_LIST
         * @constructor
         * @param {tg.ICMD_CS_GAME_TOOLS_ACCOUNT_LIST=} [properties] Properties to set
         */
        function CMD_CS_GAME_TOOLS_ACCOUNT_LIST(properties) {
            this.list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_GAME_TOOLS_ACCOUNT_LIST list.
         * @member {Array.<tg.ICMD_GAME_TOOLS_ACCOUNT_INF>} list
         * @memberof tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST
         * @instance
         */
        CMD_CS_GAME_TOOLS_ACCOUNT_LIST.prototype.list = $util.emptyArray;

        /**
         * Creates a new CMD_CS_GAME_TOOLS_ACCOUNT_LIST instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_ACCOUNT_LIST=} [properties] Properties to set
         * @returns {tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST} CMD_CS_GAME_TOOLS_ACCOUNT_LIST instance
         */
        CMD_CS_GAME_TOOLS_ACCOUNT_LIST.create = function create(properties) {
            return new CMD_CS_GAME_TOOLS_ACCOUNT_LIST(properties);
        };

        /**
         * Encodes the specified CMD_CS_GAME_TOOLS_ACCOUNT_LIST message. Does not implicitly {@link tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_ACCOUNT_LIST} message CMD_CS_GAME_TOOLS_ACCOUNT_LIST message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_GAME_TOOLS_ACCOUNT_LIST.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.list != null && message.list.length)
                for (var i = 0; i < message.list.length; ++i)
                    $root.tg.CMD_GAME_TOOLS_ACCOUNT_INF.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_GAME_TOOLS_ACCOUNT_LIST message, length delimited. Does not implicitly {@link tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_ACCOUNT_LIST} message CMD_CS_GAME_TOOLS_ACCOUNT_LIST message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_GAME_TOOLS_ACCOUNT_LIST.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_GAME_TOOLS_ACCOUNT_LIST message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST} CMD_CS_GAME_TOOLS_ACCOUNT_LIST
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_GAME_TOOLS_ACCOUNT_LIST.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.tg.CMD_GAME_TOOLS_ACCOUNT_INF.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_GAME_TOOLS_ACCOUNT_LIST message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST} CMD_CS_GAME_TOOLS_ACCOUNT_LIST
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_GAME_TOOLS_ACCOUNT_LIST.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_GAME_TOOLS_ACCOUNT_LIST message.
         * @function verify
         * @memberof tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_GAME_TOOLS_ACCOUNT_LIST.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.list != null && message.hasOwnProperty("list")) {
                if (!Array.isArray(message.list))
                    return "list: array expected";
                for (var i = 0; i < message.list.length; ++i) {
                    var error = $root.tg.CMD_GAME_TOOLS_ACCOUNT_INF.verify(message.list[i]);
                    if (error)
                        return "list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CMD_CS_GAME_TOOLS_ACCOUNT_LIST message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST} CMD_CS_GAME_TOOLS_ACCOUNT_LIST
         */
        CMD_CS_GAME_TOOLS_ACCOUNT_LIST.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST)
                return object;
            var message = new $root.tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST();
            if (object.list) {
                if (!Array.isArray(object.list))
                    throw TypeError(".tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST.list: array expected");
                message.list = [];
                for (var i = 0; i < object.list.length; ++i) {
                    if (typeof object.list[i] !== "object")
                        throw TypeError(".tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST.list: object expected");
                    message.list[i] = $root.tg.CMD_GAME_TOOLS_ACCOUNT_INF.fromObject(object.list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_GAME_TOOLS_ACCOUNT_LIST message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST
         * @static
         * @param {tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST} message CMD_CS_GAME_TOOLS_ACCOUNT_LIST
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_GAME_TOOLS_ACCOUNT_LIST.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.list = [];
            if (message.list && message.list.length) {
                object.list = [];
                for (var j = 0; j < message.list.length; ++j)
                    object.list[j] = $root.tg.CMD_GAME_TOOLS_ACCOUNT_INF.toObject(message.list[j], options);
            }
            return object;
        };

        /**
         * Converts this CMD_CS_GAME_TOOLS_ACCOUNT_LIST to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_GAME_TOOLS_ACCOUNT_LIST.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_GAME_TOOLS_ACCOUNT_LIST
         * @function getTypeUrl
         * @memberof tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_GAME_TOOLS_ACCOUNT_LIST.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST";
        };

        return CMD_CS_GAME_TOOLS_ACCOUNT_LIST;
    })();

    tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK = (function() {

        /**
         * Properties of a CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK.
         * @memberof tg
         * @interface ICMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK
         * @property {string|null} [admin] CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK admin
         */

        /**
         * Constructs a new CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK.
         * @implements ICMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK
         * @constructor
         * @param {tg.ICMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK=} [properties] Properties to set
         */
        function CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK admin.
         * @member {string} admin
         * @memberof tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK
         * @instance
         */
        CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK.prototype.admin = "";

        /**
         * Creates a new CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK
         * @static
         * @param {tg.ICMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK} CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK instance
         */
        CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK.create = function create(properties) {
            return new CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK message. Does not implicitly {@link tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK
         * @static
         * @param {tg.ICMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK} message CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.admin != null && Object.hasOwnProperty.call(message, "admin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.admin);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK
         * @static
         * @param {tg.ICMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK} message CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK} CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.admin = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK} CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK message.
         * @function verify
         * @memberof tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.admin != null && message.hasOwnProperty("admin"))
                if (!$util.isString(message.admin))
                    return "admin: string expected";
            return null;
        };

        /**
         * Creates a CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK} CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK
         */
        CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK)
                return object;
            var message = new $root.tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK();
            if (object.admin != null)
                message.admin = String(object.admin);
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK
         * @static
         * @param {tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK} message CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.admin = "";
            if (message.admin != null && message.hasOwnProperty("admin"))
                object.admin = message.admin;
            return object;
        };

        /**
         * Converts this CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK";
        };

        return CMD_CS_IM_TOOLS_ACCOUNT_LIST_ACK;
    })();

    tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT = (function() {

        /**
         * Properties of a CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT.
         * @memberof tg
         * @interface ICMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @property {number|null} [valid] CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT valid
         * @property {number|null} [proxy_id] CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT proxy_id
         * @property {number|null} [proxy_port] CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT proxy_port
         * @property {string|null} [proxy_adress] CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT proxy_adress
         */

        /**
         * Constructs a new CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT.
         * @memberof tg
         * @classdesc Represents a CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT.
         * @implements ICMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @constructor
         * @param {tg.ICMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT=} [properties] Properties to set
         */
        function CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT valid.
         * @member {number} valid
         * @memberof tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @instance
         */
        CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT.prototype.valid = 0;

        /**
         * CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT proxy_id.
         * @member {number} proxy_id
         * @memberof tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @instance
         */
        CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT.prototype.proxy_id = 0;

        /**
         * CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT proxy_port.
         * @member {number} proxy_port
         * @memberof tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @instance
         */
        CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT.prototype.proxy_port = 0;

        /**
         * CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT proxy_adress.
         * @member {string} proxy_adress
         * @memberof tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @instance
         */
        CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT.prototype.proxy_adress = "";

        /**
         * Creates a new CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT instance using the specified properties.
         * @function create
         * @memberof tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @static
         * @param {tg.ICMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT=} [properties] Properties to set
         * @returns {tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT} CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT instance
         */
        CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT.create = function create(properties) {
            return new CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT(properties);
        };

        /**
         * Encodes the specified CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT message. Does not implicitly {@link tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @static
         * @param {tg.ICMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT} message CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.valid != null && Object.hasOwnProperty.call(message, "valid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.valid);
            if (message.proxy_id != null && Object.hasOwnProperty.call(message, "proxy_id"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.proxy_id);
            if (message.proxy_port != null && Object.hasOwnProperty.call(message, "proxy_port"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.proxy_port);
            if (message.proxy_adress != null && Object.hasOwnProperty.call(message, "proxy_adress"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.proxy_adress);
            return writer;
        };

        /**
         * Encodes the specified CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT message, length delimited. Does not implicitly {@link tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @static
         * @param {tg.ICMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT} message CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT} CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.valid = reader.int32();
                        break;
                    }
                case 2: {
                        message.proxy_id = reader.int32();
                        break;
                    }
                case 3: {
                        message.proxy_port = reader.int32();
                        break;
                    }
                case 4: {
                        message.proxy_adress = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT} CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT message.
         * @function verify
         * @memberof tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.valid != null && message.hasOwnProperty("valid"))
                if (!$util.isInteger(message.valid))
                    return "valid: integer expected";
            if (message.proxy_id != null && message.hasOwnProperty("proxy_id"))
                if (!$util.isInteger(message.proxy_id))
                    return "proxy_id: integer expected";
            if (message.proxy_port != null && message.hasOwnProperty("proxy_port"))
                if (!$util.isInteger(message.proxy_port))
                    return "proxy_port: integer expected";
            if (message.proxy_adress != null && message.hasOwnProperty("proxy_adress"))
                if (!$util.isString(message.proxy_adress))
                    return "proxy_adress: string expected";
            return null;
        };

        /**
         * Creates a CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT} CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         */
        CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT)
                return object;
            var message = new $root.tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT();
            if (object.valid != null)
                message.valid = object.valid | 0;
            if (object.proxy_id != null)
                message.proxy_id = object.proxy_id | 0;
            if (object.proxy_port != null)
                message.proxy_port = object.proxy_port | 0;
            if (object.proxy_adress != null)
                message.proxy_adress = String(object.proxy_adress);
            return message;
        };

        /**
         * Creates a plain object from a CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @static
         * @param {tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT} message CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.valid = 0;
                object.proxy_id = 0;
                object.proxy_port = 0;
                object.proxy_adress = "";
            }
            if (message.valid != null && message.hasOwnProperty("valid"))
                object.valid = message.valid;
            if (message.proxy_id != null && message.hasOwnProperty("proxy_id"))
                object.proxy_id = message.proxy_id;
            if (message.proxy_port != null && message.hasOwnProperty("proxy_port"))
                object.proxy_port = message.proxy_port;
            if (message.proxy_adress != null && message.hasOwnProperty("proxy_adress"))
                object.proxy_adress = message.proxy_adress;
            return object;
        };

        /**
         * Converts this CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT to JSON.
         * @function toJSON
         * @memberof tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @function getTypeUrl
         * @memberof tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT";
        };

        return CMD_SC_IM_TOOLS_ACCOUNT_LIST_ACK_RESULT;
    })();

    tg.CMD_GAME_TOOLS_TELEGRAM_INF = (function() {

        /**
         * Properties of a CMD_GAME_TOOLS_TELEGRAM_INF.
         * @memberof tg
         * @interface ICMD_GAME_TOOLS_TELEGRAM_INF
         * @property {string|null} [strTelegramNo] CMD_GAME_TOOLS_TELEGRAM_INF strTelegramNo
         * @property {string|null} [strAccount] CMD_GAME_TOOLS_TELEGRAM_INF strAccount
         * @property {string|null} [strNickName] CMD_GAME_TOOLS_TELEGRAM_INF strNickName
         * @property {string|null} [strPhone] CMD_GAME_TOOLS_TELEGRAM_INF strPhone
         * @property {string|null} [strManage] CMD_GAME_TOOLS_TELEGRAM_INF strManage
         */

        /**
         * Constructs a new CMD_GAME_TOOLS_TELEGRAM_INF.
         * @memberof tg
         * @classdesc Represents a CMD_GAME_TOOLS_TELEGRAM_INF.
         * @implements ICMD_GAME_TOOLS_TELEGRAM_INF
         * @constructor
         * @param {tg.ICMD_GAME_TOOLS_TELEGRAM_INF=} [properties] Properties to set
         */
        function CMD_GAME_TOOLS_TELEGRAM_INF(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_GAME_TOOLS_TELEGRAM_INF strTelegramNo.
         * @member {string} strTelegramNo
         * @memberof tg.CMD_GAME_TOOLS_TELEGRAM_INF
         * @instance
         */
        CMD_GAME_TOOLS_TELEGRAM_INF.prototype.strTelegramNo = "";

        /**
         * CMD_GAME_TOOLS_TELEGRAM_INF strAccount.
         * @member {string} strAccount
         * @memberof tg.CMD_GAME_TOOLS_TELEGRAM_INF
         * @instance
         */
        CMD_GAME_TOOLS_TELEGRAM_INF.prototype.strAccount = "";

        /**
         * CMD_GAME_TOOLS_TELEGRAM_INF strNickName.
         * @member {string} strNickName
         * @memberof tg.CMD_GAME_TOOLS_TELEGRAM_INF
         * @instance
         */
        CMD_GAME_TOOLS_TELEGRAM_INF.prototype.strNickName = "";

        /**
         * CMD_GAME_TOOLS_TELEGRAM_INF strPhone.
         * @member {string} strPhone
         * @memberof tg.CMD_GAME_TOOLS_TELEGRAM_INF
         * @instance
         */
        CMD_GAME_TOOLS_TELEGRAM_INF.prototype.strPhone = "";

        /**
         * CMD_GAME_TOOLS_TELEGRAM_INF strManage.
         * @member {string} strManage
         * @memberof tg.CMD_GAME_TOOLS_TELEGRAM_INF
         * @instance
         */
        CMD_GAME_TOOLS_TELEGRAM_INF.prototype.strManage = "";

        /**
         * Creates a new CMD_GAME_TOOLS_TELEGRAM_INF instance using the specified properties.
         * @function create
         * @memberof tg.CMD_GAME_TOOLS_TELEGRAM_INF
         * @static
         * @param {tg.ICMD_GAME_TOOLS_TELEGRAM_INF=} [properties] Properties to set
         * @returns {tg.CMD_GAME_TOOLS_TELEGRAM_INF} CMD_GAME_TOOLS_TELEGRAM_INF instance
         */
        CMD_GAME_TOOLS_TELEGRAM_INF.create = function create(properties) {
            return new CMD_GAME_TOOLS_TELEGRAM_INF(properties);
        };

        /**
         * Encodes the specified CMD_GAME_TOOLS_TELEGRAM_INF message. Does not implicitly {@link tg.CMD_GAME_TOOLS_TELEGRAM_INF.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_GAME_TOOLS_TELEGRAM_INF
         * @static
         * @param {tg.ICMD_GAME_TOOLS_TELEGRAM_INF} message CMD_GAME_TOOLS_TELEGRAM_INF message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_GAME_TOOLS_TELEGRAM_INF.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.strTelegramNo != null && Object.hasOwnProperty.call(message, "strTelegramNo"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.strTelegramNo);
            if (message.strAccount != null && Object.hasOwnProperty.call(message, "strAccount"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.strAccount);
            if (message.strNickName != null && Object.hasOwnProperty.call(message, "strNickName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.strNickName);
            if (message.strPhone != null && Object.hasOwnProperty.call(message, "strPhone"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.strPhone);
            if (message.strManage != null && Object.hasOwnProperty.call(message, "strManage"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.strManage);
            return writer;
        };

        /**
         * Encodes the specified CMD_GAME_TOOLS_TELEGRAM_INF message, length delimited. Does not implicitly {@link tg.CMD_GAME_TOOLS_TELEGRAM_INF.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_GAME_TOOLS_TELEGRAM_INF
         * @static
         * @param {tg.ICMD_GAME_TOOLS_TELEGRAM_INF} message CMD_GAME_TOOLS_TELEGRAM_INF message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_GAME_TOOLS_TELEGRAM_INF.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_GAME_TOOLS_TELEGRAM_INF message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_GAME_TOOLS_TELEGRAM_INF
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_GAME_TOOLS_TELEGRAM_INF} CMD_GAME_TOOLS_TELEGRAM_INF
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_GAME_TOOLS_TELEGRAM_INF.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_GAME_TOOLS_TELEGRAM_INF();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.strTelegramNo = reader.string();
                        break;
                    }
                case 2: {
                        message.strAccount = reader.string();
                        break;
                    }
                case 3: {
                        message.strNickName = reader.string();
                        break;
                    }
                case 4: {
                        message.strPhone = reader.string();
                        break;
                    }
                case 5: {
                        message.strManage = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_GAME_TOOLS_TELEGRAM_INF message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_GAME_TOOLS_TELEGRAM_INF
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_GAME_TOOLS_TELEGRAM_INF} CMD_GAME_TOOLS_TELEGRAM_INF
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_GAME_TOOLS_TELEGRAM_INF.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_GAME_TOOLS_TELEGRAM_INF message.
         * @function verify
         * @memberof tg.CMD_GAME_TOOLS_TELEGRAM_INF
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_GAME_TOOLS_TELEGRAM_INF.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.strTelegramNo != null && message.hasOwnProperty("strTelegramNo"))
                if (!$util.isString(message.strTelegramNo))
                    return "strTelegramNo: string expected";
            if (message.strAccount != null && message.hasOwnProperty("strAccount"))
                if (!$util.isString(message.strAccount))
                    return "strAccount: string expected";
            if (message.strNickName != null && message.hasOwnProperty("strNickName"))
                if (!$util.isString(message.strNickName))
                    return "strNickName: string expected";
            if (message.strPhone != null && message.hasOwnProperty("strPhone"))
                if (!$util.isString(message.strPhone))
                    return "strPhone: string expected";
            if (message.strManage != null && message.hasOwnProperty("strManage"))
                if (!$util.isString(message.strManage))
                    return "strManage: string expected";
            return null;
        };

        /**
         * Creates a CMD_GAME_TOOLS_TELEGRAM_INF message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_GAME_TOOLS_TELEGRAM_INF
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_GAME_TOOLS_TELEGRAM_INF} CMD_GAME_TOOLS_TELEGRAM_INF
         */
        CMD_GAME_TOOLS_TELEGRAM_INF.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_GAME_TOOLS_TELEGRAM_INF)
                return object;
            var message = new $root.tg.CMD_GAME_TOOLS_TELEGRAM_INF();
            if (object.strTelegramNo != null)
                message.strTelegramNo = String(object.strTelegramNo);
            if (object.strAccount != null)
                message.strAccount = String(object.strAccount);
            if (object.strNickName != null)
                message.strNickName = String(object.strNickName);
            if (object.strPhone != null)
                message.strPhone = String(object.strPhone);
            if (object.strManage != null)
                message.strManage = String(object.strManage);
            return message;
        };

        /**
         * Creates a plain object from a CMD_GAME_TOOLS_TELEGRAM_INF message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_GAME_TOOLS_TELEGRAM_INF
         * @static
         * @param {tg.CMD_GAME_TOOLS_TELEGRAM_INF} message CMD_GAME_TOOLS_TELEGRAM_INF
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_GAME_TOOLS_TELEGRAM_INF.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.strTelegramNo = "";
                object.strAccount = "";
                object.strNickName = "";
                object.strPhone = "";
                object.strManage = "";
            }
            if (message.strTelegramNo != null && message.hasOwnProperty("strTelegramNo"))
                object.strTelegramNo = message.strTelegramNo;
            if (message.strAccount != null && message.hasOwnProperty("strAccount"))
                object.strAccount = message.strAccount;
            if (message.strNickName != null && message.hasOwnProperty("strNickName"))
                object.strNickName = message.strNickName;
            if (message.strPhone != null && message.hasOwnProperty("strPhone"))
                object.strPhone = message.strPhone;
            if (message.strManage != null && message.hasOwnProperty("strManage"))
                object.strManage = message.strManage;
            return object;
        };

        /**
         * Converts this CMD_GAME_TOOLS_TELEGRAM_INF to JSON.
         * @function toJSON
         * @memberof tg.CMD_GAME_TOOLS_TELEGRAM_INF
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_GAME_TOOLS_TELEGRAM_INF.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_GAME_TOOLS_TELEGRAM_INF
         * @function getTypeUrl
         * @memberof tg.CMD_GAME_TOOLS_TELEGRAM_INF
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_GAME_TOOLS_TELEGRAM_INF.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_GAME_TOOLS_TELEGRAM_INF";
        };

        return CMD_GAME_TOOLS_TELEGRAM_INF;
    })();

    tg.ChatTarget = (function() {

        /**
         * Properties of a ChatTarget.
         * @memberof tg
         * @interface IChatTarget
         * @property {number|Long|null} [Id] ChatTarget Id
         * @property {string|null} [name] ChatTarget name
         */

        /**
         * Constructs a new ChatTarget.
         * @memberof tg
         * @classdesc Represents a ChatTarget.
         * @implements IChatTarget
         * @constructor
         * @param {tg.IChatTarget=} [properties] Properties to set
         */
        function ChatTarget(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChatTarget Id.
         * @member {number|Long|null|undefined} Id
         * @memberof tg.ChatTarget
         * @instance
         */
        ChatTarget.prototype.Id = null;

        /**
         * ChatTarget name.
         * @member {string|null|undefined} name
         * @memberof tg.ChatTarget
         * @instance
         */
        ChatTarget.prototype.name = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * ChatTarget target.
         * @member {"Id"|"name"|undefined} target
         * @memberof tg.ChatTarget
         * @instance
         */
        Object.defineProperty(ChatTarget.prototype, "target", {
            get: $util.oneOfGetter($oneOfFields = ["Id", "name"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ChatTarget instance using the specified properties.
         * @function create
         * @memberof tg.ChatTarget
         * @static
         * @param {tg.IChatTarget=} [properties] Properties to set
         * @returns {tg.ChatTarget} ChatTarget instance
         */
        ChatTarget.create = function create(properties) {
            return new ChatTarget(properties);
        };

        /**
         * Encodes the specified ChatTarget message. Does not implicitly {@link tg.ChatTarget.verify|verify} messages.
         * @function encode
         * @memberof tg.ChatTarget
         * @static
         * @param {tg.IChatTarget} message ChatTarget message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatTarget.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Id != null && Object.hasOwnProperty.call(message, "Id"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Id);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            return writer;
        };

        /**
         * Encodes the specified ChatTarget message, length delimited. Does not implicitly {@link tg.ChatTarget.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.ChatTarget
         * @static
         * @param {tg.IChatTarget} message ChatTarget message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatTarget.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChatTarget message from the specified reader or buffer.
         * @function decode
         * @memberof tg.ChatTarget
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.ChatTarget} ChatTarget
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatTarget.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.ChatTarget();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.Id = reader.int64();
                        break;
                    }
                case 2: {
                        message.name = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ChatTarget message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.ChatTarget
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.ChatTarget} ChatTarget
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatTarget.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChatTarget message.
         * @function verify
         * @memberof tg.ChatTarget
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChatTarget.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            var properties = {};
            if (message.Id != null && message.hasOwnProperty("Id")) {
                properties.target = 1;
                if (!$util.isInteger(message.Id) && !(message.Id && $util.isInteger(message.Id.low) && $util.isInteger(message.Id.high)))
                    return "Id: integer|Long expected";
            }
            if (message.name != null && message.hasOwnProperty("name")) {
                if (properties.target === 1)
                    return "target: multiple values";
                properties.target = 1;
                if (!$util.isString(message.name))
                    return "name: string expected";
            }
            return null;
        };

        /**
         * Creates a ChatTarget message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.ChatTarget
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.ChatTarget} ChatTarget
         */
        ChatTarget.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.ChatTarget)
                return object;
            var message = new $root.tg.ChatTarget();
            if (object.Id != null)
                if ($util.Long)
                    (message.Id = $util.Long.fromValue(object.Id)).unsigned = false;
                else if (typeof object.Id === "string")
                    message.Id = parseInt(object.Id, 10);
                else if (typeof object.Id === "number")
                    message.Id = object.Id;
                else if (typeof object.Id === "object")
                    message.Id = new $util.LongBits(object.Id.low >>> 0, object.Id.high >>> 0).toNumber();
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        /**
         * Creates a plain object from a ChatTarget message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.ChatTarget
         * @static
         * @param {tg.ChatTarget} message ChatTarget
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChatTarget.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (message.Id != null && message.hasOwnProperty("Id")) {
                if (typeof message.Id === "number")
                    object.Id = options.longs === String ? String(message.Id) : message.Id;
                else
                    object.Id = options.longs === String ? $util.Long.prototype.toString.call(message.Id) : options.longs === Number ? new $util.LongBits(message.Id.low >>> 0, message.Id.high >>> 0).toNumber() : message.Id;
                if (options.oneofs)
                    object.target = "Id";
            }
            if (message.name != null && message.hasOwnProperty("name")) {
                object.name = message.name;
                if (options.oneofs)
                    object.target = "name";
            }
            return object;
        };

        /**
         * Converts this ChatTarget to JSON.
         * @function toJSON
         * @memberof tg.ChatTarget
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChatTarget.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ChatTarget
         * @function getTypeUrl
         * @memberof tg.ChatTarget
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ChatTarget.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.ChatTarget";
        };

        return ChatTarget;
    })();

    tg.CMD_CS_IM_SEND_MESSAGE = (function() {

        /**
         * Properties of a CMD_CS_IM_SEND_MESSAGE.
         * @memberof tg
         * @interface ICMD_CS_IM_SEND_MESSAGE
         * @property {string|null} [admin] CMD_CS_IM_SEND_MESSAGE admin
         * @property {string|null} [from] CMD_CS_IM_SEND_MESSAGE from
         * @property {Array.<tg.IChatTarget>|null} [targets] CMD_CS_IM_SEND_MESSAGE targets
         * @property {string|null} [message] CMD_CS_IM_SEND_MESSAGE message
         * @property {number|null} [type] CMD_CS_IM_SEND_MESSAGE type
         */

        /**
         * Constructs a new CMD_CS_IM_SEND_MESSAGE.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_SEND_MESSAGE.
         * @implements ICMD_CS_IM_SEND_MESSAGE
         * @constructor
         * @param {tg.ICMD_CS_IM_SEND_MESSAGE=} [properties] Properties to set
         */
        function CMD_CS_IM_SEND_MESSAGE(properties) {
            this.targets = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_SEND_MESSAGE admin.
         * @member {string} admin
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE
         * @instance
         */
        CMD_CS_IM_SEND_MESSAGE.prototype.admin = "";

        /**
         * CMD_CS_IM_SEND_MESSAGE from.
         * @member {string} from
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE
         * @instance
         */
        CMD_CS_IM_SEND_MESSAGE.prototype.from = "";

        /**
         * CMD_CS_IM_SEND_MESSAGE targets.
         * @member {Array.<tg.IChatTarget>} targets
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE
         * @instance
         */
        CMD_CS_IM_SEND_MESSAGE.prototype.targets = $util.emptyArray;

        /**
         * CMD_CS_IM_SEND_MESSAGE message.
         * @member {string} message
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE
         * @instance
         */
        CMD_CS_IM_SEND_MESSAGE.prototype.message = "";

        /**
         * CMD_CS_IM_SEND_MESSAGE type.
         * @member {number} type
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE
         * @instance
         */
        CMD_CS_IM_SEND_MESSAGE.prototype.type = 0;

        /**
         * Creates a new CMD_CS_IM_SEND_MESSAGE instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE
         * @static
         * @param {tg.ICMD_CS_IM_SEND_MESSAGE=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_SEND_MESSAGE} CMD_CS_IM_SEND_MESSAGE instance
         */
        CMD_CS_IM_SEND_MESSAGE.create = function create(properties) {
            return new CMD_CS_IM_SEND_MESSAGE(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_SEND_MESSAGE message. Does not implicitly {@link tg.CMD_CS_IM_SEND_MESSAGE.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE
         * @static
         * @param {tg.ICMD_CS_IM_SEND_MESSAGE} message CMD_CS_IM_SEND_MESSAGE message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_SEND_MESSAGE.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.admin != null && Object.hasOwnProperty.call(message, "admin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.admin);
            if (message.from != null && Object.hasOwnProperty.call(message, "from"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.from);
            if (message.targets != null && message.targets.length)
                for (var i = 0; i < message.targets.length; ++i)
                    $root.tg.ChatTarget.encode(message.targets[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.type);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_SEND_MESSAGE message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_SEND_MESSAGE.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE
         * @static
         * @param {tg.ICMD_CS_IM_SEND_MESSAGE} message CMD_CS_IM_SEND_MESSAGE message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_SEND_MESSAGE.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_SEND_MESSAGE message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_SEND_MESSAGE} CMD_CS_IM_SEND_MESSAGE
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_SEND_MESSAGE.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_SEND_MESSAGE();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.admin = reader.string();
                        break;
                    }
                case 2: {
                        message.from = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.targets && message.targets.length))
                            message.targets = [];
                        message.targets.push($root.tg.ChatTarget.decode(reader, reader.uint32()));
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                case 5: {
                        message.type = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_SEND_MESSAGE message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_SEND_MESSAGE} CMD_CS_IM_SEND_MESSAGE
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_SEND_MESSAGE.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_SEND_MESSAGE message.
         * @function verify
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_SEND_MESSAGE.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.admin != null && message.hasOwnProperty("admin"))
                if (!$util.isString(message.admin))
                    return "admin: string expected";
            if (message.from != null && message.hasOwnProperty("from"))
                if (!$util.isString(message.from))
                    return "from: string expected";
            if (message.targets != null && message.hasOwnProperty("targets")) {
                if (!Array.isArray(message.targets))
                    return "targets: array expected";
                for (var i = 0; i < message.targets.length; ++i) {
                    var error = $root.tg.ChatTarget.verify(message.targets[i]);
                    if (error)
                        return "targets." + error;
                }
            }
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isInteger(message.type))
                    return "type: integer expected";
            return null;
        };

        /**
         * Creates a CMD_CS_IM_SEND_MESSAGE message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_SEND_MESSAGE} CMD_CS_IM_SEND_MESSAGE
         */
        CMD_CS_IM_SEND_MESSAGE.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_SEND_MESSAGE)
                return object;
            var message = new $root.tg.CMD_CS_IM_SEND_MESSAGE();
            if (object.admin != null)
                message.admin = String(object.admin);
            if (object.from != null)
                message.from = String(object.from);
            if (object.targets) {
                if (!Array.isArray(object.targets))
                    throw TypeError(".tg.CMD_CS_IM_SEND_MESSAGE.targets: array expected");
                message.targets = [];
                for (var i = 0; i < object.targets.length; ++i) {
                    if (typeof object.targets[i] !== "object")
                        throw TypeError(".tg.CMD_CS_IM_SEND_MESSAGE.targets: object expected");
                    message.targets[i] = $root.tg.ChatTarget.fromObject(object.targets[i]);
                }
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.type != null)
                message.type = object.type | 0;
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_SEND_MESSAGE message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE
         * @static
         * @param {tg.CMD_CS_IM_SEND_MESSAGE} message CMD_CS_IM_SEND_MESSAGE
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_SEND_MESSAGE.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.targets = [];
            if (options.defaults) {
                object.admin = "";
                object.from = "";
                object.message = "";
                object.type = 0;
            }
            if (message.admin != null && message.hasOwnProperty("admin"))
                object.admin = message.admin;
            if (message.from != null && message.hasOwnProperty("from"))
                object.from = message.from;
            if (message.targets && message.targets.length) {
                object.targets = [];
                for (var j = 0; j < message.targets.length; ++j)
                    object.targets[j] = $root.tg.ChatTarget.toObject(message.targets[j], options);
            }
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            return object;
        };

        /**
         * Converts this CMD_CS_IM_SEND_MESSAGE to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_SEND_MESSAGE.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_SEND_MESSAGE
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_SEND_MESSAGE.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_SEND_MESSAGE";
        };

        return CMD_CS_IM_SEND_MESSAGE;
    })();

    tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE = (function() {

        /**
         * Properties of a CMD_CS_IM_SEND_MESSAGE_RESPONSE.
         * @memberof tg
         * @interface ICMD_CS_IM_SEND_MESSAGE_RESPONSE
         * @property {number|null} [code] CMD_CS_IM_SEND_MESSAGE_RESPONSE code
         * @property {string|null} [message] CMD_CS_IM_SEND_MESSAGE_RESPONSE message
         */

        /**
         * Constructs a new CMD_CS_IM_SEND_MESSAGE_RESPONSE.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_SEND_MESSAGE_RESPONSE.
         * @implements ICMD_CS_IM_SEND_MESSAGE_RESPONSE
         * @constructor
         * @param {tg.ICMD_CS_IM_SEND_MESSAGE_RESPONSE=} [properties] Properties to set
         */
        function CMD_CS_IM_SEND_MESSAGE_RESPONSE(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_SEND_MESSAGE_RESPONSE code.
         * @member {number} code
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE
         * @instance
         */
        CMD_CS_IM_SEND_MESSAGE_RESPONSE.prototype.code = 0;

        /**
         * CMD_CS_IM_SEND_MESSAGE_RESPONSE message.
         * @member {string} message
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE
         * @instance
         */
        CMD_CS_IM_SEND_MESSAGE_RESPONSE.prototype.message = "";

        /**
         * Creates a new CMD_CS_IM_SEND_MESSAGE_RESPONSE instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE
         * @static
         * @param {tg.ICMD_CS_IM_SEND_MESSAGE_RESPONSE=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE} CMD_CS_IM_SEND_MESSAGE_RESPONSE instance
         */
        CMD_CS_IM_SEND_MESSAGE_RESPONSE.create = function create(properties) {
            return new CMD_CS_IM_SEND_MESSAGE_RESPONSE(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_SEND_MESSAGE_RESPONSE message. Does not implicitly {@link tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE
         * @static
         * @param {tg.ICMD_CS_IM_SEND_MESSAGE_RESPONSE} message CMD_CS_IM_SEND_MESSAGE_RESPONSE message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_SEND_MESSAGE_RESPONSE.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_SEND_MESSAGE_RESPONSE message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE
         * @static
         * @param {tg.ICMD_CS_IM_SEND_MESSAGE_RESPONSE} message CMD_CS_IM_SEND_MESSAGE_RESPONSE message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_SEND_MESSAGE_RESPONSE.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_SEND_MESSAGE_RESPONSE message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE} CMD_CS_IM_SEND_MESSAGE_RESPONSE
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_SEND_MESSAGE_RESPONSE.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.code = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_SEND_MESSAGE_RESPONSE message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE} CMD_CS_IM_SEND_MESSAGE_RESPONSE
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_SEND_MESSAGE_RESPONSE.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_SEND_MESSAGE_RESPONSE message.
         * @function verify
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_SEND_MESSAGE_RESPONSE.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code))
                    return "code: integer expected";
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            return null;
        };

        /**
         * Creates a CMD_CS_IM_SEND_MESSAGE_RESPONSE message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE} CMD_CS_IM_SEND_MESSAGE_RESPONSE
         */
        CMD_CS_IM_SEND_MESSAGE_RESPONSE.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE)
                return object;
            var message = new $root.tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE();
            if (object.code != null)
                message.code = object.code | 0;
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_SEND_MESSAGE_RESPONSE message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE
         * @static
         * @param {tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE} message CMD_CS_IM_SEND_MESSAGE_RESPONSE
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_SEND_MESSAGE_RESPONSE.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.code = 0;
                object.message = "";
            }
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            return object;
        };

        /**
         * Converts this CMD_CS_IM_SEND_MESSAGE_RESPONSE to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_SEND_MESSAGE_RESPONSE.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_SEND_MESSAGE_RESPONSE
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_SEND_MESSAGE_RESPONSE.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE";
        };

        return CMD_CS_IM_SEND_MESSAGE_RESPONSE;
    })();

    tg.CMD_CS_IM_TELEGRAM_CHAT_REQ = (function() {

        /**
         * Properties of a CMD_CS_IM_TELEGRAM_CHAT_REQ.
         * @memberof tg
         * @interface ICMD_CS_IM_TELEGRAM_CHAT_REQ
         * @property {string|null} [username] CMD_CS_IM_TELEGRAM_CHAT_REQ username
         * @property {string|null} [token] CMD_CS_IM_TELEGRAM_CHAT_REQ token
         * @property {number|Long|null} [chat_id] CMD_CS_IM_TELEGRAM_CHAT_REQ chat_id
         * @property {number|null} [offset] CMD_CS_IM_TELEGRAM_CHAT_REQ offset
         * @property {number|null} [limit] CMD_CS_IM_TELEGRAM_CHAT_REQ limit
         */

        /**
         * Constructs a new CMD_CS_IM_TELEGRAM_CHAT_REQ.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_TELEGRAM_CHAT_REQ.
         * @implements ICMD_CS_IM_TELEGRAM_CHAT_REQ
         * @constructor
         * @param {tg.ICMD_CS_IM_TELEGRAM_CHAT_REQ=} [properties] Properties to set
         */
        function CMD_CS_IM_TELEGRAM_CHAT_REQ(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_TELEGRAM_CHAT_REQ username.
         * @member {string} username
         * @memberof tg.CMD_CS_IM_TELEGRAM_CHAT_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_CHAT_REQ.prototype.username = "";

        /**
         * CMD_CS_IM_TELEGRAM_CHAT_REQ token.
         * @member {string} token
         * @memberof tg.CMD_CS_IM_TELEGRAM_CHAT_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_CHAT_REQ.prototype.token = "";

        /**
         * CMD_CS_IM_TELEGRAM_CHAT_REQ chat_id.
         * @member {number|Long} chat_id
         * @memberof tg.CMD_CS_IM_TELEGRAM_CHAT_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_CHAT_REQ.prototype.chat_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * CMD_CS_IM_TELEGRAM_CHAT_REQ offset.
         * @member {number} offset
         * @memberof tg.CMD_CS_IM_TELEGRAM_CHAT_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_CHAT_REQ.prototype.offset = 0;

        /**
         * CMD_CS_IM_TELEGRAM_CHAT_REQ limit.
         * @member {number} limit
         * @memberof tg.CMD_CS_IM_TELEGRAM_CHAT_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_CHAT_REQ.prototype.limit = 0;

        /**
         * Creates a new CMD_CS_IM_TELEGRAM_CHAT_REQ instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_TELEGRAM_CHAT_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_CHAT_REQ=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_TELEGRAM_CHAT_REQ} CMD_CS_IM_TELEGRAM_CHAT_REQ instance
         */
        CMD_CS_IM_TELEGRAM_CHAT_REQ.create = function create(properties) {
            return new CMD_CS_IM_TELEGRAM_CHAT_REQ(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_TELEGRAM_CHAT_REQ message. Does not implicitly {@link tg.CMD_CS_IM_TELEGRAM_CHAT_REQ.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_TELEGRAM_CHAT_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_CHAT_REQ} message CMD_CS_IM_TELEGRAM_CHAT_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_TELEGRAM_CHAT_REQ.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.username);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.token);
            if (message.chat_id != null && Object.hasOwnProperty.call(message, "chat_id"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.chat_id);
            if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.offset);
            if (message.limit != null && Object.hasOwnProperty.call(message, "limit"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.limit);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_TELEGRAM_CHAT_REQ message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_TELEGRAM_CHAT_REQ.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_TELEGRAM_CHAT_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_CHAT_REQ} message CMD_CS_IM_TELEGRAM_CHAT_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_TELEGRAM_CHAT_REQ.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_TELEGRAM_CHAT_REQ message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_TELEGRAM_CHAT_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_TELEGRAM_CHAT_REQ} CMD_CS_IM_TELEGRAM_CHAT_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_TELEGRAM_CHAT_REQ.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_TELEGRAM_CHAT_REQ();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.username = reader.string();
                        break;
                    }
                case 2: {
                        message.token = reader.string();
                        break;
                    }
                case 3: {
                        message.chat_id = reader.int64();
                        break;
                    }
                case 4: {
                        message.offset = reader.int32();
                        break;
                    }
                case 5: {
                        message.limit = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_TELEGRAM_CHAT_REQ message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_TELEGRAM_CHAT_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_TELEGRAM_CHAT_REQ} CMD_CS_IM_TELEGRAM_CHAT_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_TELEGRAM_CHAT_REQ.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_TELEGRAM_CHAT_REQ message.
         * @function verify
         * @memberof tg.CMD_CS_IM_TELEGRAM_CHAT_REQ
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_TELEGRAM_CHAT_REQ.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.token != null && message.hasOwnProperty("token"))
                if (!$util.isString(message.token))
                    return "token: string expected";
            if (message.chat_id != null && message.hasOwnProperty("chat_id"))
                if (!$util.isInteger(message.chat_id) && !(message.chat_id && $util.isInteger(message.chat_id.low) && $util.isInteger(message.chat_id.high)))
                    return "chat_id: integer|Long expected";
            if (message.offset != null && message.hasOwnProperty("offset"))
                if (!$util.isInteger(message.offset))
                    return "offset: integer expected";
            if (message.limit != null && message.hasOwnProperty("limit"))
                if (!$util.isInteger(message.limit))
                    return "limit: integer expected";
            return null;
        };

        /**
         * Creates a CMD_CS_IM_TELEGRAM_CHAT_REQ message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_TELEGRAM_CHAT_REQ
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_TELEGRAM_CHAT_REQ} CMD_CS_IM_TELEGRAM_CHAT_REQ
         */
        CMD_CS_IM_TELEGRAM_CHAT_REQ.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_TELEGRAM_CHAT_REQ)
                return object;
            var message = new $root.tg.CMD_CS_IM_TELEGRAM_CHAT_REQ();
            if (object.username != null)
                message.username = String(object.username);
            if (object.token != null)
                message.token = String(object.token);
            if (object.chat_id != null)
                if ($util.Long)
                    (message.chat_id = $util.Long.fromValue(object.chat_id)).unsigned = false;
                else if (typeof object.chat_id === "string")
                    message.chat_id = parseInt(object.chat_id, 10);
                else if (typeof object.chat_id === "number")
                    message.chat_id = object.chat_id;
                else if (typeof object.chat_id === "object")
                    message.chat_id = new $util.LongBits(object.chat_id.low >>> 0, object.chat_id.high >>> 0).toNumber();
            if (object.offset != null)
                message.offset = object.offset | 0;
            if (object.limit != null)
                message.limit = object.limit | 0;
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_TELEGRAM_CHAT_REQ message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_TELEGRAM_CHAT_REQ
         * @static
         * @param {tg.CMD_CS_IM_TELEGRAM_CHAT_REQ} message CMD_CS_IM_TELEGRAM_CHAT_REQ
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_TELEGRAM_CHAT_REQ.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.username = "";
                object.token = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chat_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chat_id = options.longs === String ? "0" : 0;
                object.offset = 0;
                object.limit = 0;
            }
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = message.token;
            if (message.chat_id != null && message.hasOwnProperty("chat_id"))
                if (typeof message.chat_id === "number")
                    object.chat_id = options.longs === String ? String(message.chat_id) : message.chat_id;
                else
                    object.chat_id = options.longs === String ? $util.Long.prototype.toString.call(message.chat_id) : options.longs === Number ? new $util.LongBits(message.chat_id.low >>> 0, message.chat_id.high >>> 0).toNumber() : message.chat_id;
            if (message.offset != null && message.hasOwnProperty("offset"))
                object.offset = message.offset;
            if (message.limit != null && message.hasOwnProperty("limit"))
                object.limit = message.limit;
            return object;
        };

        /**
         * Converts this CMD_CS_IM_TELEGRAM_CHAT_REQ to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_TELEGRAM_CHAT_REQ
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_TELEGRAM_CHAT_REQ.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_TELEGRAM_CHAT_REQ
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_TELEGRAM_CHAT_REQ
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_TELEGRAM_CHAT_REQ.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_TELEGRAM_CHAT_REQ";
        };

        return CMD_CS_IM_TELEGRAM_CHAT_REQ;
    })();

    tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY = (function() {

        /**
         * Properties of a CMD_SC_IM_TELEGRAM_CHAT_HISTORY.
         * @memberof tg
         * @interface ICMD_SC_IM_TELEGRAM_CHAT_HISTORY
         * @property {string|null} [recipientPhone] CMD_SC_IM_TELEGRAM_CHAT_HISTORY recipientPhone
         * @property {Array.<tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.IMessageInfo>|null} [messages] CMD_SC_IM_TELEGRAM_CHAT_HISTORY messages
         */

        /**
         * Constructs a new CMD_SC_IM_TELEGRAM_CHAT_HISTORY.
         * @memberof tg
         * @classdesc Represents a CMD_SC_IM_TELEGRAM_CHAT_HISTORY.
         * @implements ICMD_SC_IM_TELEGRAM_CHAT_HISTORY
         * @constructor
         * @param {tg.ICMD_SC_IM_TELEGRAM_CHAT_HISTORY=} [properties] Properties to set
         */
        function CMD_SC_IM_TELEGRAM_CHAT_HISTORY(properties) {
            this.messages = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_SC_IM_TELEGRAM_CHAT_HISTORY recipientPhone.
         * @member {string} recipientPhone
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY
         * @instance
         */
        CMD_SC_IM_TELEGRAM_CHAT_HISTORY.prototype.recipientPhone = "";

        /**
         * CMD_SC_IM_TELEGRAM_CHAT_HISTORY messages.
         * @member {Array.<tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.IMessageInfo>} messages
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY
         * @instance
         */
        CMD_SC_IM_TELEGRAM_CHAT_HISTORY.prototype.messages = $util.emptyArray;

        /**
         * Creates a new CMD_SC_IM_TELEGRAM_CHAT_HISTORY instance using the specified properties.
         * @function create
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY
         * @static
         * @param {tg.ICMD_SC_IM_TELEGRAM_CHAT_HISTORY=} [properties] Properties to set
         * @returns {tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY} CMD_SC_IM_TELEGRAM_CHAT_HISTORY instance
         */
        CMD_SC_IM_TELEGRAM_CHAT_HISTORY.create = function create(properties) {
            return new CMD_SC_IM_TELEGRAM_CHAT_HISTORY(properties);
        };

        /**
         * Encodes the specified CMD_SC_IM_TELEGRAM_CHAT_HISTORY message. Does not implicitly {@link tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY
         * @static
         * @param {tg.ICMD_SC_IM_TELEGRAM_CHAT_HISTORY} message CMD_SC_IM_TELEGRAM_CHAT_HISTORY message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_IM_TELEGRAM_CHAT_HISTORY.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.recipientPhone != null && Object.hasOwnProperty.call(message, "recipientPhone"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.recipientPhone);
            if (message.messages != null && message.messages.length)
                for (var i = 0; i < message.messages.length; ++i)
                    $root.tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo.encode(message.messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CMD_SC_IM_TELEGRAM_CHAT_HISTORY message, length delimited. Does not implicitly {@link tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY
         * @static
         * @param {tg.ICMD_SC_IM_TELEGRAM_CHAT_HISTORY} message CMD_SC_IM_TELEGRAM_CHAT_HISTORY message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_IM_TELEGRAM_CHAT_HISTORY.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_SC_IM_TELEGRAM_CHAT_HISTORY message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY} CMD_SC_IM_TELEGRAM_CHAT_HISTORY
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_IM_TELEGRAM_CHAT_HISTORY.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.recipientPhone = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.messages && message.messages.length))
                            message.messages = [];
                        message.messages.push($root.tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_SC_IM_TELEGRAM_CHAT_HISTORY message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY} CMD_SC_IM_TELEGRAM_CHAT_HISTORY
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_IM_TELEGRAM_CHAT_HISTORY.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_SC_IM_TELEGRAM_CHAT_HISTORY message.
         * @function verify
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_SC_IM_TELEGRAM_CHAT_HISTORY.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.recipientPhone != null && message.hasOwnProperty("recipientPhone"))
                if (!$util.isString(message.recipientPhone))
                    return "recipientPhone: string expected";
            if (message.messages != null && message.hasOwnProperty("messages")) {
                if (!Array.isArray(message.messages))
                    return "messages: array expected";
                for (var i = 0; i < message.messages.length; ++i) {
                    var error = $root.tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo.verify(message.messages[i]);
                    if (error)
                        return "messages." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CMD_SC_IM_TELEGRAM_CHAT_HISTORY message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY} CMD_SC_IM_TELEGRAM_CHAT_HISTORY
         */
        CMD_SC_IM_TELEGRAM_CHAT_HISTORY.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY)
                return object;
            var message = new $root.tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY();
            if (object.recipientPhone != null)
                message.recipientPhone = String(object.recipientPhone);
            if (object.messages) {
                if (!Array.isArray(object.messages))
                    throw TypeError(".tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.messages: array expected");
                message.messages = [];
                for (var i = 0; i < object.messages.length; ++i) {
                    if (typeof object.messages[i] !== "object")
                        throw TypeError(".tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.messages: object expected");
                    message.messages[i] = $root.tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo.fromObject(object.messages[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CMD_SC_IM_TELEGRAM_CHAT_HISTORY message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY
         * @static
         * @param {tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY} message CMD_SC_IM_TELEGRAM_CHAT_HISTORY
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_SC_IM_TELEGRAM_CHAT_HISTORY.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.messages = [];
            if (options.defaults)
                object.recipientPhone = "";
            if (message.recipientPhone != null && message.hasOwnProperty("recipientPhone"))
                object.recipientPhone = message.recipientPhone;
            if (message.messages && message.messages.length) {
                object.messages = [];
                for (var j = 0; j < message.messages.length; ++j)
                    object.messages[j] = $root.tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo.toObject(message.messages[j], options);
            }
            return object;
        };

        /**
         * Converts this CMD_SC_IM_TELEGRAM_CHAT_HISTORY to JSON.
         * @function toJSON
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_SC_IM_TELEGRAM_CHAT_HISTORY.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_SC_IM_TELEGRAM_CHAT_HISTORY
         * @function getTypeUrl
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_SC_IM_TELEGRAM_CHAT_HISTORY.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY";
        };

        CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo = (function() {

            /**
             * Properties of a MessageInfo.
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY
             * @interface IMessageInfo
             * @property {number|Long|null} [senderId] MessageInfo senderId
             * @property {number|null} [type] MessageInfo type
             * @property {string|null} [title] MessageInfo title
             * @property {string|null} [last_message] MessageInfo last_message
             */

            /**
             * Constructs a new MessageInfo.
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY
             * @classdesc Represents a MessageInfo.
             * @implements IMessageInfo
             * @constructor
             * @param {tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.IMessageInfo=} [properties] Properties to set
             */
            function MessageInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MessageInfo senderId.
             * @member {number|Long} senderId
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo
             * @instance
             */
            MessageInfo.prototype.senderId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * MessageInfo type.
             * @member {number} type
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo
             * @instance
             */
            MessageInfo.prototype.type = 0;

            /**
             * MessageInfo title.
             * @member {string} title
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo
             * @instance
             */
            MessageInfo.prototype.title = "";

            /**
             * MessageInfo last_message.
             * @member {string} last_message
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo
             * @instance
             */
            MessageInfo.prototype.last_message = "";

            /**
             * Creates a new MessageInfo instance using the specified properties.
             * @function create
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo
             * @static
             * @param {tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.IMessageInfo=} [properties] Properties to set
             * @returns {tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo} MessageInfo instance
             */
            MessageInfo.create = function create(properties) {
                return new MessageInfo(properties);
            };

            /**
             * Encodes the specified MessageInfo message. Does not implicitly {@link tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo.verify|verify} messages.
             * @function encode
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo
             * @static
             * @param {tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.IMessageInfo} message MessageInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MessageInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.senderId != null && Object.hasOwnProperty.call(message, "senderId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.senderId);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
                if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.title);
                if (message.last_message != null && Object.hasOwnProperty.call(message, "last_message"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.last_message);
                return writer;
            };

            /**
             * Encodes the specified MessageInfo message, length delimited. Does not implicitly {@link tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo
             * @static
             * @param {tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.IMessageInfo} message MessageInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MessageInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MessageInfo message from the specified reader or buffer.
             * @function decode
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo} MessageInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MessageInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.senderId = reader.int64();
                            break;
                        }
                    case 2: {
                            message.type = reader.int32();
                            break;
                        }
                    case 3: {
                            message.title = reader.string();
                            break;
                        }
                    case 4: {
                            message.last_message = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MessageInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo} MessageInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MessageInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MessageInfo message.
             * @function verify
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MessageInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.senderId != null && message.hasOwnProperty("senderId"))
                    if (!$util.isInteger(message.senderId) && !(message.senderId && $util.isInteger(message.senderId.low) && $util.isInteger(message.senderId.high)))
                        return "senderId: integer|Long expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.title != null && message.hasOwnProperty("title"))
                    if (!$util.isString(message.title))
                        return "title: string expected";
                if (message.last_message != null && message.hasOwnProperty("last_message"))
                    if (!$util.isString(message.last_message))
                        return "last_message: string expected";
                return null;
            };

            /**
             * Creates a MessageInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo} MessageInfo
             */
            MessageInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo)
                    return object;
                var message = new $root.tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo();
                if (object.senderId != null)
                    if ($util.Long)
                        (message.senderId = $util.Long.fromValue(object.senderId)).unsigned = false;
                    else if (typeof object.senderId === "string")
                        message.senderId = parseInt(object.senderId, 10);
                    else if (typeof object.senderId === "number")
                        message.senderId = object.senderId;
                    else if (typeof object.senderId === "object")
                        message.senderId = new $util.LongBits(object.senderId.low >>> 0, object.senderId.high >>> 0).toNumber();
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.title != null)
                    message.title = String(object.title);
                if (object.last_message != null)
                    message.last_message = String(object.last_message);
                return message;
            };

            /**
             * Creates a plain object from a MessageInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo
             * @static
             * @param {tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo} message MessageInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MessageInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.senderId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.senderId = options.longs === String ? "0" : 0;
                    object.type = 0;
                    object.title = "";
                    object.last_message = "";
                }
                if (message.senderId != null && message.hasOwnProperty("senderId"))
                    if (typeof message.senderId === "number")
                        object.senderId = options.longs === String ? String(message.senderId) : message.senderId;
                    else
                        object.senderId = options.longs === String ? $util.Long.prototype.toString.call(message.senderId) : options.longs === Number ? new $util.LongBits(message.senderId.low >>> 0, message.senderId.high >>> 0).toNumber() : message.senderId;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.title != null && message.hasOwnProperty("title"))
                    object.title = message.title;
                if (message.last_message != null && message.hasOwnProperty("last_message"))
                    object.last_message = message.last_message;
                return object;
            };

            /**
             * Converts this MessageInfo to JSON.
             * @function toJSON
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MessageInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MessageInfo
             * @function getTypeUrl
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MessageInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY.MessageInfo";
            };

            return MessageInfo;
        })();

        return CMD_SC_IM_TELEGRAM_CHAT_HISTORY;
    })();

    tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY = (function() {

        /**
         * Properties of a CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.
         * @memberof tg
         * @interface ICMD_SC_IM_TELEGRAM_CHAT_NOTIFY
         * @property {string|null} [recipientPhone] CMD_SC_IM_TELEGRAM_CHAT_NOTIFY recipientPhone
         * @property {Array.<tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.IMessageInfo>|null} [messages] CMD_SC_IM_TELEGRAM_CHAT_NOTIFY messages
         */

        /**
         * Constructs a new CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.
         * @memberof tg
         * @classdesc Represents a CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.
         * @implements ICMD_SC_IM_TELEGRAM_CHAT_NOTIFY
         * @constructor
         * @param {tg.ICMD_SC_IM_TELEGRAM_CHAT_NOTIFY=} [properties] Properties to set
         */
        function CMD_SC_IM_TELEGRAM_CHAT_NOTIFY(properties) {
            this.messages = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_SC_IM_TELEGRAM_CHAT_NOTIFY recipientPhone.
         * @member {string} recipientPhone
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY
         * @instance
         */
        CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.prototype.recipientPhone = "";

        /**
         * CMD_SC_IM_TELEGRAM_CHAT_NOTIFY messages.
         * @member {Array.<tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.IMessageInfo>} messages
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY
         * @instance
         */
        CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.prototype.messages = $util.emptyArray;

        /**
         * Creates a new CMD_SC_IM_TELEGRAM_CHAT_NOTIFY instance using the specified properties.
         * @function create
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY
         * @static
         * @param {tg.ICMD_SC_IM_TELEGRAM_CHAT_NOTIFY=} [properties] Properties to set
         * @returns {tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY} CMD_SC_IM_TELEGRAM_CHAT_NOTIFY instance
         */
        CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.create = function create(properties) {
            return new CMD_SC_IM_TELEGRAM_CHAT_NOTIFY(properties);
        };

        /**
         * Encodes the specified CMD_SC_IM_TELEGRAM_CHAT_NOTIFY message. Does not implicitly {@link tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY
         * @static
         * @param {tg.ICMD_SC_IM_TELEGRAM_CHAT_NOTIFY} message CMD_SC_IM_TELEGRAM_CHAT_NOTIFY message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.recipientPhone != null && Object.hasOwnProperty.call(message, "recipientPhone"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.recipientPhone);
            if (message.messages != null && message.messages.length)
                for (var i = 0; i < message.messages.length; ++i)
                    $root.tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo.encode(message.messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CMD_SC_IM_TELEGRAM_CHAT_NOTIFY message, length delimited. Does not implicitly {@link tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY
         * @static
         * @param {tg.ICMD_SC_IM_TELEGRAM_CHAT_NOTIFY} message CMD_SC_IM_TELEGRAM_CHAT_NOTIFY message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_SC_IM_TELEGRAM_CHAT_NOTIFY message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY} CMD_SC_IM_TELEGRAM_CHAT_NOTIFY
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.recipientPhone = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.messages && message.messages.length))
                            message.messages = [];
                        message.messages.push($root.tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_SC_IM_TELEGRAM_CHAT_NOTIFY message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY} CMD_SC_IM_TELEGRAM_CHAT_NOTIFY
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_SC_IM_TELEGRAM_CHAT_NOTIFY message.
         * @function verify
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.recipientPhone != null && message.hasOwnProperty("recipientPhone"))
                if (!$util.isString(message.recipientPhone))
                    return "recipientPhone: string expected";
            if (message.messages != null && message.hasOwnProperty("messages")) {
                if (!Array.isArray(message.messages))
                    return "messages: array expected";
                for (var i = 0; i < message.messages.length; ++i) {
                    var error = $root.tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo.verify(message.messages[i]);
                    if (error)
                        return "messages." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CMD_SC_IM_TELEGRAM_CHAT_NOTIFY message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY} CMD_SC_IM_TELEGRAM_CHAT_NOTIFY
         */
        CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY)
                return object;
            var message = new $root.tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY();
            if (object.recipientPhone != null)
                message.recipientPhone = String(object.recipientPhone);
            if (object.messages) {
                if (!Array.isArray(object.messages))
                    throw TypeError(".tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.messages: array expected");
                message.messages = [];
                for (var i = 0; i < object.messages.length; ++i) {
                    if (typeof object.messages[i] !== "object")
                        throw TypeError(".tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.messages: object expected");
                    message.messages[i] = $root.tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo.fromObject(object.messages[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CMD_SC_IM_TELEGRAM_CHAT_NOTIFY message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY
         * @static
         * @param {tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY} message CMD_SC_IM_TELEGRAM_CHAT_NOTIFY
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.messages = [];
            if (options.defaults)
                object.recipientPhone = "";
            if (message.recipientPhone != null && message.hasOwnProperty("recipientPhone"))
                object.recipientPhone = message.recipientPhone;
            if (message.messages && message.messages.length) {
                object.messages = [];
                for (var j = 0; j < message.messages.length; ++j)
                    object.messages[j] = $root.tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo.toObject(message.messages[j], options);
            }
            return object;
        };

        /**
         * Converts this CMD_SC_IM_TELEGRAM_CHAT_NOTIFY to JSON.
         * @function toJSON
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_SC_IM_TELEGRAM_CHAT_NOTIFY
         * @function getTypeUrl
         * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY";
        };

        CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo = (function() {

            /**
             * Properties of a MessageInfo.
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY
             * @interface IMessageInfo
             * @property {number|Long|null} [messageId] MessageInfo messageId
             * @property {number|Long|null} [timestamp] MessageInfo timestamp
             * @property {number|Long|null} [senderId] MessageInfo senderId
             * @property {number|null} [type] MessageInfo type
             * @property {string|null} [content] MessageInfo content
             * @property {string|null} [senderName] MessageInfo senderName
             */

            /**
             * Constructs a new MessageInfo.
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY
             * @classdesc Represents a MessageInfo.
             * @implements IMessageInfo
             * @constructor
             * @param {tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.IMessageInfo=} [properties] Properties to set
             */
            function MessageInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MessageInfo messageId.
             * @member {number|Long} messageId
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo
             * @instance
             */
            MessageInfo.prototype.messageId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * MessageInfo timestamp.
             * @member {number|Long} timestamp
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo
             * @instance
             */
            MessageInfo.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * MessageInfo senderId.
             * @member {number|Long} senderId
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo
             * @instance
             */
            MessageInfo.prototype.senderId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * MessageInfo type.
             * @member {number} type
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo
             * @instance
             */
            MessageInfo.prototype.type = 0;

            /**
             * MessageInfo content.
             * @member {string} content
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo
             * @instance
             */
            MessageInfo.prototype.content = "";

            /**
             * MessageInfo senderName.
             * @member {string} senderName
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo
             * @instance
             */
            MessageInfo.prototype.senderName = "";

            /**
             * Creates a new MessageInfo instance using the specified properties.
             * @function create
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo
             * @static
             * @param {tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.IMessageInfo=} [properties] Properties to set
             * @returns {tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo} MessageInfo instance
             */
            MessageInfo.create = function create(properties) {
                return new MessageInfo(properties);
            };

            /**
             * Encodes the specified MessageInfo message. Does not implicitly {@link tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo.verify|verify} messages.
             * @function encode
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo
             * @static
             * @param {tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.IMessageInfo} message MessageInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MessageInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.messageId);
                if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.timestamp);
                if (message.senderId != null && Object.hasOwnProperty.call(message, "senderId"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int64(message.senderId);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.type);
                if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.content);
                if (message.senderName != null && Object.hasOwnProperty.call(message, "senderName"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.senderName);
                return writer;
            };

            /**
             * Encodes the specified MessageInfo message, length delimited. Does not implicitly {@link tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo
             * @static
             * @param {tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.IMessageInfo} message MessageInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MessageInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MessageInfo message from the specified reader or buffer.
             * @function decode
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo} MessageInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MessageInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.messageId = reader.int64();
                            break;
                        }
                    case 2: {
                            message.timestamp = reader.int64();
                            break;
                        }
                    case 3: {
                            message.senderId = reader.int64();
                            break;
                        }
                    case 4: {
                            message.type = reader.int32();
                            break;
                        }
                    case 5: {
                            message.content = reader.string();
                            break;
                        }
                    case 6: {
                            message.senderName = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MessageInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo} MessageInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MessageInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MessageInfo message.
             * @function verify
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MessageInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.messageId != null && message.hasOwnProperty("messageId"))
                    if (!$util.isInteger(message.messageId) && !(message.messageId && $util.isInteger(message.messageId.low) && $util.isInteger(message.messageId.high)))
                        return "messageId: integer|Long expected";
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                        return "timestamp: integer|Long expected";
                if (message.senderId != null && message.hasOwnProperty("senderId"))
                    if (!$util.isInteger(message.senderId) && !(message.senderId && $util.isInteger(message.senderId.low) && $util.isInteger(message.senderId.high)))
                        return "senderId: integer|Long expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.content != null && message.hasOwnProperty("content"))
                    if (!$util.isString(message.content))
                        return "content: string expected";
                if (message.senderName != null && message.hasOwnProperty("senderName"))
                    if (!$util.isString(message.senderName))
                        return "senderName: string expected";
                return null;
            };

            /**
             * Creates a MessageInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo} MessageInfo
             */
            MessageInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo)
                    return object;
                var message = new $root.tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo();
                if (object.messageId != null)
                    if ($util.Long)
                        (message.messageId = $util.Long.fromValue(object.messageId)).unsigned = false;
                    else if (typeof object.messageId === "string")
                        message.messageId = parseInt(object.messageId, 10);
                    else if (typeof object.messageId === "number")
                        message.messageId = object.messageId;
                    else if (typeof object.messageId === "object")
                        message.messageId = new $util.LongBits(object.messageId.low >>> 0, object.messageId.high >>> 0).toNumber();
                if (object.timestamp != null)
                    if ($util.Long)
                        (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = false;
                    else if (typeof object.timestamp === "string")
                        message.timestamp = parseInt(object.timestamp, 10);
                    else if (typeof object.timestamp === "number")
                        message.timestamp = object.timestamp;
                    else if (typeof object.timestamp === "object")
                        message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber();
                if (object.senderId != null)
                    if ($util.Long)
                        (message.senderId = $util.Long.fromValue(object.senderId)).unsigned = false;
                    else if (typeof object.senderId === "string")
                        message.senderId = parseInt(object.senderId, 10);
                    else if (typeof object.senderId === "number")
                        message.senderId = object.senderId;
                    else if (typeof object.senderId === "object")
                        message.senderId = new $util.LongBits(object.senderId.low >>> 0, object.senderId.high >>> 0).toNumber();
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.content != null)
                    message.content = String(object.content);
                if (object.senderName != null)
                    message.senderName = String(object.senderName);
                return message;
            };

            /**
             * Creates a plain object from a MessageInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo
             * @static
             * @param {tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo} message MessageInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MessageInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.messageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.messageId = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.timestamp = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.senderId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.senderId = options.longs === String ? "0" : 0;
                    object.type = 0;
                    object.content = "";
                    object.senderName = "";
                }
                if (message.messageId != null && message.hasOwnProperty("messageId"))
                    if (typeof message.messageId === "number")
                        object.messageId = options.longs === String ? String(message.messageId) : message.messageId;
                    else
                        object.messageId = options.longs === String ? $util.Long.prototype.toString.call(message.messageId) : options.longs === Number ? new $util.LongBits(message.messageId.low >>> 0, message.messageId.high >>> 0).toNumber() : message.messageId;
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (typeof message.timestamp === "number")
                        object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                    else
                        object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber() : message.timestamp;
                if (message.senderId != null && message.hasOwnProperty("senderId"))
                    if (typeof message.senderId === "number")
                        object.senderId = options.longs === String ? String(message.senderId) : message.senderId;
                    else
                        object.senderId = options.longs === String ? $util.Long.prototype.toString.call(message.senderId) : options.longs === Number ? new $util.LongBits(message.senderId.low >>> 0, message.senderId.high >>> 0).toNumber() : message.senderId;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.content != null && message.hasOwnProperty("content"))
                    object.content = message.content;
                if (message.senderName != null && message.hasOwnProperty("senderName"))
                    object.senderName = message.senderName;
                return object;
            };

            /**
             * Converts this MessageInfo to JSON.
             * @function toJSON
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MessageInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MessageInfo
             * @function getTypeUrl
             * @memberof tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MessageInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY.MessageInfo";
            };

            return MessageInfo;
        })();

        return CMD_SC_IM_TELEGRAM_CHAT_NOTIFY;
    })();

    tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ = (function() {

        /**
         * Properties of a CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.
         * @memberof tg
         * @interface ICMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @property {string|null} [admin] CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ admin
         * @property {string|null} [phone] CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ phone
         * @property {number|Long|null} [chat_id] CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ chat_id
         * @property {number|null} [offset] CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ offset
         * @property {number|null} [limit] CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ limit
         */

        /**
         * Constructs a new CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.
         * @implements ICMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @constructor
         * @param {tg.ICMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ=} [properties] Properties to set
         */
        function CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ admin.
         * @member {string} admin
         * @memberof tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.prototype.admin = "";

        /**
         * CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ phone.
         * @member {string} phone
         * @memberof tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.prototype.phone = "";

        /**
         * CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ chat_id.
         * @member {number|Long} chat_id
         * @memberof tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.prototype.chat_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ offset.
         * @member {number} offset
         * @memberof tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.prototype.offset = 0;

        /**
         * CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ limit.
         * @member {number} limit
         * @memberof tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.prototype.limit = 0;

        /**
         * Creates a new CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ} CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ instance
         */
        CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.create = function create(properties) {
            return new CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ message. Does not implicitly {@link tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ} message CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.admin != null && Object.hasOwnProperty.call(message, "admin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.admin);
            if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.phone);
            if (message.chat_id != null && Object.hasOwnProperty.call(message, "chat_id"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.chat_id);
            if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.offset);
            if (message.limit != null && Object.hasOwnProperty.call(message, "limit"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.limit);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ} message CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ} CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.admin = reader.string();
                        break;
                    }
                case 2: {
                        message.phone = reader.string();
                        break;
                    }
                case 3: {
                        message.chat_id = reader.int64();
                        break;
                    }
                case 4: {
                        message.offset = reader.int32();
                        break;
                    }
                case 5: {
                        message.limit = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ} CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ message.
         * @function verify
         * @memberof tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.admin != null && message.hasOwnProperty("admin"))
                if (!$util.isString(message.admin))
                    return "admin: string expected";
            if (message.phone != null && message.hasOwnProperty("phone"))
                if (!$util.isString(message.phone))
                    return "phone: string expected";
            if (message.chat_id != null && message.hasOwnProperty("chat_id"))
                if (!$util.isInteger(message.chat_id) && !(message.chat_id && $util.isInteger(message.chat_id.low) && $util.isInteger(message.chat_id.high)))
                    return "chat_id: integer|Long expected";
            if (message.offset != null && message.hasOwnProperty("offset"))
                if (!$util.isInteger(message.offset))
                    return "offset: integer expected";
            if (message.limit != null && message.hasOwnProperty("limit"))
                if (!$util.isInteger(message.limit))
                    return "limit: integer expected";
            return null;
        };

        /**
         * Creates a CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ} CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         */
        CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ)
                return object;
            var message = new $root.tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ();
            if (object.admin != null)
                message.admin = String(object.admin);
            if (object.phone != null)
                message.phone = String(object.phone);
            if (object.chat_id != null)
                if ($util.Long)
                    (message.chat_id = $util.Long.fromValue(object.chat_id)).unsigned = false;
                else if (typeof object.chat_id === "string")
                    message.chat_id = parseInt(object.chat_id, 10);
                else if (typeof object.chat_id === "number")
                    message.chat_id = object.chat_id;
                else if (typeof object.chat_id === "object")
                    message.chat_id = new $util.LongBits(object.chat_id.low >>> 0, object.chat_id.high >>> 0).toNumber();
            if (object.offset != null)
                message.offset = object.offset | 0;
            if (object.limit != null)
                message.limit = object.limit | 0;
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @static
         * @param {tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ} message CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.admin = "";
                object.phone = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chat_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chat_id = options.longs === String ? "0" : 0;
                object.offset = 0;
                object.limit = 0;
            }
            if (message.admin != null && message.hasOwnProperty("admin"))
                object.admin = message.admin;
            if (message.phone != null && message.hasOwnProperty("phone"))
                object.phone = message.phone;
            if (message.chat_id != null && message.hasOwnProperty("chat_id"))
                if (typeof message.chat_id === "number")
                    object.chat_id = options.longs === String ? String(message.chat_id) : message.chat_id;
                else
                    object.chat_id = options.longs === String ? $util.Long.prototype.toString.call(message.chat_id) : options.longs === Number ? new $util.LongBits(message.chat_id.low >>> 0, message.chat_id.high >>> 0).toNumber() : message.chat_id;
            if (message.offset != null && message.hasOwnProperty("offset"))
                object.offset = message.offset;
            if (message.limit != null && message.hasOwnProperty("limit"))
                object.limit = message.limit;
            return object;
        };

        /**
         * Converts this CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ";
        };

        return CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ;
    })();

    tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ = (function() {

        /**
         * Properties of a CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ.
         * @memberof tg
         * @interface ICMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ
         * @property {string|null} [admin] CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ admin
         * @property {string|null} [phone] CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ phone
         */

        /**
         * Constructs a new CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ.
         * @implements ICMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ
         * @constructor
         * @param {tg.ICMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ=} [properties] Properties to set
         */
        function CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ admin.
         * @member {string} admin
         * @memberof tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ.prototype.admin = "";

        /**
         * CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ phone.
         * @member {string} phone
         * @memberof tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ.prototype.phone = "";

        /**
         * Creates a new CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ} CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ instance
         */
        CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ.create = function create(properties) {
            return new CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ message. Does not implicitly {@link tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ} message CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.admin != null && Object.hasOwnProperty.call(message, "admin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.admin);
            if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.phone);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ} message CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ} CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.admin = reader.string();
                        break;
                    }
                case 2: {
                        message.phone = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ} CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ message.
         * @function verify
         * @memberof tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.admin != null && message.hasOwnProperty("admin"))
                if (!$util.isString(message.admin))
                    return "admin: string expected";
            if (message.phone != null && message.hasOwnProperty("phone"))
                if (!$util.isString(message.phone))
                    return "phone: string expected";
            return null;
        };

        /**
         * Creates a CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ} CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ
         */
        CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ)
                return object;
            var message = new $root.tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ();
            if (object.admin != null)
                message.admin = String(object.admin);
            if (object.phone != null)
                message.phone = String(object.phone);
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ
         * @static
         * @param {tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ} message CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.admin = "";
                object.phone = "";
            }
            if (message.admin != null && message.hasOwnProperty("admin"))
                object.admin = message.admin;
            if (message.phone != null && message.hasOwnProperty("phone"))
                object.phone = message.phone;
            return object;
        };

        /**
         * Converts this CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ";
        };

        return CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ;
    })();

    tg.UserInfo = (function() {

        /**
         * Properties of a UserInfo.
         * @memberof tg
         * @interface IUserInfo
         * @property {number|Long|null} [userId] UserInfo userId
         * @property {string|null} [phone] UserInfo phone
         * @property {string|null} [userName] UserInfo userName
         * @property {string|null} [userNick] UserInfo userNick
         * @property {boolean|null} [isContact] UserInfo isContact
         */

        /**
         * Constructs a new UserInfo.
         * @memberof tg
         * @classdesc Represents a UserInfo.
         * @implements IUserInfo
         * @constructor
         * @param {tg.IUserInfo=} [properties] Properties to set
         */
        function UserInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserInfo userId.
         * @member {number|Long} userId
         * @memberof tg.UserInfo
         * @instance
         */
        UserInfo.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * UserInfo phone.
         * @member {string} phone
         * @memberof tg.UserInfo
         * @instance
         */
        UserInfo.prototype.phone = "";

        /**
         * UserInfo userName.
         * @member {string} userName
         * @memberof tg.UserInfo
         * @instance
         */
        UserInfo.prototype.userName = "";

        /**
         * UserInfo userNick.
         * @member {string} userNick
         * @memberof tg.UserInfo
         * @instance
         */
        UserInfo.prototype.userNick = "";

        /**
         * UserInfo isContact.
         * @member {boolean} isContact
         * @memberof tg.UserInfo
         * @instance
         */
        UserInfo.prototype.isContact = false;

        /**
         * Creates a new UserInfo instance using the specified properties.
         * @function create
         * @memberof tg.UserInfo
         * @static
         * @param {tg.IUserInfo=} [properties] Properties to set
         * @returns {tg.UserInfo} UserInfo instance
         */
        UserInfo.create = function create(properties) {
            return new UserInfo(properties);
        };

        /**
         * Encodes the specified UserInfo message. Does not implicitly {@link tg.UserInfo.verify|verify} messages.
         * @function encode
         * @memberof tg.UserInfo
         * @static
         * @param {tg.IUserInfo} message UserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.userId);
            if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.phone);
            if (message.userName != null && Object.hasOwnProperty.call(message, "userName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.userName);
            if (message.userNick != null && Object.hasOwnProperty.call(message, "userNick"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.userNick);
            if (message.isContact != null && Object.hasOwnProperty.call(message, "isContact"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isContact);
            return writer;
        };

        /**
         * Encodes the specified UserInfo message, length delimited. Does not implicitly {@link tg.UserInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.UserInfo
         * @static
         * @param {tg.IUserInfo} message UserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UserInfo message from the specified reader or buffer.
         * @function decode
         * @memberof tg.UserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.UserInfo} UserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.UserInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.userId = reader.int64();
                        break;
                    }
                case 2: {
                        message.phone = reader.string();
                        break;
                    }
                case 3: {
                        message.userName = reader.string();
                        break;
                    }
                case 4: {
                        message.userNick = reader.string();
                        break;
                    }
                case 5: {
                        message.isContact = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UserInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.UserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.UserInfo} UserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UserInfo message.
         * @function verify
         * @memberof tg.UserInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UserInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (!$util.isInteger(message.userId) && !(message.userId && $util.isInteger(message.userId.low) && $util.isInteger(message.userId.high)))
                    return "userId: integer|Long expected";
            if (message.phone != null && message.hasOwnProperty("phone"))
                if (!$util.isString(message.phone))
                    return "phone: string expected";
            if (message.userName != null && message.hasOwnProperty("userName"))
                if (!$util.isString(message.userName))
                    return "userName: string expected";
            if (message.userNick != null && message.hasOwnProperty("userNick"))
                if (!$util.isString(message.userNick))
                    return "userNick: string expected";
            if (message.isContact != null && message.hasOwnProperty("isContact"))
                if (typeof message.isContact !== "boolean")
                    return "isContact: boolean expected";
            return null;
        };

        /**
         * Creates a UserInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.UserInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.UserInfo} UserInfo
         */
        UserInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.UserInfo)
                return object;
            var message = new $root.tg.UserInfo();
            if (object.userId != null)
                if ($util.Long)
                    (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
                else if (typeof object.userId === "string")
                    message.userId = parseInt(object.userId, 10);
                else if (typeof object.userId === "number")
                    message.userId = object.userId;
                else if (typeof object.userId === "object")
                    message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
            if (object.phone != null)
                message.phone = String(object.phone);
            if (object.userName != null)
                message.userName = String(object.userName);
            if (object.userNick != null)
                message.userNick = String(object.userNick);
            if (object.isContact != null)
                message.isContact = Boolean(object.isContact);
            return message;
        };

        /**
         * Creates a plain object from a UserInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.UserInfo
         * @static
         * @param {tg.UserInfo} message UserInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.userId = options.longs === String ? "0" : 0;
                object.phone = "";
                object.userName = "";
                object.userNick = "";
                object.isContact = false;
            }
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (typeof message.userId === "number")
                    object.userId = options.longs === String ? String(message.userId) : message.userId;
                else
                    object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
            if (message.phone != null && message.hasOwnProperty("phone"))
                object.phone = message.phone;
            if (message.userName != null && message.hasOwnProperty("userName"))
                object.userName = message.userName;
            if (message.userNick != null && message.hasOwnProperty("userNick"))
                object.userNick = message.userNick;
            if (message.isContact != null && message.hasOwnProperty("isContact"))
                object.isContact = message.isContact;
            return object;
        };

        /**
         * Converts this UserInfo to JSON.
         * @function toJSON
         * @memberof tg.UserInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UserInfo
         * @function getTypeUrl
         * @memberof tg.UserInfo
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UserInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.UserInfo";
        };

        return UserInfo;
    })();

    tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP = (function() {

        /**
         * Properties of a CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP.
         * @memberof tg
         * @interface ICMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP
         * @property {string|null} [recipientPhone] CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP recipientPhone
         * @property {Array.<tg.IUserInfo>|null} [list] CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP list
         */

        /**
         * Constructs a new CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP.
         * @memberof tg
         * @classdesc Represents a CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP.
         * @implements ICMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP
         * @constructor
         * @param {tg.ICMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP=} [properties] Properties to set
         */
        function CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP(properties) {
            this.list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP recipientPhone.
         * @member {string} recipientPhone
         * @memberof tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP
         * @instance
         */
        CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP.prototype.recipientPhone = "";

        /**
         * CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP list.
         * @member {Array.<tg.IUserInfo>} list
         * @memberof tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP
         * @instance
         */
        CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP.prototype.list = $util.emptyArray;

        /**
         * Creates a new CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP instance using the specified properties.
         * @function create
         * @memberof tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP
         * @static
         * @param {tg.ICMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP=} [properties] Properties to set
         * @returns {tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP} CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP instance
         */
        CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP.create = function create(properties) {
            return new CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP(properties);
        };

        /**
         * Encodes the specified CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP message. Does not implicitly {@link tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP
         * @static
         * @param {tg.ICMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP} message CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.recipientPhone != null && Object.hasOwnProperty.call(message, "recipientPhone"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.recipientPhone);
            if (message.list != null && message.list.length)
                for (var i = 0; i < message.list.length; ++i)
                    $root.tg.UserInfo.encode(message.list[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP message, length delimited. Does not implicitly {@link tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP
         * @static
         * @param {tg.ICMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP} message CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP} CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.recipientPhone = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.tg.UserInfo.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP} CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP message.
         * @function verify
         * @memberof tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.recipientPhone != null && message.hasOwnProperty("recipientPhone"))
                if (!$util.isString(message.recipientPhone))
                    return "recipientPhone: string expected";
            if (message.list != null && message.hasOwnProperty("list")) {
                if (!Array.isArray(message.list))
                    return "list: array expected";
                for (var i = 0; i < message.list.length; ++i) {
                    var error = $root.tg.UserInfo.verify(message.list[i]);
                    if (error)
                        return "list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP} CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP
         */
        CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP)
                return object;
            var message = new $root.tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP();
            if (object.recipientPhone != null)
                message.recipientPhone = String(object.recipientPhone);
            if (object.list) {
                if (!Array.isArray(object.list))
                    throw TypeError(".tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP.list: array expected");
                message.list = [];
                for (var i = 0; i < object.list.length; ++i) {
                    if (typeof object.list[i] !== "object")
                        throw TypeError(".tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP.list: object expected");
                    message.list[i] = $root.tg.UserInfo.fromObject(object.list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP
         * @static
         * @param {tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP} message CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.list = [];
            if (options.defaults)
                object.recipientPhone = "";
            if (message.recipientPhone != null && message.hasOwnProperty("recipientPhone"))
                object.recipientPhone = message.recipientPhone;
            if (message.list && message.list.length) {
                object.list = [];
                for (var j = 0; j < message.list.length; ++j)
                    object.list[j] = $root.tg.UserInfo.toObject(message.list[j], options);
            }
            return object;
        };

        /**
         * Converts this CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP to JSON.
         * @function toJSON
         * @memberof tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP
         * @function getTypeUrl
         * @memberof tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP";
        };

        return CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP;
    })();

    tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ = (function() {

        /**
         * Properties of a CMD_CS_IM_TELEGRAM_SEARCH_REQ.
         * @memberof tg
         * @interface ICMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @property {string|null} [admin] CMD_CS_IM_TELEGRAM_SEARCH_REQ admin
         * @property {string|null} [phone] CMD_CS_IM_TELEGRAM_SEARCH_REQ phone
         * @property {string|null} [query] CMD_CS_IM_TELEGRAM_SEARCH_REQ query
         * @property {number|null} [limit] CMD_CS_IM_TELEGRAM_SEARCH_REQ limit
         */

        /**
         * Constructs a new CMD_CS_IM_TELEGRAM_SEARCH_REQ.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_TELEGRAM_SEARCH_REQ.
         * @implements ICMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @constructor
         * @param {tg.ICMD_CS_IM_TELEGRAM_SEARCH_REQ=} [properties] Properties to set
         */
        function CMD_CS_IM_TELEGRAM_SEARCH_REQ(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_TELEGRAM_SEARCH_REQ admin.
         * @member {string} admin
         * @memberof tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_SEARCH_REQ.prototype.admin = "";

        /**
         * CMD_CS_IM_TELEGRAM_SEARCH_REQ phone.
         * @member {string} phone
         * @memberof tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_SEARCH_REQ.prototype.phone = "";

        /**
         * CMD_CS_IM_TELEGRAM_SEARCH_REQ query.
         * @member {string} query
         * @memberof tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_SEARCH_REQ.prototype.query = "";

        /**
         * CMD_CS_IM_TELEGRAM_SEARCH_REQ limit.
         * @member {number} limit
         * @memberof tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_SEARCH_REQ.prototype.limit = 0;

        /**
         * Creates a new CMD_CS_IM_TELEGRAM_SEARCH_REQ instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_SEARCH_REQ=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ} CMD_CS_IM_TELEGRAM_SEARCH_REQ instance
         */
        CMD_CS_IM_TELEGRAM_SEARCH_REQ.create = function create(properties) {
            return new CMD_CS_IM_TELEGRAM_SEARCH_REQ(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_TELEGRAM_SEARCH_REQ message. Does not implicitly {@link tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_SEARCH_REQ} message CMD_CS_IM_TELEGRAM_SEARCH_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_TELEGRAM_SEARCH_REQ.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.admin != null && Object.hasOwnProperty.call(message, "admin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.admin);
            if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.phone);
            if (message.query != null && Object.hasOwnProperty.call(message, "query"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.query);
            if (message.limit != null && Object.hasOwnProperty.call(message, "limit"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.limit);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_TELEGRAM_SEARCH_REQ message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_SEARCH_REQ} message CMD_CS_IM_TELEGRAM_SEARCH_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_TELEGRAM_SEARCH_REQ.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_TELEGRAM_SEARCH_REQ message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ} CMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_TELEGRAM_SEARCH_REQ.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.admin = reader.string();
                        break;
                    }
                case 2: {
                        message.phone = reader.string();
                        break;
                    }
                case 3: {
                        message.query = reader.string();
                        break;
                    }
                case 4: {
                        message.limit = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_TELEGRAM_SEARCH_REQ message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ} CMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_TELEGRAM_SEARCH_REQ.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_TELEGRAM_SEARCH_REQ message.
         * @function verify
         * @memberof tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_TELEGRAM_SEARCH_REQ.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.admin != null && message.hasOwnProperty("admin"))
                if (!$util.isString(message.admin))
                    return "admin: string expected";
            if (message.phone != null && message.hasOwnProperty("phone"))
                if (!$util.isString(message.phone))
                    return "phone: string expected";
            if (message.query != null && message.hasOwnProperty("query"))
                if (!$util.isString(message.query))
                    return "query: string expected";
            if (message.limit != null && message.hasOwnProperty("limit"))
                if (!$util.isInteger(message.limit))
                    return "limit: integer expected";
            return null;
        };

        /**
         * Creates a CMD_CS_IM_TELEGRAM_SEARCH_REQ message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ} CMD_CS_IM_TELEGRAM_SEARCH_REQ
         */
        CMD_CS_IM_TELEGRAM_SEARCH_REQ.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ)
                return object;
            var message = new $root.tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ();
            if (object.admin != null)
                message.admin = String(object.admin);
            if (object.phone != null)
                message.phone = String(object.phone);
            if (object.query != null)
                message.query = String(object.query);
            if (object.limit != null)
                message.limit = object.limit | 0;
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_TELEGRAM_SEARCH_REQ message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @static
         * @param {tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ} message CMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_TELEGRAM_SEARCH_REQ.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.admin = "";
                object.phone = "";
                object.query = "";
                object.limit = 0;
            }
            if (message.admin != null && message.hasOwnProperty("admin"))
                object.admin = message.admin;
            if (message.phone != null && message.hasOwnProperty("phone"))
                object.phone = message.phone;
            if (message.query != null && message.hasOwnProperty("query"))
                object.query = message.query;
            if (message.limit != null && message.hasOwnProperty("limit"))
                object.limit = message.limit;
            return object;
        };

        /**
         * Converts this CMD_CS_IM_TELEGRAM_SEARCH_REQ to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_TELEGRAM_SEARCH_REQ.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_TELEGRAM_SEARCH_REQ.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ";
        };

        return CMD_CS_IM_TELEGRAM_SEARCH_REQ;
    })();

    tg.CMD_SC_IM_TELEGRAM_SEARCH_RES = (function() {

        /**
         * Properties of a CMD_SC_IM_TELEGRAM_SEARCH_RES.
         * @memberof tg
         * @interface ICMD_SC_IM_TELEGRAM_SEARCH_RES
         * @property {string|null} [admin] CMD_SC_IM_TELEGRAM_SEARCH_RES admin
         * @property {string|null} [recipientPhone] CMD_SC_IM_TELEGRAM_SEARCH_RES recipientPhone
         * @property {tg.IUserInfo|null} [user_info] CMD_SC_IM_TELEGRAM_SEARCH_RES user_info
         */

        /**
         * Constructs a new CMD_SC_IM_TELEGRAM_SEARCH_RES.
         * @memberof tg
         * @classdesc Represents a CMD_SC_IM_TELEGRAM_SEARCH_RES.
         * @implements ICMD_SC_IM_TELEGRAM_SEARCH_RES
         * @constructor
         * @param {tg.ICMD_SC_IM_TELEGRAM_SEARCH_RES=} [properties] Properties to set
         */
        function CMD_SC_IM_TELEGRAM_SEARCH_RES(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_SC_IM_TELEGRAM_SEARCH_RES admin.
         * @member {string} admin
         * @memberof tg.CMD_SC_IM_TELEGRAM_SEARCH_RES
         * @instance
         */
        CMD_SC_IM_TELEGRAM_SEARCH_RES.prototype.admin = "";

        /**
         * CMD_SC_IM_TELEGRAM_SEARCH_RES recipientPhone.
         * @member {string} recipientPhone
         * @memberof tg.CMD_SC_IM_TELEGRAM_SEARCH_RES
         * @instance
         */
        CMD_SC_IM_TELEGRAM_SEARCH_RES.prototype.recipientPhone = "";

        /**
         * CMD_SC_IM_TELEGRAM_SEARCH_RES user_info.
         * @member {tg.IUserInfo|null|undefined} user_info
         * @memberof tg.CMD_SC_IM_TELEGRAM_SEARCH_RES
         * @instance
         */
        CMD_SC_IM_TELEGRAM_SEARCH_RES.prototype.user_info = null;

        /**
         * Creates a new CMD_SC_IM_TELEGRAM_SEARCH_RES instance using the specified properties.
         * @function create
         * @memberof tg.CMD_SC_IM_TELEGRAM_SEARCH_RES
         * @static
         * @param {tg.ICMD_SC_IM_TELEGRAM_SEARCH_RES=} [properties] Properties to set
         * @returns {tg.CMD_SC_IM_TELEGRAM_SEARCH_RES} CMD_SC_IM_TELEGRAM_SEARCH_RES instance
         */
        CMD_SC_IM_TELEGRAM_SEARCH_RES.create = function create(properties) {
            return new CMD_SC_IM_TELEGRAM_SEARCH_RES(properties);
        };

        /**
         * Encodes the specified CMD_SC_IM_TELEGRAM_SEARCH_RES message. Does not implicitly {@link tg.CMD_SC_IM_TELEGRAM_SEARCH_RES.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_SC_IM_TELEGRAM_SEARCH_RES
         * @static
         * @param {tg.ICMD_SC_IM_TELEGRAM_SEARCH_RES} message CMD_SC_IM_TELEGRAM_SEARCH_RES message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_IM_TELEGRAM_SEARCH_RES.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.admin != null && Object.hasOwnProperty.call(message, "admin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.admin);
            if (message.recipientPhone != null && Object.hasOwnProperty.call(message, "recipientPhone"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.recipientPhone);
            if (message.user_info != null && Object.hasOwnProperty.call(message, "user_info"))
                $root.tg.UserInfo.encode(message.user_info, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CMD_SC_IM_TELEGRAM_SEARCH_RES message, length delimited. Does not implicitly {@link tg.CMD_SC_IM_TELEGRAM_SEARCH_RES.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_SC_IM_TELEGRAM_SEARCH_RES
         * @static
         * @param {tg.ICMD_SC_IM_TELEGRAM_SEARCH_RES} message CMD_SC_IM_TELEGRAM_SEARCH_RES message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_SC_IM_TELEGRAM_SEARCH_RES.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_SC_IM_TELEGRAM_SEARCH_RES message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_SC_IM_TELEGRAM_SEARCH_RES
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_SC_IM_TELEGRAM_SEARCH_RES} CMD_SC_IM_TELEGRAM_SEARCH_RES
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_IM_TELEGRAM_SEARCH_RES.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_SC_IM_TELEGRAM_SEARCH_RES();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.admin = reader.string();
                        break;
                    }
                case 2: {
                        message.recipientPhone = reader.string();
                        break;
                    }
                case 3: {
                        message.user_info = $root.tg.UserInfo.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_SC_IM_TELEGRAM_SEARCH_RES message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_SC_IM_TELEGRAM_SEARCH_RES
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_SC_IM_TELEGRAM_SEARCH_RES} CMD_SC_IM_TELEGRAM_SEARCH_RES
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_SC_IM_TELEGRAM_SEARCH_RES.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_SC_IM_TELEGRAM_SEARCH_RES message.
         * @function verify
         * @memberof tg.CMD_SC_IM_TELEGRAM_SEARCH_RES
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_SC_IM_TELEGRAM_SEARCH_RES.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.admin != null && message.hasOwnProperty("admin"))
                if (!$util.isString(message.admin))
                    return "admin: string expected";
            if (message.recipientPhone != null && message.hasOwnProperty("recipientPhone"))
                if (!$util.isString(message.recipientPhone))
                    return "recipientPhone: string expected";
            if (message.user_info != null && message.hasOwnProperty("user_info")) {
                var error = $root.tg.UserInfo.verify(message.user_info);
                if (error)
                    return "user_info." + error;
            }
            return null;
        };

        /**
         * Creates a CMD_SC_IM_TELEGRAM_SEARCH_RES message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_SC_IM_TELEGRAM_SEARCH_RES
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_SC_IM_TELEGRAM_SEARCH_RES} CMD_SC_IM_TELEGRAM_SEARCH_RES
         */
        CMD_SC_IM_TELEGRAM_SEARCH_RES.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_SC_IM_TELEGRAM_SEARCH_RES)
                return object;
            var message = new $root.tg.CMD_SC_IM_TELEGRAM_SEARCH_RES();
            if (object.admin != null)
                message.admin = String(object.admin);
            if (object.recipientPhone != null)
                message.recipientPhone = String(object.recipientPhone);
            if (object.user_info != null) {
                if (typeof object.user_info !== "object")
                    throw TypeError(".tg.CMD_SC_IM_TELEGRAM_SEARCH_RES.user_info: object expected");
                message.user_info = $root.tg.UserInfo.fromObject(object.user_info);
            }
            return message;
        };

        /**
         * Creates a plain object from a CMD_SC_IM_TELEGRAM_SEARCH_RES message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_SC_IM_TELEGRAM_SEARCH_RES
         * @static
         * @param {tg.CMD_SC_IM_TELEGRAM_SEARCH_RES} message CMD_SC_IM_TELEGRAM_SEARCH_RES
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_SC_IM_TELEGRAM_SEARCH_RES.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.admin = "";
                object.recipientPhone = "";
                object.user_info = null;
            }
            if (message.admin != null && message.hasOwnProperty("admin"))
                object.admin = message.admin;
            if (message.recipientPhone != null && message.hasOwnProperty("recipientPhone"))
                object.recipientPhone = message.recipientPhone;
            if (message.user_info != null && message.hasOwnProperty("user_info"))
                object.user_info = $root.tg.UserInfo.toObject(message.user_info, options);
            return object;
        };

        /**
         * Converts this CMD_SC_IM_TELEGRAM_SEARCH_RES to JSON.
         * @function toJSON
         * @memberof tg.CMD_SC_IM_TELEGRAM_SEARCH_RES
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_SC_IM_TELEGRAM_SEARCH_RES.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_SC_IM_TELEGRAM_SEARCH_RES
         * @function getTypeUrl
         * @memberof tg.CMD_SC_IM_TELEGRAM_SEARCH_RES
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_SC_IM_TELEGRAM_SEARCH_RES.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_SC_IM_TELEGRAM_SEARCH_RES";
        };

        return CMD_SC_IM_TELEGRAM_SEARCH_RES;
    })();

    tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ = (function() {

        /**
         * Properties of a CMD_CS_IM_TELEGRAM_ADDUSER_REQ.
         * @memberof tg
         * @interface ICMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @property {string|null} [admin] CMD_CS_IM_TELEGRAM_ADDUSER_REQ admin
         * @property {string|null} [phone] CMD_CS_IM_TELEGRAM_ADDUSER_REQ phone
         * @property {number|Long|null} [chat_id] CMD_CS_IM_TELEGRAM_ADDUSER_REQ chat_id
         * @property {string|null} [usernick] CMD_CS_IM_TELEGRAM_ADDUSER_REQ usernick
         */

        /**
         * Constructs a new CMD_CS_IM_TELEGRAM_ADDUSER_REQ.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_TELEGRAM_ADDUSER_REQ.
         * @implements ICMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @constructor
         * @param {tg.ICMD_CS_IM_TELEGRAM_ADDUSER_REQ=} [properties] Properties to set
         */
        function CMD_CS_IM_TELEGRAM_ADDUSER_REQ(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_TELEGRAM_ADDUSER_REQ admin.
         * @member {string} admin
         * @memberof tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_ADDUSER_REQ.prototype.admin = "";

        /**
         * CMD_CS_IM_TELEGRAM_ADDUSER_REQ phone.
         * @member {string} phone
         * @memberof tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_ADDUSER_REQ.prototype.phone = "";

        /**
         * CMD_CS_IM_TELEGRAM_ADDUSER_REQ chat_id.
         * @member {number|Long} chat_id
         * @memberof tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_ADDUSER_REQ.prototype.chat_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * CMD_CS_IM_TELEGRAM_ADDUSER_REQ usernick.
         * @member {string} usernick
         * @memberof tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_ADDUSER_REQ.prototype.usernick = "";

        /**
         * Creates a new CMD_CS_IM_TELEGRAM_ADDUSER_REQ instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_ADDUSER_REQ=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ} CMD_CS_IM_TELEGRAM_ADDUSER_REQ instance
         */
        CMD_CS_IM_TELEGRAM_ADDUSER_REQ.create = function create(properties) {
            return new CMD_CS_IM_TELEGRAM_ADDUSER_REQ(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_TELEGRAM_ADDUSER_REQ message. Does not implicitly {@link tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_ADDUSER_REQ} message CMD_CS_IM_TELEGRAM_ADDUSER_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_TELEGRAM_ADDUSER_REQ.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.admin != null && Object.hasOwnProperty.call(message, "admin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.admin);
            if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.phone);
            if (message.chat_id != null && Object.hasOwnProperty.call(message, "chat_id"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.chat_id);
            if (message.usernick != null && Object.hasOwnProperty.call(message, "usernick"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.usernick);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_TELEGRAM_ADDUSER_REQ message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_ADDUSER_REQ} message CMD_CS_IM_TELEGRAM_ADDUSER_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_TELEGRAM_ADDUSER_REQ.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_TELEGRAM_ADDUSER_REQ message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ} CMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_TELEGRAM_ADDUSER_REQ.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.admin = reader.string();
                        break;
                    }
                case 2: {
                        message.phone = reader.string();
                        break;
                    }
                case 3: {
                        message.chat_id = reader.int64();
                        break;
                    }
                case 4: {
                        message.usernick = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_TELEGRAM_ADDUSER_REQ message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ} CMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_TELEGRAM_ADDUSER_REQ.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_TELEGRAM_ADDUSER_REQ message.
         * @function verify
         * @memberof tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_TELEGRAM_ADDUSER_REQ.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.admin != null && message.hasOwnProperty("admin"))
                if (!$util.isString(message.admin))
                    return "admin: string expected";
            if (message.phone != null && message.hasOwnProperty("phone"))
                if (!$util.isString(message.phone))
                    return "phone: string expected";
            if (message.chat_id != null && message.hasOwnProperty("chat_id"))
                if (!$util.isInteger(message.chat_id) && !(message.chat_id && $util.isInteger(message.chat_id.low) && $util.isInteger(message.chat_id.high)))
                    return "chat_id: integer|Long expected";
            if (message.usernick != null && message.hasOwnProperty("usernick"))
                if (!$util.isString(message.usernick))
                    return "usernick: string expected";
            return null;
        };

        /**
         * Creates a CMD_CS_IM_TELEGRAM_ADDUSER_REQ message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ} CMD_CS_IM_TELEGRAM_ADDUSER_REQ
         */
        CMD_CS_IM_TELEGRAM_ADDUSER_REQ.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ)
                return object;
            var message = new $root.tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ();
            if (object.admin != null)
                message.admin = String(object.admin);
            if (object.phone != null)
                message.phone = String(object.phone);
            if (object.chat_id != null)
                if ($util.Long)
                    (message.chat_id = $util.Long.fromValue(object.chat_id)).unsigned = false;
                else if (typeof object.chat_id === "string")
                    message.chat_id = parseInt(object.chat_id, 10);
                else if (typeof object.chat_id === "number")
                    message.chat_id = object.chat_id;
                else if (typeof object.chat_id === "object")
                    message.chat_id = new $util.LongBits(object.chat_id.low >>> 0, object.chat_id.high >>> 0).toNumber();
            if (object.usernick != null)
                message.usernick = String(object.usernick);
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_TELEGRAM_ADDUSER_REQ message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @static
         * @param {tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ} message CMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_TELEGRAM_ADDUSER_REQ.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.admin = "";
                object.phone = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chat_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chat_id = options.longs === String ? "0" : 0;
                object.usernick = "";
            }
            if (message.admin != null && message.hasOwnProperty("admin"))
                object.admin = message.admin;
            if (message.phone != null && message.hasOwnProperty("phone"))
                object.phone = message.phone;
            if (message.chat_id != null && message.hasOwnProperty("chat_id"))
                if (typeof message.chat_id === "number")
                    object.chat_id = options.longs === String ? String(message.chat_id) : message.chat_id;
                else
                    object.chat_id = options.longs === String ? $util.Long.prototype.toString.call(message.chat_id) : options.longs === Number ? new $util.LongBits(message.chat_id.low >>> 0, message.chat_id.high >>> 0).toNumber() : message.chat_id;
            if (message.usernick != null && message.hasOwnProperty("usernick"))
                object.usernick = message.usernick;
            return object;
        };

        /**
         * Converts this CMD_CS_IM_TELEGRAM_ADDUSER_REQ to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_TELEGRAM_ADDUSER_REQ.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_TELEGRAM_ADDUSER_REQ.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ";
        };

        return CMD_CS_IM_TELEGRAM_ADDUSER_REQ;
    })();

    tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ = (function() {

        /**
         * Properties of a CMD_CS_IM_TELEGRAM_DELUSER_REQ.
         * @memberof tg
         * @interface ICMD_CS_IM_TELEGRAM_DELUSER_REQ
         * @property {string|null} [admin] CMD_CS_IM_TELEGRAM_DELUSER_REQ admin
         * @property {string|null} [phone] CMD_CS_IM_TELEGRAM_DELUSER_REQ phone
         * @property {Array.<number|Long>|null} [user_ids] CMD_CS_IM_TELEGRAM_DELUSER_REQ user_ids
         */

        /**
         * Constructs a new CMD_CS_IM_TELEGRAM_DELUSER_REQ.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_TELEGRAM_DELUSER_REQ.
         * @implements ICMD_CS_IM_TELEGRAM_DELUSER_REQ
         * @constructor
         * @param {tg.ICMD_CS_IM_TELEGRAM_DELUSER_REQ=} [properties] Properties to set
         */
        function CMD_CS_IM_TELEGRAM_DELUSER_REQ(properties) {
            this.user_ids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_TELEGRAM_DELUSER_REQ admin.
         * @member {string} admin
         * @memberof tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_DELUSER_REQ.prototype.admin = "";

        /**
         * CMD_CS_IM_TELEGRAM_DELUSER_REQ phone.
         * @member {string} phone
         * @memberof tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_DELUSER_REQ.prototype.phone = "";

        /**
         * CMD_CS_IM_TELEGRAM_DELUSER_REQ user_ids.
         * @member {Array.<number|Long>} user_ids
         * @memberof tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_DELUSER_REQ.prototype.user_ids = $util.emptyArray;

        /**
         * Creates a new CMD_CS_IM_TELEGRAM_DELUSER_REQ instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_DELUSER_REQ=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ} CMD_CS_IM_TELEGRAM_DELUSER_REQ instance
         */
        CMD_CS_IM_TELEGRAM_DELUSER_REQ.create = function create(properties) {
            return new CMD_CS_IM_TELEGRAM_DELUSER_REQ(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_TELEGRAM_DELUSER_REQ message. Does not implicitly {@link tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_DELUSER_REQ} message CMD_CS_IM_TELEGRAM_DELUSER_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_TELEGRAM_DELUSER_REQ.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.admin != null && Object.hasOwnProperty.call(message, "admin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.admin);
            if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.phone);
            if (message.user_ids != null && message.user_ids.length) {
                writer.uint32(/* id 3, wireType 2 =*/26).fork();
                for (var i = 0; i < message.user_ids.length; ++i)
                    writer.int64(message.user_ids[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_TELEGRAM_DELUSER_REQ message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_DELUSER_REQ} message CMD_CS_IM_TELEGRAM_DELUSER_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_TELEGRAM_DELUSER_REQ.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_TELEGRAM_DELUSER_REQ message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ} CMD_CS_IM_TELEGRAM_DELUSER_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_TELEGRAM_DELUSER_REQ.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.admin = reader.string();
                        break;
                    }
                case 2: {
                        message.phone = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.user_ids && message.user_ids.length))
                            message.user_ids = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.user_ids.push(reader.int64());
                        } else
                            message.user_ids.push(reader.int64());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_TELEGRAM_DELUSER_REQ message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ} CMD_CS_IM_TELEGRAM_DELUSER_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_TELEGRAM_DELUSER_REQ.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_TELEGRAM_DELUSER_REQ message.
         * @function verify
         * @memberof tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_TELEGRAM_DELUSER_REQ.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.admin != null && message.hasOwnProperty("admin"))
                if (!$util.isString(message.admin))
                    return "admin: string expected";
            if (message.phone != null && message.hasOwnProperty("phone"))
                if (!$util.isString(message.phone))
                    return "phone: string expected";
            if (message.user_ids != null && message.hasOwnProperty("user_ids")) {
                if (!Array.isArray(message.user_ids))
                    return "user_ids: array expected";
                for (var i = 0; i < message.user_ids.length; ++i)
                    if (!$util.isInteger(message.user_ids[i]) && !(message.user_ids[i] && $util.isInteger(message.user_ids[i].low) && $util.isInteger(message.user_ids[i].high)))
                        return "user_ids: integer|Long[] expected";
            }
            return null;
        };

        /**
         * Creates a CMD_CS_IM_TELEGRAM_DELUSER_REQ message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ} CMD_CS_IM_TELEGRAM_DELUSER_REQ
         */
        CMD_CS_IM_TELEGRAM_DELUSER_REQ.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ)
                return object;
            var message = new $root.tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ();
            if (object.admin != null)
                message.admin = String(object.admin);
            if (object.phone != null)
                message.phone = String(object.phone);
            if (object.user_ids) {
                if (!Array.isArray(object.user_ids))
                    throw TypeError(".tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ.user_ids: array expected");
                message.user_ids = [];
                for (var i = 0; i < object.user_ids.length; ++i)
                    if ($util.Long)
                        (message.user_ids[i] = $util.Long.fromValue(object.user_ids[i])).unsigned = false;
                    else if (typeof object.user_ids[i] === "string")
                        message.user_ids[i] = parseInt(object.user_ids[i], 10);
                    else if (typeof object.user_ids[i] === "number")
                        message.user_ids[i] = object.user_ids[i];
                    else if (typeof object.user_ids[i] === "object")
                        message.user_ids[i] = new $util.LongBits(object.user_ids[i].low >>> 0, object.user_ids[i].high >>> 0).toNumber();
            }
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_TELEGRAM_DELUSER_REQ message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ
         * @static
         * @param {tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ} message CMD_CS_IM_TELEGRAM_DELUSER_REQ
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_TELEGRAM_DELUSER_REQ.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.user_ids = [];
            if (options.defaults) {
                object.admin = "";
                object.phone = "";
            }
            if (message.admin != null && message.hasOwnProperty("admin"))
                object.admin = message.admin;
            if (message.phone != null && message.hasOwnProperty("phone"))
                object.phone = message.phone;
            if (message.user_ids && message.user_ids.length) {
                object.user_ids = [];
                for (var j = 0; j < message.user_ids.length; ++j)
                    if (typeof message.user_ids[j] === "number")
                        object.user_ids[j] = options.longs === String ? String(message.user_ids[j]) : message.user_ids[j];
                    else
                        object.user_ids[j] = options.longs === String ? $util.Long.prototype.toString.call(message.user_ids[j]) : options.longs === Number ? new $util.LongBits(message.user_ids[j].low >>> 0, message.user_ids[j].high >>> 0).toNumber() : message.user_ids[j];
            }
            return object;
        };

        /**
         * Converts this CMD_CS_IM_TELEGRAM_DELUSER_REQ to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_TELEGRAM_DELUSER_REQ.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_TELEGRAM_DELUSER_REQ
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_TELEGRAM_DELUSER_REQ.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_TELEGRAM_DELUSER_REQ";
        };

        return CMD_CS_IM_TELEGRAM_DELUSER_REQ;
    })();

    tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ = (function() {

        /**
         * Properties of a CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.
         * @memberof tg
         * @interface ICMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @property {string|null} [admin] CMD_CS_IM_TELEGRAM_EDIT_USER_REQ admin
         * @property {string|null} [phone] CMD_CS_IM_TELEGRAM_EDIT_USER_REQ phone
         * @property {number|Long|null} [chat_id] CMD_CS_IM_TELEGRAM_EDIT_USER_REQ chat_id
         * @property {string|null} [first_name] CMD_CS_IM_TELEGRAM_EDIT_USER_REQ first_name
         * @property {string|null} [last_name] CMD_CS_IM_TELEGRAM_EDIT_USER_REQ last_name
         */

        /**
         * Constructs a new CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.
         * @implements ICMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @constructor
         * @param {tg.ICMD_CS_IM_TELEGRAM_EDIT_USER_REQ=} [properties] Properties to set
         */
        function CMD_CS_IM_TELEGRAM_EDIT_USER_REQ(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_TELEGRAM_EDIT_USER_REQ admin.
         * @member {string} admin
         * @memberof tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.prototype.admin = "";

        /**
         * CMD_CS_IM_TELEGRAM_EDIT_USER_REQ phone.
         * @member {string} phone
         * @memberof tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.prototype.phone = "";

        /**
         * CMD_CS_IM_TELEGRAM_EDIT_USER_REQ chat_id.
         * @member {number|Long} chat_id
         * @memberof tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.prototype.chat_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * CMD_CS_IM_TELEGRAM_EDIT_USER_REQ first_name.
         * @member {string} first_name
         * @memberof tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.prototype.first_name = "";

        /**
         * CMD_CS_IM_TELEGRAM_EDIT_USER_REQ last_name.
         * @member {string} last_name
         * @memberof tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @instance
         */
        CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.prototype.last_name = "";

        /**
         * Creates a new CMD_CS_IM_TELEGRAM_EDIT_USER_REQ instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_EDIT_USER_REQ=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ} CMD_CS_IM_TELEGRAM_EDIT_USER_REQ instance
         */
        CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.create = function create(properties) {
            return new CMD_CS_IM_TELEGRAM_EDIT_USER_REQ(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_TELEGRAM_EDIT_USER_REQ message. Does not implicitly {@link tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_EDIT_USER_REQ} message CMD_CS_IM_TELEGRAM_EDIT_USER_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.admin != null && Object.hasOwnProperty.call(message, "admin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.admin);
            if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.phone);
            if (message.chat_id != null && Object.hasOwnProperty.call(message, "chat_id"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.chat_id);
            if (message.first_name != null && Object.hasOwnProperty.call(message, "first_name"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.first_name);
            if (message.last_name != null && Object.hasOwnProperty.call(message, "last_name"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.last_name);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_TELEGRAM_EDIT_USER_REQ message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @static
         * @param {tg.ICMD_CS_IM_TELEGRAM_EDIT_USER_REQ} message CMD_CS_IM_TELEGRAM_EDIT_USER_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_TELEGRAM_EDIT_USER_REQ message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ} CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.admin = reader.string();
                        break;
                    }
                case 2: {
                        message.phone = reader.string();
                        break;
                    }
                case 3: {
                        message.chat_id = reader.int64();
                        break;
                    }
                case 4: {
                        message.first_name = reader.string();
                        break;
                    }
                case 5: {
                        message.last_name = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_TELEGRAM_EDIT_USER_REQ message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ} CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_TELEGRAM_EDIT_USER_REQ message.
         * @function verify
         * @memberof tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.admin != null && message.hasOwnProperty("admin"))
                if (!$util.isString(message.admin))
                    return "admin: string expected";
            if (message.phone != null && message.hasOwnProperty("phone"))
                if (!$util.isString(message.phone))
                    return "phone: string expected";
            if (message.chat_id != null && message.hasOwnProperty("chat_id"))
                if (!$util.isInteger(message.chat_id) && !(message.chat_id && $util.isInteger(message.chat_id.low) && $util.isInteger(message.chat_id.high)))
                    return "chat_id: integer|Long expected";
            if (message.first_name != null && message.hasOwnProperty("first_name"))
                if (!$util.isString(message.first_name))
                    return "first_name: string expected";
            if (message.last_name != null && message.hasOwnProperty("last_name"))
                if (!$util.isString(message.last_name))
                    return "last_name: string expected";
            return null;
        };

        /**
         * Creates a CMD_CS_IM_TELEGRAM_EDIT_USER_REQ message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ} CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         */
        CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ)
                return object;
            var message = new $root.tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ();
            if (object.admin != null)
                message.admin = String(object.admin);
            if (object.phone != null)
                message.phone = String(object.phone);
            if (object.chat_id != null)
                if ($util.Long)
                    (message.chat_id = $util.Long.fromValue(object.chat_id)).unsigned = false;
                else if (typeof object.chat_id === "string")
                    message.chat_id = parseInt(object.chat_id, 10);
                else if (typeof object.chat_id === "number")
                    message.chat_id = object.chat_id;
                else if (typeof object.chat_id === "object")
                    message.chat_id = new $util.LongBits(object.chat_id.low >>> 0, object.chat_id.high >>> 0).toNumber();
            if (object.first_name != null)
                message.first_name = String(object.first_name);
            if (object.last_name != null)
                message.last_name = String(object.last_name);
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_TELEGRAM_EDIT_USER_REQ message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @static
         * @param {tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ} message CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.admin = "";
                object.phone = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chat_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chat_id = options.longs === String ? "0" : 0;
                object.first_name = "";
                object.last_name = "";
            }
            if (message.admin != null && message.hasOwnProperty("admin"))
                object.admin = message.admin;
            if (message.phone != null && message.hasOwnProperty("phone"))
                object.phone = message.phone;
            if (message.chat_id != null && message.hasOwnProperty("chat_id"))
                if (typeof message.chat_id === "number")
                    object.chat_id = options.longs === String ? String(message.chat_id) : message.chat_id;
                else
                    object.chat_id = options.longs === String ? $util.Long.prototype.toString.call(message.chat_id) : options.longs === Number ? new $util.LongBits(message.chat_id.low >>> 0, message.chat_id.high >>> 0).toNumber() : message.chat_id;
            if (message.first_name != null && message.hasOwnProperty("first_name"))
                object.first_name = message.first_name;
            if (message.last_name != null && message.hasOwnProperty("last_name"))
                object.last_name = message.last_name;
            return object;
        };

        /**
         * Converts this CMD_CS_IM_TELEGRAM_EDIT_USER_REQ to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ";
        };

        return CMD_CS_IM_TELEGRAM_EDIT_USER_REQ;
    })();

    tg.CMD_CS_IM_JOIN_GROUP_REQ = (function() {

        /**
         * Properties of a CMD_CS_IM_JOIN_GROUP_REQ.
         * @memberof tg
         * @interface ICMD_CS_IM_JOIN_GROUP_REQ
         * @property {string|null} [user_name] CMD_CS_IM_JOIN_GROUP_REQ user_name
         * @property {string|null} [channel_name] CMD_CS_IM_JOIN_GROUP_REQ channel_name
         */

        /**
         * Constructs a new CMD_CS_IM_JOIN_GROUP_REQ.
         * @memberof tg
         * @classdesc Represents a CMD_CS_IM_JOIN_GROUP_REQ.
         * @implements ICMD_CS_IM_JOIN_GROUP_REQ
         * @constructor
         * @param {tg.ICMD_CS_IM_JOIN_GROUP_REQ=} [properties] Properties to set
         */
        function CMD_CS_IM_JOIN_GROUP_REQ(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_IM_JOIN_GROUP_REQ user_name.
         * @member {string} user_name
         * @memberof tg.CMD_CS_IM_JOIN_GROUP_REQ
         * @instance
         */
        CMD_CS_IM_JOIN_GROUP_REQ.prototype.user_name = "";

        /**
         * CMD_CS_IM_JOIN_GROUP_REQ channel_name.
         * @member {string} channel_name
         * @memberof tg.CMD_CS_IM_JOIN_GROUP_REQ
         * @instance
         */
        CMD_CS_IM_JOIN_GROUP_REQ.prototype.channel_name = "";

        /**
         * Creates a new CMD_CS_IM_JOIN_GROUP_REQ instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_IM_JOIN_GROUP_REQ
         * @static
         * @param {tg.ICMD_CS_IM_JOIN_GROUP_REQ=} [properties] Properties to set
         * @returns {tg.CMD_CS_IM_JOIN_GROUP_REQ} CMD_CS_IM_JOIN_GROUP_REQ instance
         */
        CMD_CS_IM_JOIN_GROUP_REQ.create = function create(properties) {
            return new CMD_CS_IM_JOIN_GROUP_REQ(properties);
        };

        /**
         * Encodes the specified CMD_CS_IM_JOIN_GROUP_REQ message. Does not implicitly {@link tg.CMD_CS_IM_JOIN_GROUP_REQ.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_IM_JOIN_GROUP_REQ
         * @static
         * @param {tg.ICMD_CS_IM_JOIN_GROUP_REQ} message CMD_CS_IM_JOIN_GROUP_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_JOIN_GROUP_REQ.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.user_name != null && Object.hasOwnProperty.call(message, "user_name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.user_name);
            if (message.channel_name != null && Object.hasOwnProperty.call(message, "channel_name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.channel_name);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_IM_JOIN_GROUP_REQ message, length delimited. Does not implicitly {@link tg.CMD_CS_IM_JOIN_GROUP_REQ.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_IM_JOIN_GROUP_REQ
         * @static
         * @param {tg.ICMD_CS_IM_JOIN_GROUP_REQ} message CMD_CS_IM_JOIN_GROUP_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_IM_JOIN_GROUP_REQ.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_IM_JOIN_GROUP_REQ message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_IM_JOIN_GROUP_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_IM_JOIN_GROUP_REQ} CMD_CS_IM_JOIN_GROUP_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_JOIN_GROUP_REQ.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_IM_JOIN_GROUP_REQ();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.user_name = reader.string();
                        break;
                    }
                case 2: {
                        message.channel_name = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_IM_JOIN_GROUP_REQ message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_IM_JOIN_GROUP_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_IM_JOIN_GROUP_REQ} CMD_CS_IM_JOIN_GROUP_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_IM_JOIN_GROUP_REQ.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_IM_JOIN_GROUP_REQ message.
         * @function verify
         * @memberof tg.CMD_CS_IM_JOIN_GROUP_REQ
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_IM_JOIN_GROUP_REQ.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.user_name != null && message.hasOwnProperty("user_name"))
                if (!$util.isString(message.user_name))
                    return "user_name: string expected";
            if (message.channel_name != null && message.hasOwnProperty("channel_name"))
                if (!$util.isString(message.channel_name))
                    return "channel_name: string expected";
            return null;
        };

        /**
         * Creates a CMD_CS_IM_JOIN_GROUP_REQ message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_IM_JOIN_GROUP_REQ
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_IM_JOIN_GROUP_REQ} CMD_CS_IM_JOIN_GROUP_REQ
         */
        CMD_CS_IM_JOIN_GROUP_REQ.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_IM_JOIN_GROUP_REQ)
                return object;
            var message = new $root.tg.CMD_CS_IM_JOIN_GROUP_REQ();
            if (object.user_name != null)
                message.user_name = String(object.user_name);
            if (object.channel_name != null)
                message.channel_name = String(object.channel_name);
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_IM_JOIN_GROUP_REQ message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_IM_JOIN_GROUP_REQ
         * @static
         * @param {tg.CMD_CS_IM_JOIN_GROUP_REQ} message CMD_CS_IM_JOIN_GROUP_REQ
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_IM_JOIN_GROUP_REQ.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.user_name = "";
                object.channel_name = "";
            }
            if (message.user_name != null && message.hasOwnProperty("user_name"))
                object.user_name = message.user_name;
            if (message.channel_name != null && message.hasOwnProperty("channel_name"))
                object.channel_name = message.channel_name;
            return object;
        };

        /**
         * Converts this CMD_CS_IM_JOIN_GROUP_REQ to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_IM_JOIN_GROUP_REQ
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_IM_JOIN_GROUP_REQ.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_IM_JOIN_GROUP_REQ
         * @function getTypeUrl
         * @memberof tg.CMD_CS_IM_JOIN_GROUP_REQ
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_IM_JOIN_GROUP_REQ.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_IM_JOIN_GROUP_REQ";
        };

        return CMD_CS_IM_JOIN_GROUP_REQ;
    })();

    tg.CMD_CS_GAME_TOOLS_BASE_RESULT = (function() {

        /**
         * Properties of a CMD_CS_GAME_TOOLS_BASE_RESULT.
         * @memberof tg
         * @interface ICMD_CS_GAME_TOOLS_BASE_RESULT
         * @property {number|null} [nCode] CMD_CS_GAME_TOOLS_BASE_RESULT nCode
         * @property {string|null} [strResult] CMD_CS_GAME_TOOLS_BASE_RESULT strResult
         * @property {number|null} [nTotal] CMD_CS_GAME_TOOLS_BASE_RESULT nTotal
         */

        /**
         * Constructs a new CMD_CS_GAME_TOOLS_BASE_RESULT.
         * @memberof tg
         * @classdesc Represents a CMD_CS_GAME_TOOLS_BASE_RESULT.
         * @implements ICMD_CS_GAME_TOOLS_BASE_RESULT
         * @constructor
         * @param {tg.ICMD_CS_GAME_TOOLS_BASE_RESULT=} [properties] Properties to set
         */
        function CMD_CS_GAME_TOOLS_BASE_RESULT(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CS_GAME_TOOLS_BASE_RESULT nCode.
         * @member {number} nCode
         * @memberof tg.CMD_CS_GAME_TOOLS_BASE_RESULT
         * @instance
         */
        CMD_CS_GAME_TOOLS_BASE_RESULT.prototype.nCode = 0;

        /**
         * CMD_CS_GAME_TOOLS_BASE_RESULT strResult.
         * @member {string} strResult
         * @memberof tg.CMD_CS_GAME_TOOLS_BASE_RESULT
         * @instance
         */
        CMD_CS_GAME_TOOLS_BASE_RESULT.prototype.strResult = "";

        /**
         * CMD_CS_GAME_TOOLS_BASE_RESULT nTotal.
         * @member {number} nTotal
         * @memberof tg.CMD_CS_GAME_TOOLS_BASE_RESULT
         * @instance
         */
        CMD_CS_GAME_TOOLS_BASE_RESULT.prototype.nTotal = 0;

        /**
         * Creates a new CMD_CS_GAME_TOOLS_BASE_RESULT instance using the specified properties.
         * @function create
         * @memberof tg.CMD_CS_GAME_TOOLS_BASE_RESULT
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_BASE_RESULT=} [properties] Properties to set
         * @returns {tg.CMD_CS_GAME_TOOLS_BASE_RESULT} CMD_CS_GAME_TOOLS_BASE_RESULT instance
         */
        CMD_CS_GAME_TOOLS_BASE_RESULT.create = function create(properties) {
            return new CMD_CS_GAME_TOOLS_BASE_RESULT(properties);
        };

        /**
         * Encodes the specified CMD_CS_GAME_TOOLS_BASE_RESULT message. Does not implicitly {@link tg.CMD_CS_GAME_TOOLS_BASE_RESULT.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_CS_GAME_TOOLS_BASE_RESULT
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_BASE_RESULT} message CMD_CS_GAME_TOOLS_BASE_RESULT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_GAME_TOOLS_BASE_RESULT.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.nCode != null && Object.hasOwnProperty.call(message, "nCode"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.nCode);
            if (message.strResult != null && Object.hasOwnProperty.call(message, "strResult"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.strResult);
            if (message.nTotal != null && Object.hasOwnProperty.call(message, "nTotal"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.nTotal);
            return writer;
        };

        /**
         * Encodes the specified CMD_CS_GAME_TOOLS_BASE_RESULT message, length delimited. Does not implicitly {@link tg.CMD_CS_GAME_TOOLS_BASE_RESULT.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_CS_GAME_TOOLS_BASE_RESULT
         * @static
         * @param {tg.ICMD_CS_GAME_TOOLS_BASE_RESULT} message CMD_CS_GAME_TOOLS_BASE_RESULT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CS_GAME_TOOLS_BASE_RESULT.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CS_GAME_TOOLS_BASE_RESULT message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_CS_GAME_TOOLS_BASE_RESULT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_CS_GAME_TOOLS_BASE_RESULT} CMD_CS_GAME_TOOLS_BASE_RESULT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_GAME_TOOLS_BASE_RESULT.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_CS_GAME_TOOLS_BASE_RESULT();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.nCode = reader.int32();
                        break;
                    }
                case 2: {
                        message.strResult = reader.string();
                        break;
                    }
                case 3: {
                        message.nTotal = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CS_GAME_TOOLS_BASE_RESULT message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_CS_GAME_TOOLS_BASE_RESULT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_CS_GAME_TOOLS_BASE_RESULT} CMD_CS_GAME_TOOLS_BASE_RESULT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CS_GAME_TOOLS_BASE_RESULT.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CS_GAME_TOOLS_BASE_RESULT message.
         * @function verify
         * @memberof tg.CMD_CS_GAME_TOOLS_BASE_RESULT
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CS_GAME_TOOLS_BASE_RESULT.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.nCode != null && message.hasOwnProperty("nCode"))
                if (!$util.isInteger(message.nCode))
                    return "nCode: integer expected";
            if (message.strResult != null && message.hasOwnProperty("strResult"))
                if (!$util.isString(message.strResult))
                    return "strResult: string expected";
            if (message.nTotal != null && message.hasOwnProperty("nTotal"))
                if (!$util.isInteger(message.nTotal))
                    return "nTotal: integer expected";
            return null;
        };

        /**
         * Creates a CMD_CS_GAME_TOOLS_BASE_RESULT message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_CS_GAME_TOOLS_BASE_RESULT
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_CS_GAME_TOOLS_BASE_RESULT} CMD_CS_GAME_TOOLS_BASE_RESULT
         */
        CMD_CS_GAME_TOOLS_BASE_RESULT.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_CS_GAME_TOOLS_BASE_RESULT)
                return object;
            var message = new $root.tg.CMD_CS_GAME_TOOLS_BASE_RESULT();
            if (object.nCode != null)
                message.nCode = object.nCode | 0;
            if (object.strResult != null)
                message.strResult = String(object.strResult);
            if (object.nTotal != null)
                message.nTotal = object.nTotal | 0;
            return message;
        };

        /**
         * Creates a plain object from a CMD_CS_GAME_TOOLS_BASE_RESULT message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_CS_GAME_TOOLS_BASE_RESULT
         * @static
         * @param {tg.CMD_CS_GAME_TOOLS_BASE_RESULT} message CMD_CS_GAME_TOOLS_BASE_RESULT
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CS_GAME_TOOLS_BASE_RESULT.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.nCode = 0;
                object.strResult = "";
                object.nTotal = 0;
            }
            if (message.nCode != null && message.hasOwnProperty("nCode"))
                object.nCode = message.nCode;
            if (message.strResult != null && message.hasOwnProperty("strResult"))
                object.strResult = message.strResult;
            if (message.nTotal != null && message.hasOwnProperty("nTotal"))
                object.nTotal = message.nTotal;
            return object;
        };

        /**
         * Converts this CMD_CS_GAME_TOOLS_BASE_RESULT to JSON.
         * @function toJSON
         * @memberof tg.CMD_CS_GAME_TOOLS_BASE_RESULT
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CS_GAME_TOOLS_BASE_RESULT.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_CS_GAME_TOOLS_BASE_RESULT
         * @function getTypeUrl
         * @memberof tg.CMD_CS_GAME_TOOLS_BASE_RESULT
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_CS_GAME_TOOLS_BASE_RESULT.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_CS_GAME_TOOLS_BASE_RESULT";
        };

        return CMD_CS_GAME_TOOLS_BASE_RESULT;
    })();

    tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS = (function() {

        /**
         * Properties of a CMD_GAME_TOOLS_LOAD_ACCOUNTS.
         * @memberof tg
         * @interface ICMD_GAME_TOOLS_LOAD_ACCOUNTS
         * @property {Array.<tg.ICMD_GAME_TOOLS_ACCOUNT_INF>|null} [list] CMD_GAME_TOOLS_LOAD_ACCOUNTS list
         */

        /**
         * Constructs a new CMD_GAME_TOOLS_LOAD_ACCOUNTS.
         * @memberof tg
         * @classdesc Represents a CMD_GAME_TOOLS_LOAD_ACCOUNTS.
         * @implements ICMD_GAME_TOOLS_LOAD_ACCOUNTS
         * @constructor
         * @param {tg.ICMD_GAME_TOOLS_LOAD_ACCOUNTS=} [properties] Properties to set
         */
        function CMD_GAME_TOOLS_LOAD_ACCOUNTS(properties) {
            this.list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_GAME_TOOLS_LOAD_ACCOUNTS list.
         * @member {Array.<tg.ICMD_GAME_TOOLS_ACCOUNT_INF>} list
         * @memberof tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS
         * @instance
         */
        CMD_GAME_TOOLS_LOAD_ACCOUNTS.prototype.list = $util.emptyArray;

        /**
         * Creates a new CMD_GAME_TOOLS_LOAD_ACCOUNTS instance using the specified properties.
         * @function create
         * @memberof tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS
         * @static
         * @param {tg.ICMD_GAME_TOOLS_LOAD_ACCOUNTS=} [properties] Properties to set
         * @returns {tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS} CMD_GAME_TOOLS_LOAD_ACCOUNTS instance
         */
        CMD_GAME_TOOLS_LOAD_ACCOUNTS.create = function create(properties) {
            return new CMD_GAME_TOOLS_LOAD_ACCOUNTS(properties);
        };

        /**
         * Encodes the specified CMD_GAME_TOOLS_LOAD_ACCOUNTS message. Does not implicitly {@link tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS
         * @static
         * @param {tg.ICMD_GAME_TOOLS_LOAD_ACCOUNTS} message CMD_GAME_TOOLS_LOAD_ACCOUNTS message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_GAME_TOOLS_LOAD_ACCOUNTS.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.list != null && message.list.length)
                for (var i = 0; i < message.list.length; ++i)
                    $root.tg.CMD_GAME_TOOLS_ACCOUNT_INF.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CMD_GAME_TOOLS_LOAD_ACCOUNTS message, length delimited. Does not implicitly {@link tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS
         * @static
         * @param {tg.ICMD_GAME_TOOLS_LOAD_ACCOUNTS} message CMD_GAME_TOOLS_LOAD_ACCOUNTS message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_GAME_TOOLS_LOAD_ACCOUNTS.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_GAME_TOOLS_LOAD_ACCOUNTS message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS} CMD_GAME_TOOLS_LOAD_ACCOUNTS
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_GAME_TOOLS_LOAD_ACCOUNTS.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.tg.CMD_GAME_TOOLS_ACCOUNT_INF.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_GAME_TOOLS_LOAD_ACCOUNTS message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS} CMD_GAME_TOOLS_LOAD_ACCOUNTS
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_GAME_TOOLS_LOAD_ACCOUNTS.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_GAME_TOOLS_LOAD_ACCOUNTS message.
         * @function verify
         * @memberof tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_GAME_TOOLS_LOAD_ACCOUNTS.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.list != null && message.hasOwnProperty("list")) {
                if (!Array.isArray(message.list))
                    return "list: array expected";
                for (var i = 0; i < message.list.length; ++i) {
                    var error = $root.tg.CMD_GAME_TOOLS_ACCOUNT_INF.verify(message.list[i]);
                    if (error)
                        return "list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CMD_GAME_TOOLS_LOAD_ACCOUNTS message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS} CMD_GAME_TOOLS_LOAD_ACCOUNTS
         */
        CMD_GAME_TOOLS_LOAD_ACCOUNTS.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS)
                return object;
            var message = new $root.tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS();
            if (object.list) {
                if (!Array.isArray(object.list))
                    throw TypeError(".tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS.list: array expected");
                message.list = [];
                for (var i = 0; i < object.list.length; ++i) {
                    if (typeof object.list[i] !== "object")
                        throw TypeError(".tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS.list: object expected");
                    message.list[i] = $root.tg.CMD_GAME_TOOLS_ACCOUNT_INF.fromObject(object.list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CMD_GAME_TOOLS_LOAD_ACCOUNTS message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS
         * @static
         * @param {tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS} message CMD_GAME_TOOLS_LOAD_ACCOUNTS
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_GAME_TOOLS_LOAD_ACCOUNTS.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.list = [];
            if (message.list && message.list.length) {
                object.list = [];
                for (var j = 0; j < message.list.length; ++j)
                    object.list[j] = $root.tg.CMD_GAME_TOOLS_ACCOUNT_INF.toObject(message.list[j], options);
            }
            return object;
        };

        /**
         * Converts this CMD_GAME_TOOLS_LOAD_ACCOUNTS to JSON.
         * @function toJSON
         * @memberof tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_GAME_TOOLS_LOAD_ACCOUNTS.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_GAME_TOOLS_LOAD_ACCOUNTS
         * @function getTypeUrl
         * @memberof tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_GAME_TOOLS_LOAD_ACCOUNTS.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_GAME_TOOLS_LOAD_ACCOUNTS";
        };

        return CMD_GAME_TOOLS_LOAD_ACCOUNTS;
    })();

    tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS = (function() {

        /**
         * Properties of a CMD_GAME_TOOLS_LOAD_TELEGRAMS.
         * @memberof tg
         * @interface ICMD_GAME_TOOLS_LOAD_TELEGRAMS
         * @property {Array.<tg.ICMD_GAME_TOOLS_TELEGRAM_INF>|null} [list] CMD_GAME_TOOLS_LOAD_TELEGRAMS list
         */

        /**
         * Constructs a new CMD_GAME_TOOLS_LOAD_TELEGRAMS.
         * @memberof tg
         * @classdesc Represents a CMD_GAME_TOOLS_LOAD_TELEGRAMS.
         * @implements ICMD_GAME_TOOLS_LOAD_TELEGRAMS
         * @constructor
         * @param {tg.ICMD_GAME_TOOLS_LOAD_TELEGRAMS=} [properties] Properties to set
         */
        function CMD_GAME_TOOLS_LOAD_TELEGRAMS(properties) {
            this.list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_GAME_TOOLS_LOAD_TELEGRAMS list.
         * @member {Array.<tg.ICMD_GAME_TOOLS_TELEGRAM_INF>} list
         * @memberof tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS
         * @instance
         */
        CMD_GAME_TOOLS_LOAD_TELEGRAMS.prototype.list = $util.emptyArray;

        /**
         * Creates a new CMD_GAME_TOOLS_LOAD_TELEGRAMS instance using the specified properties.
         * @function create
         * @memberof tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS
         * @static
         * @param {tg.ICMD_GAME_TOOLS_LOAD_TELEGRAMS=} [properties] Properties to set
         * @returns {tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS} CMD_GAME_TOOLS_LOAD_TELEGRAMS instance
         */
        CMD_GAME_TOOLS_LOAD_TELEGRAMS.create = function create(properties) {
            return new CMD_GAME_TOOLS_LOAD_TELEGRAMS(properties);
        };

        /**
         * Encodes the specified CMD_GAME_TOOLS_LOAD_TELEGRAMS message. Does not implicitly {@link tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS
         * @static
         * @param {tg.ICMD_GAME_TOOLS_LOAD_TELEGRAMS} message CMD_GAME_TOOLS_LOAD_TELEGRAMS message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_GAME_TOOLS_LOAD_TELEGRAMS.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.list != null && message.list.length)
                for (var i = 0; i < message.list.length; ++i)
                    $root.tg.CMD_GAME_TOOLS_TELEGRAM_INF.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CMD_GAME_TOOLS_LOAD_TELEGRAMS message, length delimited. Does not implicitly {@link tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS
         * @static
         * @param {tg.ICMD_GAME_TOOLS_LOAD_TELEGRAMS} message CMD_GAME_TOOLS_LOAD_TELEGRAMS message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_GAME_TOOLS_LOAD_TELEGRAMS.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_GAME_TOOLS_LOAD_TELEGRAMS message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS} CMD_GAME_TOOLS_LOAD_TELEGRAMS
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_GAME_TOOLS_LOAD_TELEGRAMS.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.tg.CMD_GAME_TOOLS_TELEGRAM_INF.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_GAME_TOOLS_LOAD_TELEGRAMS message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS} CMD_GAME_TOOLS_LOAD_TELEGRAMS
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_GAME_TOOLS_LOAD_TELEGRAMS.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_GAME_TOOLS_LOAD_TELEGRAMS message.
         * @function verify
         * @memberof tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_GAME_TOOLS_LOAD_TELEGRAMS.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.list != null && message.hasOwnProperty("list")) {
                if (!Array.isArray(message.list))
                    return "list: array expected";
                for (var i = 0; i < message.list.length; ++i) {
                    var error = $root.tg.CMD_GAME_TOOLS_TELEGRAM_INF.verify(message.list[i]);
                    if (error)
                        return "list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CMD_GAME_TOOLS_LOAD_TELEGRAMS message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS} CMD_GAME_TOOLS_LOAD_TELEGRAMS
         */
        CMD_GAME_TOOLS_LOAD_TELEGRAMS.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS)
                return object;
            var message = new $root.tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS();
            if (object.list) {
                if (!Array.isArray(object.list))
                    throw TypeError(".tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS.list: array expected");
                message.list = [];
                for (var i = 0; i < object.list.length; ++i) {
                    if (typeof object.list[i] !== "object")
                        throw TypeError(".tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS.list: object expected");
                    message.list[i] = $root.tg.CMD_GAME_TOOLS_TELEGRAM_INF.fromObject(object.list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CMD_GAME_TOOLS_LOAD_TELEGRAMS message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS
         * @static
         * @param {tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS} message CMD_GAME_TOOLS_LOAD_TELEGRAMS
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_GAME_TOOLS_LOAD_TELEGRAMS.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.list = [];
            if (message.list && message.list.length) {
                object.list = [];
                for (var j = 0; j < message.list.length; ++j)
                    object.list[j] = $root.tg.CMD_GAME_TOOLS_TELEGRAM_INF.toObject(message.list[j], options);
            }
            return object;
        };

        /**
         * Converts this CMD_GAME_TOOLS_LOAD_TELEGRAMS to JSON.
         * @function toJSON
         * @memberof tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_GAME_TOOLS_LOAD_TELEGRAMS.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_GAME_TOOLS_LOAD_TELEGRAMS
         * @function getTypeUrl
         * @memberof tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_GAME_TOOLS_LOAD_TELEGRAMS.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS";
        };

        return CMD_GAME_TOOLS_LOAD_TELEGRAMS;
    })();

    tg.CMD_IM_PRIVATE_DELETE = (function() {

        /**
         * Properties of a CMD_IM_PRIVATE_DELETE.
         * @memberof tg
         * @interface ICMD_IM_PRIVATE_DELETE
         * @property {string|null} [account] CMD_IM_PRIVATE_DELETE account
         * @property {string|null} [token] CMD_IM_PRIVATE_DELETE token
         */

        /**
         * Constructs a new CMD_IM_PRIVATE_DELETE.
         * @memberof tg
         * @classdesc Represents a CMD_IM_PRIVATE_DELETE.
         * @implements ICMD_IM_PRIVATE_DELETE
         * @constructor
         * @param {tg.ICMD_IM_PRIVATE_DELETE=} [properties] Properties to set
         */
        function CMD_IM_PRIVATE_DELETE(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_IM_PRIVATE_DELETE account.
         * @member {string} account
         * @memberof tg.CMD_IM_PRIVATE_DELETE
         * @instance
         */
        CMD_IM_PRIVATE_DELETE.prototype.account = "";

        /**
         * CMD_IM_PRIVATE_DELETE token.
         * @member {string} token
         * @memberof tg.CMD_IM_PRIVATE_DELETE
         * @instance
         */
        CMD_IM_PRIVATE_DELETE.prototype.token = "";

        /**
         * Creates a new CMD_IM_PRIVATE_DELETE instance using the specified properties.
         * @function create
         * @memberof tg.CMD_IM_PRIVATE_DELETE
         * @static
         * @param {tg.ICMD_IM_PRIVATE_DELETE=} [properties] Properties to set
         * @returns {tg.CMD_IM_PRIVATE_DELETE} CMD_IM_PRIVATE_DELETE instance
         */
        CMD_IM_PRIVATE_DELETE.create = function create(properties) {
            return new CMD_IM_PRIVATE_DELETE(properties);
        };

        /**
         * Encodes the specified CMD_IM_PRIVATE_DELETE message. Does not implicitly {@link tg.CMD_IM_PRIVATE_DELETE.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_IM_PRIVATE_DELETE
         * @static
         * @param {tg.ICMD_IM_PRIVATE_DELETE} message CMD_IM_PRIVATE_DELETE message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_IM_PRIVATE_DELETE.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.account);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.token);
            return writer;
        };

        /**
         * Encodes the specified CMD_IM_PRIVATE_DELETE message, length delimited. Does not implicitly {@link tg.CMD_IM_PRIVATE_DELETE.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_IM_PRIVATE_DELETE
         * @static
         * @param {tg.ICMD_IM_PRIVATE_DELETE} message CMD_IM_PRIVATE_DELETE message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_IM_PRIVATE_DELETE.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_IM_PRIVATE_DELETE message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_IM_PRIVATE_DELETE
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_IM_PRIVATE_DELETE} CMD_IM_PRIVATE_DELETE
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_IM_PRIVATE_DELETE.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_IM_PRIVATE_DELETE();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.account = reader.string();
                        break;
                    }
                case 2: {
                        message.token = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_IM_PRIVATE_DELETE message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_IM_PRIVATE_DELETE
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_IM_PRIVATE_DELETE} CMD_IM_PRIVATE_DELETE
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_IM_PRIVATE_DELETE.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_IM_PRIVATE_DELETE message.
         * @function verify
         * @memberof tg.CMD_IM_PRIVATE_DELETE
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_IM_PRIVATE_DELETE.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isString(message.account))
                    return "account: string expected";
            if (message.token != null && message.hasOwnProperty("token"))
                if (!$util.isString(message.token))
                    return "token: string expected";
            return null;
        };

        /**
         * Creates a CMD_IM_PRIVATE_DELETE message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_IM_PRIVATE_DELETE
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_IM_PRIVATE_DELETE} CMD_IM_PRIVATE_DELETE
         */
        CMD_IM_PRIVATE_DELETE.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_IM_PRIVATE_DELETE)
                return object;
            var message = new $root.tg.CMD_IM_PRIVATE_DELETE();
            if (object.account != null)
                message.account = String(object.account);
            if (object.token != null)
                message.token = String(object.token);
            return message;
        };

        /**
         * Creates a plain object from a CMD_IM_PRIVATE_DELETE message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_IM_PRIVATE_DELETE
         * @static
         * @param {tg.CMD_IM_PRIVATE_DELETE} message CMD_IM_PRIVATE_DELETE
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_IM_PRIVATE_DELETE.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.account = "";
                object.token = "";
            }
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = message.token;
            return object;
        };

        /**
         * Converts this CMD_IM_PRIVATE_DELETE to JSON.
         * @function toJSON
         * @memberof tg.CMD_IM_PRIVATE_DELETE
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_IM_PRIVATE_DELETE.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_IM_PRIVATE_DELETE
         * @function getTypeUrl
         * @memberof tg.CMD_IM_PRIVATE_DELETE
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_IM_PRIVATE_DELETE.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_IM_PRIVATE_DELETE";
        };

        return CMD_IM_PRIVATE_DELETE;
    })();

    tg.CMD_TELEGRAM_ACCOUNTS_REQ = (function() {

        /**
         * Properties of a CMD_TELEGRAM_ACCOUNTS_REQ.
         * @memberof tg
         * @interface ICMD_TELEGRAM_ACCOUNTS_REQ
         * @property {string|null} [username] CMD_TELEGRAM_ACCOUNTS_REQ username
         * @property {string|null} [session] CMD_TELEGRAM_ACCOUNTS_REQ session
         * @property {number|null} [type] CMD_TELEGRAM_ACCOUNTS_REQ type
         */

        /**
         * Constructs a new CMD_TELEGRAM_ACCOUNTS_REQ.
         * @memberof tg
         * @classdesc Represents a CMD_TELEGRAM_ACCOUNTS_REQ.
         * @implements ICMD_TELEGRAM_ACCOUNTS_REQ
         * @constructor
         * @param {tg.ICMD_TELEGRAM_ACCOUNTS_REQ=} [properties] Properties to set
         */
        function CMD_TELEGRAM_ACCOUNTS_REQ(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_TELEGRAM_ACCOUNTS_REQ username.
         * @member {string} username
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_REQ
         * @instance
         */
        CMD_TELEGRAM_ACCOUNTS_REQ.prototype.username = "";

        /**
         * CMD_TELEGRAM_ACCOUNTS_REQ session.
         * @member {string} session
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_REQ
         * @instance
         */
        CMD_TELEGRAM_ACCOUNTS_REQ.prototype.session = "";

        /**
         * CMD_TELEGRAM_ACCOUNTS_REQ type.
         * @member {number} type
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_REQ
         * @instance
         */
        CMD_TELEGRAM_ACCOUNTS_REQ.prototype.type = 0;

        /**
         * Creates a new CMD_TELEGRAM_ACCOUNTS_REQ instance using the specified properties.
         * @function create
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_REQ
         * @static
         * @param {tg.ICMD_TELEGRAM_ACCOUNTS_REQ=} [properties] Properties to set
         * @returns {tg.CMD_TELEGRAM_ACCOUNTS_REQ} CMD_TELEGRAM_ACCOUNTS_REQ instance
         */
        CMD_TELEGRAM_ACCOUNTS_REQ.create = function create(properties) {
            return new CMD_TELEGRAM_ACCOUNTS_REQ(properties);
        };

        /**
         * Encodes the specified CMD_TELEGRAM_ACCOUNTS_REQ message. Does not implicitly {@link tg.CMD_TELEGRAM_ACCOUNTS_REQ.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_REQ
         * @static
         * @param {tg.ICMD_TELEGRAM_ACCOUNTS_REQ} message CMD_TELEGRAM_ACCOUNTS_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_TELEGRAM_ACCOUNTS_REQ.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.username);
            if (message.session != null && Object.hasOwnProperty.call(message, "session"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.session);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.type);
            return writer;
        };

        /**
         * Encodes the specified CMD_TELEGRAM_ACCOUNTS_REQ message, length delimited. Does not implicitly {@link tg.CMD_TELEGRAM_ACCOUNTS_REQ.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_REQ
         * @static
         * @param {tg.ICMD_TELEGRAM_ACCOUNTS_REQ} message CMD_TELEGRAM_ACCOUNTS_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_TELEGRAM_ACCOUNTS_REQ.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_TELEGRAM_ACCOUNTS_REQ message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_TELEGRAM_ACCOUNTS_REQ} CMD_TELEGRAM_ACCOUNTS_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_TELEGRAM_ACCOUNTS_REQ.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_TELEGRAM_ACCOUNTS_REQ();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.username = reader.string();
                        break;
                    }
                case 2: {
                        message.session = reader.string();
                        break;
                    }
                case 3: {
                        message.type = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_TELEGRAM_ACCOUNTS_REQ message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_TELEGRAM_ACCOUNTS_REQ} CMD_TELEGRAM_ACCOUNTS_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_TELEGRAM_ACCOUNTS_REQ.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_TELEGRAM_ACCOUNTS_REQ message.
         * @function verify
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_REQ
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_TELEGRAM_ACCOUNTS_REQ.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.session != null && message.hasOwnProperty("session"))
                if (!$util.isString(message.session))
                    return "session: string expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isInteger(message.type))
                    return "type: integer expected";
            return null;
        };

        /**
         * Creates a CMD_TELEGRAM_ACCOUNTS_REQ message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_REQ
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_TELEGRAM_ACCOUNTS_REQ} CMD_TELEGRAM_ACCOUNTS_REQ
         */
        CMD_TELEGRAM_ACCOUNTS_REQ.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_TELEGRAM_ACCOUNTS_REQ)
                return object;
            var message = new $root.tg.CMD_TELEGRAM_ACCOUNTS_REQ();
            if (object.username != null)
                message.username = String(object.username);
            if (object.session != null)
                message.session = String(object.session);
            if (object.type != null)
                message.type = object.type | 0;
            return message;
        };

        /**
         * Creates a plain object from a CMD_TELEGRAM_ACCOUNTS_REQ message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_REQ
         * @static
         * @param {tg.CMD_TELEGRAM_ACCOUNTS_REQ} message CMD_TELEGRAM_ACCOUNTS_REQ
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_TELEGRAM_ACCOUNTS_REQ.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.username = "";
                object.session = "";
                object.type = 0;
            }
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.session != null && message.hasOwnProperty("session"))
                object.session = message.session;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            return object;
        };

        /**
         * Converts this CMD_TELEGRAM_ACCOUNTS_REQ to JSON.
         * @function toJSON
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_REQ
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_TELEGRAM_ACCOUNTS_REQ.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_TELEGRAM_ACCOUNTS_REQ
         * @function getTypeUrl
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_REQ
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_TELEGRAM_ACCOUNTS_REQ.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_TELEGRAM_ACCOUNTS_REQ";
        };

        return CMD_TELEGRAM_ACCOUNTS_REQ;
    })();

    tg.CMD_TELEGRAM_ACCOUNTS_RSP = (function() {

        /**
         * Properties of a CMD_TELEGRAM_ACCOUNTS_RSP.
         * @memberof tg
         * @interface ICMD_TELEGRAM_ACCOUNTS_RSP
         * @property {Array.<tg.ICMD_GAME_TOOLS_TELEGRAM_INF>|null} [list] CMD_TELEGRAM_ACCOUNTS_RSP list
         */

        /**
         * Constructs a new CMD_TELEGRAM_ACCOUNTS_RSP.
         * @memberof tg
         * @classdesc Represents a CMD_TELEGRAM_ACCOUNTS_RSP.
         * @implements ICMD_TELEGRAM_ACCOUNTS_RSP
         * @constructor
         * @param {tg.ICMD_TELEGRAM_ACCOUNTS_RSP=} [properties] Properties to set
         */
        function CMD_TELEGRAM_ACCOUNTS_RSP(properties) {
            this.list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_TELEGRAM_ACCOUNTS_RSP list.
         * @member {Array.<tg.ICMD_GAME_TOOLS_TELEGRAM_INF>} list
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_RSP
         * @instance
         */
        CMD_TELEGRAM_ACCOUNTS_RSP.prototype.list = $util.emptyArray;

        /**
         * Creates a new CMD_TELEGRAM_ACCOUNTS_RSP instance using the specified properties.
         * @function create
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_RSP
         * @static
         * @param {tg.ICMD_TELEGRAM_ACCOUNTS_RSP=} [properties] Properties to set
         * @returns {tg.CMD_TELEGRAM_ACCOUNTS_RSP} CMD_TELEGRAM_ACCOUNTS_RSP instance
         */
        CMD_TELEGRAM_ACCOUNTS_RSP.create = function create(properties) {
            return new CMD_TELEGRAM_ACCOUNTS_RSP(properties);
        };

        /**
         * Encodes the specified CMD_TELEGRAM_ACCOUNTS_RSP message. Does not implicitly {@link tg.CMD_TELEGRAM_ACCOUNTS_RSP.verify|verify} messages.
         * @function encode
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_RSP
         * @static
         * @param {tg.ICMD_TELEGRAM_ACCOUNTS_RSP} message CMD_TELEGRAM_ACCOUNTS_RSP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_TELEGRAM_ACCOUNTS_RSP.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.list != null && message.list.length)
                for (var i = 0; i < message.list.length; ++i)
                    $root.tg.CMD_GAME_TOOLS_TELEGRAM_INF.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CMD_TELEGRAM_ACCOUNTS_RSP message, length delimited. Does not implicitly {@link tg.CMD_TELEGRAM_ACCOUNTS_RSP.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_RSP
         * @static
         * @param {tg.ICMD_TELEGRAM_ACCOUNTS_RSP} message CMD_TELEGRAM_ACCOUNTS_RSP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_TELEGRAM_ACCOUNTS_RSP.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_TELEGRAM_ACCOUNTS_RSP message from the specified reader or buffer.
         * @function decode
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_RSP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.CMD_TELEGRAM_ACCOUNTS_RSP} CMD_TELEGRAM_ACCOUNTS_RSP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_TELEGRAM_ACCOUNTS_RSP.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.CMD_TELEGRAM_ACCOUNTS_RSP();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.tg.CMD_GAME_TOOLS_TELEGRAM_INF.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_TELEGRAM_ACCOUNTS_RSP message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_RSP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.CMD_TELEGRAM_ACCOUNTS_RSP} CMD_TELEGRAM_ACCOUNTS_RSP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_TELEGRAM_ACCOUNTS_RSP.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_TELEGRAM_ACCOUNTS_RSP message.
         * @function verify
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_RSP
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_TELEGRAM_ACCOUNTS_RSP.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.list != null && message.hasOwnProperty("list")) {
                if (!Array.isArray(message.list))
                    return "list: array expected";
                for (var i = 0; i < message.list.length; ++i) {
                    var error = $root.tg.CMD_GAME_TOOLS_TELEGRAM_INF.verify(message.list[i]);
                    if (error)
                        return "list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CMD_TELEGRAM_ACCOUNTS_RSP message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_RSP
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.CMD_TELEGRAM_ACCOUNTS_RSP} CMD_TELEGRAM_ACCOUNTS_RSP
         */
        CMD_TELEGRAM_ACCOUNTS_RSP.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.CMD_TELEGRAM_ACCOUNTS_RSP)
                return object;
            var message = new $root.tg.CMD_TELEGRAM_ACCOUNTS_RSP();
            if (object.list) {
                if (!Array.isArray(object.list))
                    throw TypeError(".tg.CMD_TELEGRAM_ACCOUNTS_RSP.list: array expected");
                message.list = [];
                for (var i = 0; i < object.list.length; ++i) {
                    if (typeof object.list[i] !== "object")
                        throw TypeError(".tg.CMD_TELEGRAM_ACCOUNTS_RSP.list: object expected");
                    message.list[i] = $root.tg.CMD_GAME_TOOLS_TELEGRAM_INF.fromObject(object.list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CMD_TELEGRAM_ACCOUNTS_RSP message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_RSP
         * @static
         * @param {tg.CMD_TELEGRAM_ACCOUNTS_RSP} message CMD_TELEGRAM_ACCOUNTS_RSP
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_TELEGRAM_ACCOUNTS_RSP.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.list = [];
            if (message.list && message.list.length) {
                object.list = [];
                for (var j = 0; j < message.list.length; ++j)
                    object.list[j] = $root.tg.CMD_GAME_TOOLS_TELEGRAM_INF.toObject(message.list[j], options);
            }
            return object;
        };

        /**
         * Converts this CMD_TELEGRAM_ACCOUNTS_RSP to JSON.
         * @function toJSON
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_RSP
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_TELEGRAM_ACCOUNTS_RSP.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CMD_TELEGRAM_ACCOUNTS_RSP
         * @function getTypeUrl
         * @memberof tg.CMD_TELEGRAM_ACCOUNTS_RSP
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CMD_TELEGRAM_ACCOUNTS_RSP.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.CMD_TELEGRAM_ACCOUNTS_RSP";
        };

        return CMD_TELEGRAM_ACCOUNTS_RSP;
    })();

    tg.TAG_TASK_INFO = (function() {

        /**
         * Properties of a TAG_TASK_INFO.
         * @memberof tg
         * @interface ITAG_TASK_INFO
         * @property {number|null} [index] TAG_TASK_INFO index
         * @property {number|null} [task_type] TAG_TASK_INFO task_type
         * @property {number|null} [status] TAG_TASK_INFO status
         * @property {Array.<string>|null} [phone] TAG_TASK_INFO phone
         * @property {Array.<tg.IChatTarget>|null} [targets] TAG_TASK_INFO targets
         * @property {number|null} [msg_type] TAG_TASK_INFO msg_type
         * @property {string|null} [message] TAG_TASK_INFO message
         * @property {number|Long|null} [start_time] TAG_TASK_INFO start_time
         * @property {number|Long|null} [end_time] TAG_TASK_INFO end_time
         * @property {number|null} [interval] TAG_TASK_INFO interval
         * @property {string|null} [account] TAG_TASK_INFO account
         * @property {string|null} [create_time] TAG_TASK_INFO create_time
         * @property {string|null} [remark] TAG_TASK_INFO remark
         */

        /**
         * Constructs a new TAG_TASK_INFO.
         * @memberof tg
         * @classdesc Represents a TAG_TASK_INFO.
         * @implements ITAG_TASK_INFO
         * @constructor
         * @param {tg.ITAG_TASK_INFO=} [properties] Properties to set
         */
        function TAG_TASK_INFO(properties) {
            this.phone = [];
            this.targets = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TAG_TASK_INFO index.
         * @member {number} index
         * @memberof tg.TAG_TASK_INFO
         * @instance
         */
        TAG_TASK_INFO.prototype.index = 0;

        /**
         * TAG_TASK_INFO task_type.
         * @member {number} task_type
         * @memberof tg.TAG_TASK_INFO
         * @instance
         */
        TAG_TASK_INFO.prototype.task_type = 0;

        /**
         * TAG_TASK_INFO status.
         * @member {number} status
         * @memberof tg.TAG_TASK_INFO
         * @instance
         */
        TAG_TASK_INFO.prototype.status = 0;

        /**
         * TAG_TASK_INFO phone.
         * @member {Array.<string>} phone
         * @memberof tg.TAG_TASK_INFO
         * @instance
         */
        TAG_TASK_INFO.prototype.phone = $util.emptyArray;

        /**
         * TAG_TASK_INFO targets.
         * @member {Array.<tg.IChatTarget>} targets
         * @memberof tg.TAG_TASK_INFO
         * @instance
         */
        TAG_TASK_INFO.prototype.targets = $util.emptyArray;

        /**
         * TAG_TASK_INFO msg_type.
         * @member {number} msg_type
         * @memberof tg.TAG_TASK_INFO
         * @instance
         */
        TAG_TASK_INFO.prototype.msg_type = 0;

        /**
         * TAG_TASK_INFO message.
         * @member {string} message
         * @memberof tg.TAG_TASK_INFO
         * @instance
         */
        TAG_TASK_INFO.prototype.message = "";

        /**
         * TAG_TASK_INFO start_time.
         * @member {number|Long} start_time
         * @memberof tg.TAG_TASK_INFO
         * @instance
         */
        TAG_TASK_INFO.prototype.start_time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TAG_TASK_INFO end_time.
         * @member {number|Long} end_time
         * @memberof tg.TAG_TASK_INFO
         * @instance
         */
        TAG_TASK_INFO.prototype.end_time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TAG_TASK_INFO interval.
         * @member {number} interval
         * @memberof tg.TAG_TASK_INFO
         * @instance
         */
        TAG_TASK_INFO.prototype.interval = 0;

        /**
         * TAG_TASK_INFO account.
         * @member {string} account
         * @memberof tg.TAG_TASK_INFO
         * @instance
         */
        TAG_TASK_INFO.prototype.account = "";

        /**
         * TAG_TASK_INFO create_time.
         * @member {string} create_time
         * @memberof tg.TAG_TASK_INFO
         * @instance
         */
        TAG_TASK_INFO.prototype.create_time = "";

        /**
         * TAG_TASK_INFO remark.
         * @member {string} remark
         * @memberof tg.TAG_TASK_INFO
         * @instance
         */
        TAG_TASK_INFO.prototype.remark = "";

        /**
         * Creates a new TAG_TASK_INFO instance using the specified properties.
         * @function create
         * @memberof tg.TAG_TASK_INFO
         * @static
         * @param {tg.ITAG_TASK_INFO=} [properties] Properties to set
         * @returns {tg.TAG_TASK_INFO} TAG_TASK_INFO instance
         */
        TAG_TASK_INFO.create = function create(properties) {
            return new TAG_TASK_INFO(properties);
        };

        /**
         * Encodes the specified TAG_TASK_INFO message. Does not implicitly {@link tg.TAG_TASK_INFO.verify|verify} messages.
         * @function encode
         * @memberof tg.TAG_TASK_INFO
         * @static
         * @param {tg.ITAG_TASK_INFO} message TAG_TASK_INFO message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TAG_TASK_INFO.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.index);
            if (message.task_type != null && Object.hasOwnProperty.call(message, "task_type"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.task_type);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.status);
            if (message.phone != null && message.phone.length)
                for (var i = 0; i < message.phone.length; ++i)
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.phone[i]);
            if (message.targets != null && message.targets.length)
                for (var i = 0; i < message.targets.length; ++i)
                    $root.tg.ChatTarget.encode(message.targets[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.msg_type != null && Object.hasOwnProperty.call(message, "msg_type"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.msg_type);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.message);
            if (message.start_time != null && Object.hasOwnProperty.call(message, "start_time"))
                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.start_time);
            if (message.end_time != null && Object.hasOwnProperty.call(message, "end_time"))
                writer.uint32(/* id 9, wireType 0 =*/72).int64(message.end_time);
            if (message.interval != null && Object.hasOwnProperty.call(message, "interval"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.interval);
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.account);
            if (message.create_time != null && Object.hasOwnProperty.call(message, "create_time"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.create_time);
            if (message.remark != null && Object.hasOwnProperty.call(message, "remark"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.remark);
            return writer;
        };

        /**
         * Encodes the specified TAG_TASK_INFO message, length delimited. Does not implicitly {@link tg.TAG_TASK_INFO.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.TAG_TASK_INFO
         * @static
         * @param {tg.ITAG_TASK_INFO} message TAG_TASK_INFO message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TAG_TASK_INFO.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TAG_TASK_INFO message from the specified reader or buffer.
         * @function decode
         * @memberof tg.TAG_TASK_INFO
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.TAG_TASK_INFO} TAG_TASK_INFO
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TAG_TASK_INFO.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.TAG_TASK_INFO();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.index = reader.int32();
                        break;
                    }
                case 2: {
                        message.task_type = reader.int32();
                        break;
                    }
                case 3: {
                        message.status = reader.int32();
                        break;
                    }
                case 4: {
                        if (!(message.phone && message.phone.length))
                            message.phone = [];
                        message.phone.push(reader.string());
                        break;
                    }
                case 5: {
                        if (!(message.targets && message.targets.length))
                            message.targets = [];
                        message.targets.push($root.tg.ChatTarget.decode(reader, reader.uint32()));
                        break;
                    }
                case 6: {
                        message.msg_type = reader.int32();
                        break;
                    }
                case 7: {
                        message.message = reader.string();
                        break;
                    }
                case 8: {
                        message.start_time = reader.int64();
                        break;
                    }
                case 9: {
                        message.end_time = reader.int64();
                        break;
                    }
                case 10: {
                        message.interval = reader.int32();
                        break;
                    }
                case 11: {
                        message.account = reader.string();
                        break;
                    }
                case 12: {
                        message.create_time = reader.string();
                        break;
                    }
                case 13: {
                        message.remark = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TAG_TASK_INFO message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.TAG_TASK_INFO
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.TAG_TASK_INFO} TAG_TASK_INFO
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TAG_TASK_INFO.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TAG_TASK_INFO message.
         * @function verify
         * @memberof tg.TAG_TASK_INFO
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TAG_TASK_INFO.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.index != null && message.hasOwnProperty("index"))
                if (!$util.isInteger(message.index))
                    return "index: integer expected";
            if (message.task_type != null && message.hasOwnProperty("task_type"))
                if (!$util.isInteger(message.task_type))
                    return "task_type: integer expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status))
                    return "status: integer expected";
            if (message.phone != null && message.hasOwnProperty("phone")) {
                if (!Array.isArray(message.phone))
                    return "phone: array expected";
                for (var i = 0; i < message.phone.length; ++i)
                    if (!$util.isString(message.phone[i]))
                        return "phone: string[] expected";
            }
            if (message.targets != null && message.hasOwnProperty("targets")) {
                if (!Array.isArray(message.targets))
                    return "targets: array expected";
                for (var i = 0; i < message.targets.length; ++i) {
                    var error = $root.tg.ChatTarget.verify(message.targets[i]);
                    if (error)
                        return "targets." + error;
                }
            }
            if (message.msg_type != null && message.hasOwnProperty("msg_type"))
                if (!$util.isInteger(message.msg_type))
                    return "msg_type: integer expected";
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            if (message.start_time != null && message.hasOwnProperty("start_time"))
                if (!$util.isInteger(message.start_time) && !(message.start_time && $util.isInteger(message.start_time.low) && $util.isInteger(message.start_time.high)))
                    return "start_time: integer|Long expected";
            if (message.end_time != null && message.hasOwnProperty("end_time"))
                if (!$util.isInteger(message.end_time) && !(message.end_time && $util.isInteger(message.end_time.low) && $util.isInteger(message.end_time.high)))
                    return "end_time: integer|Long expected";
            if (message.interval != null && message.hasOwnProperty("interval"))
                if (!$util.isInteger(message.interval))
                    return "interval: integer expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isString(message.account))
                    return "account: string expected";
            if (message.create_time != null && message.hasOwnProperty("create_time"))
                if (!$util.isString(message.create_time))
                    return "create_time: string expected";
            if (message.remark != null && message.hasOwnProperty("remark"))
                if (!$util.isString(message.remark))
                    return "remark: string expected";
            return null;
        };

        /**
         * Creates a TAG_TASK_INFO message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.TAG_TASK_INFO
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.TAG_TASK_INFO} TAG_TASK_INFO
         */
        TAG_TASK_INFO.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.TAG_TASK_INFO)
                return object;
            var message = new $root.tg.TAG_TASK_INFO();
            if (object.index != null)
                message.index = object.index | 0;
            if (object.task_type != null)
                message.task_type = object.task_type | 0;
            if (object.status != null)
                message.status = object.status | 0;
            if (object.phone) {
                if (!Array.isArray(object.phone))
                    throw TypeError(".tg.TAG_TASK_INFO.phone: array expected");
                message.phone = [];
                for (var i = 0; i < object.phone.length; ++i)
                    message.phone[i] = String(object.phone[i]);
            }
            if (object.targets) {
                if (!Array.isArray(object.targets))
                    throw TypeError(".tg.TAG_TASK_INFO.targets: array expected");
                message.targets = [];
                for (var i = 0; i < object.targets.length; ++i) {
                    if (typeof object.targets[i] !== "object")
                        throw TypeError(".tg.TAG_TASK_INFO.targets: object expected");
                    message.targets[i] = $root.tg.ChatTarget.fromObject(object.targets[i]);
                }
            }
            if (object.msg_type != null)
                message.msg_type = object.msg_type | 0;
            if (object.message != null)
                message.message = String(object.message);
            if (object.start_time != null)
                if ($util.Long)
                    (message.start_time = $util.Long.fromValue(object.start_time)).unsigned = false;
                else if (typeof object.start_time === "string")
                    message.start_time = parseInt(object.start_time, 10);
                else if (typeof object.start_time === "number")
                    message.start_time = object.start_time;
                else if (typeof object.start_time === "object")
                    message.start_time = new $util.LongBits(object.start_time.low >>> 0, object.start_time.high >>> 0).toNumber();
            if (object.end_time != null)
                if ($util.Long)
                    (message.end_time = $util.Long.fromValue(object.end_time)).unsigned = false;
                else if (typeof object.end_time === "string")
                    message.end_time = parseInt(object.end_time, 10);
                else if (typeof object.end_time === "number")
                    message.end_time = object.end_time;
                else if (typeof object.end_time === "object")
                    message.end_time = new $util.LongBits(object.end_time.low >>> 0, object.end_time.high >>> 0).toNumber();
            if (object.interval != null)
                message.interval = object.interval | 0;
            if (object.account != null)
                message.account = String(object.account);
            if (object.create_time != null)
                message.create_time = String(object.create_time);
            if (object.remark != null)
                message.remark = String(object.remark);
            return message;
        };

        /**
         * Creates a plain object from a TAG_TASK_INFO message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.TAG_TASK_INFO
         * @static
         * @param {tg.TAG_TASK_INFO} message TAG_TASK_INFO
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TAG_TASK_INFO.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.phone = [];
                object.targets = [];
            }
            if (options.defaults) {
                object.index = 0;
                object.task_type = 0;
                object.status = 0;
                object.msg_type = 0;
                object.message = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.start_time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.start_time = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.end_time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.end_time = options.longs === String ? "0" : 0;
                object.interval = 0;
                object.account = "";
                object.create_time = "";
                object.remark = "";
            }
            if (message.index != null && message.hasOwnProperty("index"))
                object.index = message.index;
            if (message.task_type != null && message.hasOwnProperty("task_type"))
                object.task_type = message.task_type;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.phone && message.phone.length) {
                object.phone = [];
                for (var j = 0; j < message.phone.length; ++j)
                    object.phone[j] = message.phone[j];
            }
            if (message.targets && message.targets.length) {
                object.targets = [];
                for (var j = 0; j < message.targets.length; ++j)
                    object.targets[j] = $root.tg.ChatTarget.toObject(message.targets[j], options);
            }
            if (message.msg_type != null && message.hasOwnProperty("msg_type"))
                object.msg_type = message.msg_type;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            if (message.start_time != null && message.hasOwnProperty("start_time"))
                if (typeof message.start_time === "number")
                    object.start_time = options.longs === String ? String(message.start_time) : message.start_time;
                else
                    object.start_time = options.longs === String ? $util.Long.prototype.toString.call(message.start_time) : options.longs === Number ? new $util.LongBits(message.start_time.low >>> 0, message.start_time.high >>> 0).toNumber() : message.start_time;
            if (message.end_time != null && message.hasOwnProperty("end_time"))
                if (typeof message.end_time === "number")
                    object.end_time = options.longs === String ? String(message.end_time) : message.end_time;
                else
                    object.end_time = options.longs === String ? $util.Long.prototype.toString.call(message.end_time) : options.longs === Number ? new $util.LongBits(message.end_time.low >>> 0, message.end_time.high >>> 0).toNumber() : message.end_time;
            if (message.interval != null && message.hasOwnProperty("interval"))
                object.interval = message.interval;
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            if (message.create_time != null && message.hasOwnProperty("create_time"))
                object.create_time = message.create_time;
            if (message.remark != null && message.hasOwnProperty("remark"))
                object.remark = message.remark;
            return object;
        };

        /**
         * Converts this TAG_TASK_INFO to JSON.
         * @function toJSON
         * @memberof tg.TAG_TASK_INFO
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TAG_TASK_INFO.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for TAG_TASK_INFO
         * @function getTypeUrl
         * @memberof tg.TAG_TASK_INFO
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        TAG_TASK_INFO.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.TAG_TASK_INFO";
        };

        return TAG_TASK_INFO;
    })();

    tg.MDM_GR_CREATE_TASK_REQ = (function() {

        /**
         * Properties of a MDM_GR_CREATE_TASK_REQ.
         * @memberof tg
         * @interface IMDM_GR_CREATE_TASK_REQ
         * @property {string|null} [account] MDM_GR_CREATE_TASK_REQ account
         * @property {tg.ITAG_TASK_INFO|null} [data] MDM_GR_CREATE_TASK_REQ data
         */

        /**
         * Constructs a new MDM_GR_CREATE_TASK_REQ.
         * @memberof tg
         * @classdesc Represents a MDM_GR_CREATE_TASK_REQ.
         * @implements IMDM_GR_CREATE_TASK_REQ
         * @constructor
         * @param {tg.IMDM_GR_CREATE_TASK_REQ=} [properties] Properties to set
         */
        function MDM_GR_CREATE_TASK_REQ(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MDM_GR_CREATE_TASK_REQ account.
         * @member {string} account
         * @memberof tg.MDM_GR_CREATE_TASK_REQ
         * @instance
         */
        MDM_GR_CREATE_TASK_REQ.prototype.account = "";

        /**
         * MDM_GR_CREATE_TASK_REQ data.
         * @member {tg.ITAG_TASK_INFO|null|undefined} data
         * @memberof tg.MDM_GR_CREATE_TASK_REQ
         * @instance
         */
        MDM_GR_CREATE_TASK_REQ.prototype.data = null;

        /**
         * Creates a new MDM_GR_CREATE_TASK_REQ instance using the specified properties.
         * @function create
         * @memberof tg.MDM_GR_CREATE_TASK_REQ
         * @static
         * @param {tg.IMDM_GR_CREATE_TASK_REQ=} [properties] Properties to set
         * @returns {tg.MDM_GR_CREATE_TASK_REQ} MDM_GR_CREATE_TASK_REQ instance
         */
        MDM_GR_CREATE_TASK_REQ.create = function create(properties) {
            return new MDM_GR_CREATE_TASK_REQ(properties);
        };

        /**
         * Encodes the specified MDM_GR_CREATE_TASK_REQ message. Does not implicitly {@link tg.MDM_GR_CREATE_TASK_REQ.verify|verify} messages.
         * @function encode
         * @memberof tg.MDM_GR_CREATE_TASK_REQ
         * @static
         * @param {tg.IMDM_GR_CREATE_TASK_REQ} message MDM_GR_CREATE_TASK_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_CREATE_TASK_REQ.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.account);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                $root.tg.TAG_TASK_INFO.encode(message.data, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified MDM_GR_CREATE_TASK_REQ message, length delimited. Does not implicitly {@link tg.MDM_GR_CREATE_TASK_REQ.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.MDM_GR_CREATE_TASK_REQ
         * @static
         * @param {tg.IMDM_GR_CREATE_TASK_REQ} message MDM_GR_CREATE_TASK_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_CREATE_TASK_REQ.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MDM_GR_CREATE_TASK_REQ message from the specified reader or buffer.
         * @function decode
         * @memberof tg.MDM_GR_CREATE_TASK_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.MDM_GR_CREATE_TASK_REQ} MDM_GR_CREATE_TASK_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_CREATE_TASK_REQ.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.MDM_GR_CREATE_TASK_REQ();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.account = reader.string();
                        break;
                    }
                case 2: {
                        message.data = $root.tg.TAG_TASK_INFO.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MDM_GR_CREATE_TASK_REQ message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.MDM_GR_CREATE_TASK_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.MDM_GR_CREATE_TASK_REQ} MDM_GR_CREATE_TASK_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_CREATE_TASK_REQ.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MDM_GR_CREATE_TASK_REQ message.
         * @function verify
         * @memberof tg.MDM_GR_CREATE_TASK_REQ
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MDM_GR_CREATE_TASK_REQ.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isString(message.account))
                    return "account: string expected";
            if (message.data != null && message.hasOwnProperty("data")) {
                var error = $root.tg.TAG_TASK_INFO.verify(message.data);
                if (error)
                    return "data." + error;
            }
            return null;
        };

        /**
         * Creates a MDM_GR_CREATE_TASK_REQ message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.MDM_GR_CREATE_TASK_REQ
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.MDM_GR_CREATE_TASK_REQ} MDM_GR_CREATE_TASK_REQ
         */
        MDM_GR_CREATE_TASK_REQ.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.MDM_GR_CREATE_TASK_REQ)
                return object;
            var message = new $root.tg.MDM_GR_CREATE_TASK_REQ();
            if (object.account != null)
                message.account = String(object.account);
            if (object.data != null) {
                if (typeof object.data !== "object")
                    throw TypeError(".tg.MDM_GR_CREATE_TASK_REQ.data: object expected");
                message.data = $root.tg.TAG_TASK_INFO.fromObject(object.data);
            }
            return message;
        };

        /**
         * Creates a plain object from a MDM_GR_CREATE_TASK_REQ message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.MDM_GR_CREATE_TASK_REQ
         * @static
         * @param {tg.MDM_GR_CREATE_TASK_REQ} message MDM_GR_CREATE_TASK_REQ
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MDM_GR_CREATE_TASK_REQ.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.account = "";
                object.data = null;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = $root.tg.TAG_TASK_INFO.toObject(message.data, options);
            return object;
        };

        /**
         * Converts this MDM_GR_CREATE_TASK_REQ to JSON.
         * @function toJSON
         * @memberof tg.MDM_GR_CREATE_TASK_REQ
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MDM_GR_CREATE_TASK_REQ.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MDM_GR_CREATE_TASK_REQ
         * @function getTypeUrl
         * @memberof tg.MDM_GR_CREATE_TASK_REQ
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MDM_GR_CREATE_TASK_REQ.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.MDM_GR_CREATE_TASK_REQ";
        };

        return MDM_GR_CREATE_TASK_REQ;
    })();

    tg.MDM_GR_CREATE_TASK_RSP = (function() {

        /**
         * Properties of a MDM_GR_CREATE_TASK_RSP.
         * @memberof tg
         * @interface IMDM_GR_CREATE_TASK_RSP
         * @property {number|null} [code] MDM_GR_CREATE_TASK_RSP code
         * @property {string|null} [reason] MDM_GR_CREATE_TASK_RSP reason
         */

        /**
         * Constructs a new MDM_GR_CREATE_TASK_RSP.
         * @memberof tg
         * @classdesc Represents a MDM_GR_CREATE_TASK_RSP.
         * @implements IMDM_GR_CREATE_TASK_RSP
         * @constructor
         * @param {tg.IMDM_GR_CREATE_TASK_RSP=} [properties] Properties to set
         */
        function MDM_GR_CREATE_TASK_RSP(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MDM_GR_CREATE_TASK_RSP code.
         * @member {number} code
         * @memberof tg.MDM_GR_CREATE_TASK_RSP
         * @instance
         */
        MDM_GR_CREATE_TASK_RSP.prototype.code = 0;

        /**
         * MDM_GR_CREATE_TASK_RSP reason.
         * @member {string} reason
         * @memberof tg.MDM_GR_CREATE_TASK_RSP
         * @instance
         */
        MDM_GR_CREATE_TASK_RSP.prototype.reason = "";

        /**
         * Creates a new MDM_GR_CREATE_TASK_RSP instance using the specified properties.
         * @function create
         * @memberof tg.MDM_GR_CREATE_TASK_RSP
         * @static
         * @param {tg.IMDM_GR_CREATE_TASK_RSP=} [properties] Properties to set
         * @returns {tg.MDM_GR_CREATE_TASK_RSP} MDM_GR_CREATE_TASK_RSP instance
         */
        MDM_GR_CREATE_TASK_RSP.create = function create(properties) {
            return new MDM_GR_CREATE_TASK_RSP(properties);
        };

        /**
         * Encodes the specified MDM_GR_CREATE_TASK_RSP message. Does not implicitly {@link tg.MDM_GR_CREATE_TASK_RSP.verify|verify} messages.
         * @function encode
         * @memberof tg.MDM_GR_CREATE_TASK_RSP
         * @static
         * @param {tg.IMDM_GR_CREATE_TASK_RSP} message MDM_GR_CREATE_TASK_RSP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_CREATE_TASK_RSP.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
            if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.reason);
            return writer;
        };

        /**
         * Encodes the specified MDM_GR_CREATE_TASK_RSP message, length delimited. Does not implicitly {@link tg.MDM_GR_CREATE_TASK_RSP.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.MDM_GR_CREATE_TASK_RSP
         * @static
         * @param {tg.IMDM_GR_CREATE_TASK_RSP} message MDM_GR_CREATE_TASK_RSP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_CREATE_TASK_RSP.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MDM_GR_CREATE_TASK_RSP message from the specified reader or buffer.
         * @function decode
         * @memberof tg.MDM_GR_CREATE_TASK_RSP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.MDM_GR_CREATE_TASK_RSP} MDM_GR_CREATE_TASK_RSP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_CREATE_TASK_RSP.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.MDM_GR_CREATE_TASK_RSP();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.code = reader.int32();
                        break;
                    }
                case 2: {
                        message.reason = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MDM_GR_CREATE_TASK_RSP message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.MDM_GR_CREATE_TASK_RSP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.MDM_GR_CREATE_TASK_RSP} MDM_GR_CREATE_TASK_RSP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_CREATE_TASK_RSP.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MDM_GR_CREATE_TASK_RSP message.
         * @function verify
         * @memberof tg.MDM_GR_CREATE_TASK_RSP
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MDM_GR_CREATE_TASK_RSP.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code))
                    return "code: integer expected";
            if (message.reason != null && message.hasOwnProperty("reason"))
                if (!$util.isString(message.reason))
                    return "reason: string expected";
            return null;
        };

        /**
         * Creates a MDM_GR_CREATE_TASK_RSP message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.MDM_GR_CREATE_TASK_RSP
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.MDM_GR_CREATE_TASK_RSP} MDM_GR_CREATE_TASK_RSP
         */
        MDM_GR_CREATE_TASK_RSP.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.MDM_GR_CREATE_TASK_RSP)
                return object;
            var message = new $root.tg.MDM_GR_CREATE_TASK_RSP();
            if (object.code != null)
                message.code = object.code | 0;
            if (object.reason != null)
                message.reason = String(object.reason);
            return message;
        };

        /**
         * Creates a plain object from a MDM_GR_CREATE_TASK_RSP message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.MDM_GR_CREATE_TASK_RSP
         * @static
         * @param {tg.MDM_GR_CREATE_TASK_RSP} message MDM_GR_CREATE_TASK_RSP
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MDM_GR_CREATE_TASK_RSP.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.code = 0;
                object.reason = "";
            }
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.reason != null && message.hasOwnProperty("reason"))
                object.reason = message.reason;
            return object;
        };

        /**
         * Converts this MDM_GR_CREATE_TASK_RSP to JSON.
         * @function toJSON
         * @memberof tg.MDM_GR_CREATE_TASK_RSP
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MDM_GR_CREATE_TASK_RSP.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MDM_GR_CREATE_TASK_RSP
         * @function getTypeUrl
         * @memberof tg.MDM_GR_CREATE_TASK_RSP
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MDM_GR_CREATE_TASK_RSP.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.MDM_GR_CREATE_TASK_RSP";
        };

        return MDM_GR_CREATE_TASK_RSP;
    })();

    tg.MDM_GR_SELECT_TASK_REQ = (function() {

        /**
         * Properties of a MDM_GR_SELECT_TASK_REQ.
         * @memberof tg
         * @interface IMDM_GR_SELECT_TASK_REQ
         * @property {string|null} [account] MDM_GR_SELECT_TASK_REQ account
         */

        /**
         * Constructs a new MDM_GR_SELECT_TASK_REQ.
         * @memberof tg
         * @classdesc Represents a MDM_GR_SELECT_TASK_REQ.
         * @implements IMDM_GR_SELECT_TASK_REQ
         * @constructor
         * @param {tg.IMDM_GR_SELECT_TASK_REQ=} [properties] Properties to set
         */
        function MDM_GR_SELECT_TASK_REQ(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MDM_GR_SELECT_TASK_REQ account.
         * @member {string} account
         * @memberof tg.MDM_GR_SELECT_TASK_REQ
         * @instance
         */
        MDM_GR_SELECT_TASK_REQ.prototype.account = "";

        /**
         * Creates a new MDM_GR_SELECT_TASK_REQ instance using the specified properties.
         * @function create
         * @memberof tg.MDM_GR_SELECT_TASK_REQ
         * @static
         * @param {tg.IMDM_GR_SELECT_TASK_REQ=} [properties] Properties to set
         * @returns {tg.MDM_GR_SELECT_TASK_REQ} MDM_GR_SELECT_TASK_REQ instance
         */
        MDM_GR_SELECT_TASK_REQ.create = function create(properties) {
            return new MDM_GR_SELECT_TASK_REQ(properties);
        };

        /**
         * Encodes the specified MDM_GR_SELECT_TASK_REQ message. Does not implicitly {@link tg.MDM_GR_SELECT_TASK_REQ.verify|verify} messages.
         * @function encode
         * @memberof tg.MDM_GR_SELECT_TASK_REQ
         * @static
         * @param {tg.IMDM_GR_SELECT_TASK_REQ} message MDM_GR_SELECT_TASK_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_SELECT_TASK_REQ.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.account);
            return writer;
        };

        /**
         * Encodes the specified MDM_GR_SELECT_TASK_REQ message, length delimited. Does not implicitly {@link tg.MDM_GR_SELECT_TASK_REQ.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.MDM_GR_SELECT_TASK_REQ
         * @static
         * @param {tg.IMDM_GR_SELECT_TASK_REQ} message MDM_GR_SELECT_TASK_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_SELECT_TASK_REQ.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MDM_GR_SELECT_TASK_REQ message from the specified reader or buffer.
         * @function decode
         * @memberof tg.MDM_GR_SELECT_TASK_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.MDM_GR_SELECT_TASK_REQ} MDM_GR_SELECT_TASK_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_SELECT_TASK_REQ.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.MDM_GR_SELECT_TASK_REQ();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.account = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MDM_GR_SELECT_TASK_REQ message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.MDM_GR_SELECT_TASK_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.MDM_GR_SELECT_TASK_REQ} MDM_GR_SELECT_TASK_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_SELECT_TASK_REQ.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MDM_GR_SELECT_TASK_REQ message.
         * @function verify
         * @memberof tg.MDM_GR_SELECT_TASK_REQ
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MDM_GR_SELECT_TASK_REQ.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isString(message.account))
                    return "account: string expected";
            return null;
        };

        /**
         * Creates a MDM_GR_SELECT_TASK_REQ message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.MDM_GR_SELECT_TASK_REQ
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.MDM_GR_SELECT_TASK_REQ} MDM_GR_SELECT_TASK_REQ
         */
        MDM_GR_SELECT_TASK_REQ.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.MDM_GR_SELECT_TASK_REQ)
                return object;
            var message = new $root.tg.MDM_GR_SELECT_TASK_REQ();
            if (object.account != null)
                message.account = String(object.account);
            return message;
        };

        /**
         * Creates a plain object from a MDM_GR_SELECT_TASK_REQ message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.MDM_GR_SELECT_TASK_REQ
         * @static
         * @param {tg.MDM_GR_SELECT_TASK_REQ} message MDM_GR_SELECT_TASK_REQ
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MDM_GR_SELECT_TASK_REQ.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.account = "";
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            return object;
        };

        /**
         * Converts this MDM_GR_SELECT_TASK_REQ to JSON.
         * @function toJSON
         * @memberof tg.MDM_GR_SELECT_TASK_REQ
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MDM_GR_SELECT_TASK_REQ.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MDM_GR_SELECT_TASK_REQ
         * @function getTypeUrl
         * @memberof tg.MDM_GR_SELECT_TASK_REQ
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MDM_GR_SELECT_TASK_REQ.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.MDM_GR_SELECT_TASK_REQ";
        };

        return MDM_GR_SELECT_TASK_REQ;
    })();

    tg.MDM_GR_SELECT_TASK_RSP = (function() {

        /**
         * Properties of a MDM_GR_SELECT_TASK_RSP.
         * @memberof tg
         * @interface IMDM_GR_SELECT_TASK_RSP
         * @property {Array.<tg.ITAG_TASK_INFO>|null} [list] MDM_GR_SELECT_TASK_RSP list
         */

        /**
         * Constructs a new MDM_GR_SELECT_TASK_RSP.
         * @memberof tg
         * @classdesc Represents a MDM_GR_SELECT_TASK_RSP.
         * @implements IMDM_GR_SELECT_TASK_RSP
         * @constructor
         * @param {tg.IMDM_GR_SELECT_TASK_RSP=} [properties] Properties to set
         */
        function MDM_GR_SELECT_TASK_RSP(properties) {
            this.list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MDM_GR_SELECT_TASK_RSP list.
         * @member {Array.<tg.ITAG_TASK_INFO>} list
         * @memberof tg.MDM_GR_SELECT_TASK_RSP
         * @instance
         */
        MDM_GR_SELECT_TASK_RSP.prototype.list = $util.emptyArray;

        /**
         * Creates a new MDM_GR_SELECT_TASK_RSP instance using the specified properties.
         * @function create
         * @memberof tg.MDM_GR_SELECT_TASK_RSP
         * @static
         * @param {tg.IMDM_GR_SELECT_TASK_RSP=} [properties] Properties to set
         * @returns {tg.MDM_GR_SELECT_TASK_RSP} MDM_GR_SELECT_TASK_RSP instance
         */
        MDM_GR_SELECT_TASK_RSP.create = function create(properties) {
            return new MDM_GR_SELECT_TASK_RSP(properties);
        };

        /**
         * Encodes the specified MDM_GR_SELECT_TASK_RSP message. Does not implicitly {@link tg.MDM_GR_SELECT_TASK_RSP.verify|verify} messages.
         * @function encode
         * @memberof tg.MDM_GR_SELECT_TASK_RSP
         * @static
         * @param {tg.IMDM_GR_SELECT_TASK_RSP} message MDM_GR_SELECT_TASK_RSP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_SELECT_TASK_RSP.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.list != null && message.list.length)
                for (var i = 0; i < message.list.length; ++i)
                    $root.tg.TAG_TASK_INFO.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified MDM_GR_SELECT_TASK_RSP message, length delimited. Does not implicitly {@link tg.MDM_GR_SELECT_TASK_RSP.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.MDM_GR_SELECT_TASK_RSP
         * @static
         * @param {tg.IMDM_GR_SELECT_TASK_RSP} message MDM_GR_SELECT_TASK_RSP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_SELECT_TASK_RSP.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MDM_GR_SELECT_TASK_RSP message from the specified reader or buffer.
         * @function decode
         * @memberof tg.MDM_GR_SELECT_TASK_RSP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.MDM_GR_SELECT_TASK_RSP} MDM_GR_SELECT_TASK_RSP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_SELECT_TASK_RSP.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.MDM_GR_SELECT_TASK_RSP();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.tg.TAG_TASK_INFO.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MDM_GR_SELECT_TASK_RSP message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.MDM_GR_SELECT_TASK_RSP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.MDM_GR_SELECT_TASK_RSP} MDM_GR_SELECT_TASK_RSP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_SELECT_TASK_RSP.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MDM_GR_SELECT_TASK_RSP message.
         * @function verify
         * @memberof tg.MDM_GR_SELECT_TASK_RSP
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MDM_GR_SELECT_TASK_RSP.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.list != null && message.hasOwnProperty("list")) {
                if (!Array.isArray(message.list))
                    return "list: array expected";
                for (var i = 0; i < message.list.length; ++i) {
                    var error = $root.tg.TAG_TASK_INFO.verify(message.list[i]);
                    if (error)
                        return "list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a MDM_GR_SELECT_TASK_RSP message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.MDM_GR_SELECT_TASK_RSP
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.MDM_GR_SELECT_TASK_RSP} MDM_GR_SELECT_TASK_RSP
         */
        MDM_GR_SELECT_TASK_RSP.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.MDM_GR_SELECT_TASK_RSP)
                return object;
            var message = new $root.tg.MDM_GR_SELECT_TASK_RSP();
            if (object.list) {
                if (!Array.isArray(object.list))
                    throw TypeError(".tg.MDM_GR_SELECT_TASK_RSP.list: array expected");
                message.list = [];
                for (var i = 0; i < object.list.length; ++i) {
                    if (typeof object.list[i] !== "object")
                        throw TypeError(".tg.MDM_GR_SELECT_TASK_RSP.list: object expected");
                    message.list[i] = $root.tg.TAG_TASK_INFO.fromObject(object.list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a MDM_GR_SELECT_TASK_RSP message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.MDM_GR_SELECT_TASK_RSP
         * @static
         * @param {tg.MDM_GR_SELECT_TASK_RSP} message MDM_GR_SELECT_TASK_RSP
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MDM_GR_SELECT_TASK_RSP.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.list = [];
            if (message.list && message.list.length) {
                object.list = [];
                for (var j = 0; j < message.list.length; ++j)
                    object.list[j] = $root.tg.TAG_TASK_INFO.toObject(message.list[j], options);
            }
            return object;
        };

        /**
         * Converts this MDM_GR_SELECT_TASK_RSP to JSON.
         * @function toJSON
         * @memberof tg.MDM_GR_SELECT_TASK_RSP
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MDM_GR_SELECT_TASK_RSP.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MDM_GR_SELECT_TASK_RSP
         * @function getTypeUrl
         * @memberof tg.MDM_GR_SELECT_TASK_RSP
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MDM_GR_SELECT_TASK_RSP.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.MDM_GR_SELECT_TASK_RSP";
        };

        return MDM_GR_SELECT_TASK_RSP;
    })();

    tg.MDM_GR_DELETE_TASK_REQ = (function() {

        /**
         * Properties of a MDM_GR_DELETE_TASK_REQ.
         * @memberof tg
         * @interface IMDM_GR_DELETE_TASK_REQ
         * @property {string|null} [account] MDM_GR_DELETE_TASK_REQ account
         * @property {Array.<number>|null} [index] MDM_GR_DELETE_TASK_REQ index
         */

        /**
         * Constructs a new MDM_GR_DELETE_TASK_REQ.
         * @memberof tg
         * @classdesc Represents a MDM_GR_DELETE_TASK_REQ.
         * @implements IMDM_GR_DELETE_TASK_REQ
         * @constructor
         * @param {tg.IMDM_GR_DELETE_TASK_REQ=} [properties] Properties to set
         */
        function MDM_GR_DELETE_TASK_REQ(properties) {
            this.index = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MDM_GR_DELETE_TASK_REQ account.
         * @member {string} account
         * @memberof tg.MDM_GR_DELETE_TASK_REQ
         * @instance
         */
        MDM_GR_DELETE_TASK_REQ.prototype.account = "";

        /**
         * MDM_GR_DELETE_TASK_REQ index.
         * @member {Array.<number>} index
         * @memberof tg.MDM_GR_DELETE_TASK_REQ
         * @instance
         */
        MDM_GR_DELETE_TASK_REQ.prototype.index = $util.emptyArray;

        /**
         * Creates a new MDM_GR_DELETE_TASK_REQ instance using the specified properties.
         * @function create
         * @memberof tg.MDM_GR_DELETE_TASK_REQ
         * @static
         * @param {tg.IMDM_GR_DELETE_TASK_REQ=} [properties] Properties to set
         * @returns {tg.MDM_GR_DELETE_TASK_REQ} MDM_GR_DELETE_TASK_REQ instance
         */
        MDM_GR_DELETE_TASK_REQ.create = function create(properties) {
            return new MDM_GR_DELETE_TASK_REQ(properties);
        };

        /**
         * Encodes the specified MDM_GR_DELETE_TASK_REQ message. Does not implicitly {@link tg.MDM_GR_DELETE_TASK_REQ.verify|verify} messages.
         * @function encode
         * @memberof tg.MDM_GR_DELETE_TASK_REQ
         * @static
         * @param {tg.IMDM_GR_DELETE_TASK_REQ} message MDM_GR_DELETE_TASK_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_DELETE_TASK_REQ.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.account);
            if (message.index != null && message.index.length) {
                writer.uint32(/* id 2, wireType 2 =*/18).fork();
                for (var i = 0; i < message.index.length; ++i)
                    writer.int32(message.index[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified MDM_GR_DELETE_TASK_REQ message, length delimited. Does not implicitly {@link tg.MDM_GR_DELETE_TASK_REQ.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.MDM_GR_DELETE_TASK_REQ
         * @static
         * @param {tg.IMDM_GR_DELETE_TASK_REQ} message MDM_GR_DELETE_TASK_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_DELETE_TASK_REQ.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MDM_GR_DELETE_TASK_REQ message from the specified reader or buffer.
         * @function decode
         * @memberof tg.MDM_GR_DELETE_TASK_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.MDM_GR_DELETE_TASK_REQ} MDM_GR_DELETE_TASK_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_DELETE_TASK_REQ.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.MDM_GR_DELETE_TASK_REQ();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.account = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.index && message.index.length))
                            message.index = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.index.push(reader.int32());
                        } else
                            message.index.push(reader.int32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MDM_GR_DELETE_TASK_REQ message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.MDM_GR_DELETE_TASK_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.MDM_GR_DELETE_TASK_REQ} MDM_GR_DELETE_TASK_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_DELETE_TASK_REQ.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MDM_GR_DELETE_TASK_REQ message.
         * @function verify
         * @memberof tg.MDM_GR_DELETE_TASK_REQ
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MDM_GR_DELETE_TASK_REQ.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isString(message.account))
                    return "account: string expected";
            if (message.index != null && message.hasOwnProperty("index")) {
                if (!Array.isArray(message.index))
                    return "index: array expected";
                for (var i = 0; i < message.index.length; ++i)
                    if (!$util.isInteger(message.index[i]))
                        return "index: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a MDM_GR_DELETE_TASK_REQ message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.MDM_GR_DELETE_TASK_REQ
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.MDM_GR_DELETE_TASK_REQ} MDM_GR_DELETE_TASK_REQ
         */
        MDM_GR_DELETE_TASK_REQ.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.MDM_GR_DELETE_TASK_REQ)
                return object;
            var message = new $root.tg.MDM_GR_DELETE_TASK_REQ();
            if (object.account != null)
                message.account = String(object.account);
            if (object.index) {
                if (!Array.isArray(object.index))
                    throw TypeError(".tg.MDM_GR_DELETE_TASK_REQ.index: array expected");
                message.index = [];
                for (var i = 0; i < object.index.length; ++i)
                    message.index[i] = object.index[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a MDM_GR_DELETE_TASK_REQ message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.MDM_GR_DELETE_TASK_REQ
         * @static
         * @param {tg.MDM_GR_DELETE_TASK_REQ} message MDM_GR_DELETE_TASK_REQ
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MDM_GR_DELETE_TASK_REQ.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.index = [];
            if (options.defaults)
                object.account = "";
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            if (message.index && message.index.length) {
                object.index = [];
                for (var j = 0; j < message.index.length; ++j)
                    object.index[j] = message.index[j];
            }
            return object;
        };

        /**
         * Converts this MDM_GR_DELETE_TASK_REQ to JSON.
         * @function toJSON
         * @memberof tg.MDM_GR_DELETE_TASK_REQ
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MDM_GR_DELETE_TASK_REQ.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MDM_GR_DELETE_TASK_REQ
         * @function getTypeUrl
         * @memberof tg.MDM_GR_DELETE_TASK_REQ
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MDM_GR_DELETE_TASK_REQ.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.MDM_GR_DELETE_TASK_REQ";
        };

        return MDM_GR_DELETE_TASK_REQ;
    })();

    tg.MDM_GR_DELETE_TASK_RSP = (function() {

        /**
         * Properties of a MDM_GR_DELETE_TASK_RSP.
         * @memberof tg
         * @interface IMDM_GR_DELETE_TASK_RSP
         * @property {number|null} [code] MDM_GR_DELETE_TASK_RSP code
         * @property {string|null} [reason] MDM_GR_DELETE_TASK_RSP reason
         */

        /**
         * Constructs a new MDM_GR_DELETE_TASK_RSP.
         * @memberof tg
         * @classdesc Represents a MDM_GR_DELETE_TASK_RSP.
         * @implements IMDM_GR_DELETE_TASK_RSP
         * @constructor
         * @param {tg.IMDM_GR_DELETE_TASK_RSP=} [properties] Properties to set
         */
        function MDM_GR_DELETE_TASK_RSP(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MDM_GR_DELETE_TASK_RSP code.
         * @member {number} code
         * @memberof tg.MDM_GR_DELETE_TASK_RSP
         * @instance
         */
        MDM_GR_DELETE_TASK_RSP.prototype.code = 0;

        /**
         * MDM_GR_DELETE_TASK_RSP reason.
         * @member {string} reason
         * @memberof tg.MDM_GR_DELETE_TASK_RSP
         * @instance
         */
        MDM_GR_DELETE_TASK_RSP.prototype.reason = "";

        /**
         * Creates a new MDM_GR_DELETE_TASK_RSP instance using the specified properties.
         * @function create
         * @memberof tg.MDM_GR_DELETE_TASK_RSP
         * @static
         * @param {tg.IMDM_GR_DELETE_TASK_RSP=} [properties] Properties to set
         * @returns {tg.MDM_GR_DELETE_TASK_RSP} MDM_GR_DELETE_TASK_RSP instance
         */
        MDM_GR_DELETE_TASK_RSP.create = function create(properties) {
            return new MDM_GR_DELETE_TASK_RSP(properties);
        };

        /**
         * Encodes the specified MDM_GR_DELETE_TASK_RSP message. Does not implicitly {@link tg.MDM_GR_DELETE_TASK_RSP.verify|verify} messages.
         * @function encode
         * @memberof tg.MDM_GR_DELETE_TASK_RSP
         * @static
         * @param {tg.IMDM_GR_DELETE_TASK_RSP} message MDM_GR_DELETE_TASK_RSP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_DELETE_TASK_RSP.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
            if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.reason);
            return writer;
        };

        /**
         * Encodes the specified MDM_GR_DELETE_TASK_RSP message, length delimited. Does not implicitly {@link tg.MDM_GR_DELETE_TASK_RSP.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.MDM_GR_DELETE_TASK_RSP
         * @static
         * @param {tg.IMDM_GR_DELETE_TASK_RSP} message MDM_GR_DELETE_TASK_RSP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_DELETE_TASK_RSP.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MDM_GR_DELETE_TASK_RSP message from the specified reader or buffer.
         * @function decode
         * @memberof tg.MDM_GR_DELETE_TASK_RSP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.MDM_GR_DELETE_TASK_RSP} MDM_GR_DELETE_TASK_RSP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_DELETE_TASK_RSP.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.MDM_GR_DELETE_TASK_RSP();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.code = reader.int32();
                        break;
                    }
                case 2: {
                        message.reason = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MDM_GR_DELETE_TASK_RSP message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.MDM_GR_DELETE_TASK_RSP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.MDM_GR_DELETE_TASK_RSP} MDM_GR_DELETE_TASK_RSP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_DELETE_TASK_RSP.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MDM_GR_DELETE_TASK_RSP message.
         * @function verify
         * @memberof tg.MDM_GR_DELETE_TASK_RSP
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MDM_GR_DELETE_TASK_RSP.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code))
                    return "code: integer expected";
            if (message.reason != null && message.hasOwnProperty("reason"))
                if (!$util.isString(message.reason))
                    return "reason: string expected";
            return null;
        };

        /**
         * Creates a MDM_GR_DELETE_TASK_RSP message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.MDM_GR_DELETE_TASK_RSP
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.MDM_GR_DELETE_TASK_RSP} MDM_GR_DELETE_TASK_RSP
         */
        MDM_GR_DELETE_TASK_RSP.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.MDM_GR_DELETE_TASK_RSP)
                return object;
            var message = new $root.tg.MDM_GR_DELETE_TASK_RSP();
            if (object.code != null)
                message.code = object.code | 0;
            if (object.reason != null)
                message.reason = String(object.reason);
            return message;
        };

        /**
         * Creates a plain object from a MDM_GR_DELETE_TASK_RSP message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.MDM_GR_DELETE_TASK_RSP
         * @static
         * @param {tg.MDM_GR_DELETE_TASK_RSP} message MDM_GR_DELETE_TASK_RSP
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MDM_GR_DELETE_TASK_RSP.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.code = 0;
                object.reason = "";
            }
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.reason != null && message.hasOwnProperty("reason"))
                object.reason = message.reason;
            return object;
        };

        /**
         * Converts this MDM_GR_DELETE_TASK_RSP to JSON.
         * @function toJSON
         * @memberof tg.MDM_GR_DELETE_TASK_RSP
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MDM_GR_DELETE_TASK_RSP.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MDM_GR_DELETE_TASK_RSP
         * @function getTypeUrl
         * @memberof tg.MDM_GR_DELETE_TASK_RSP
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MDM_GR_DELETE_TASK_RSP.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.MDM_GR_DELETE_TASK_RSP";
        };

        return MDM_GR_DELETE_TASK_RSP;
    })();

    tg.MDM_GR_EXECUTE_TASK_REQ = (function() {

        /**
         * Properties of a MDM_GR_EXECUTE_TASK_REQ.
         * @memberof tg
         * @interface IMDM_GR_EXECUTE_TASK_REQ
         * @property {string|null} [account] MDM_GR_EXECUTE_TASK_REQ account
         * @property {Array.<number>|null} [index] MDM_GR_EXECUTE_TASK_REQ index
         */

        /**
         * Constructs a new MDM_GR_EXECUTE_TASK_REQ.
         * @memberof tg
         * @classdesc Represents a MDM_GR_EXECUTE_TASK_REQ.
         * @implements IMDM_GR_EXECUTE_TASK_REQ
         * @constructor
         * @param {tg.IMDM_GR_EXECUTE_TASK_REQ=} [properties] Properties to set
         */
        function MDM_GR_EXECUTE_TASK_REQ(properties) {
            this.index = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MDM_GR_EXECUTE_TASK_REQ account.
         * @member {string} account
         * @memberof tg.MDM_GR_EXECUTE_TASK_REQ
         * @instance
         */
        MDM_GR_EXECUTE_TASK_REQ.prototype.account = "";

        /**
         * MDM_GR_EXECUTE_TASK_REQ index.
         * @member {Array.<number>} index
         * @memberof tg.MDM_GR_EXECUTE_TASK_REQ
         * @instance
         */
        MDM_GR_EXECUTE_TASK_REQ.prototype.index = $util.emptyArray;

        /**
         * Creates a new MDM_GR_EXECUTE_TASK_REQ instance using the specified properties.
         * @function create
         * @memberof tg.MDM_GR_EXECUTE_TASK_REQ
         * @static
         * @param {tg.IMDM_GR_EXECUTE_TASK_REQ=} [properties] Properties to set
         * @returns {tg.MDM_GR_EXECUTE_TASK_REQ} MDM_GR_EXECUTE_TASK_REQ instance
         */
        MDM_GR_EXECUTE_TASK_REQ.create = function create(properties) {
            return new MDM_GR_EXECUTE_TASK_REQ(properties);
        };

        /**
         * Encodes the specified MDM_GR_EXECUTE_TASK_REQ message. Does not implicitly {@link tg.MDM_GR_EXECUTE_TASK_REQ.verify|verify} messages.
         * @function encode
         * @memberof tg.MDM_GR_EXECUTE_TASK_REQ
         * @static
         * @param {tg.IMDM_GR_EXECUTE_TASK_REQ} message MDM_GR_EXECUTE_TASK_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_EXECUTE_TASK_REQ.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.account);
            if (message.index != null && message.index.length) {
                writer.uint32(/* id 2, wireType 2 =*/18).fork();
                for (var i = 0; i < message.index.length; ++i)
                    writer.int32(message.index[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified MDM_GR_EXECUTE_TASK_REQ message, length delimited. Does not implicitly {@link tg.MDM_GR_EXECUTE_TASK_REQ.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.MDM_GR_EXECUTE_TASK_REQ
         * @static
         * @param {tg.IMDM_GR_EXECUTE_TASK_REQ} message MDM_GR_EXECUTE_TASK_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_EXECUTE_TASK_REQ.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MDM_GR_EXECUTE_TASK_REQ message from the specified reader or buffer.
         * @function decode
         * @memberof tg.MDM_GR_EXECUTE_TASK_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.MDM_GR_EXECUTE_TASK_REQ} MDM_GR_EXECUTE_TASK_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_EXECUTE_TASK_REQ.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.MDM_GR_EXECUTE_TASK_REQ();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.account = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.index && message.index.length))
                            message.index = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.index.push(reader.int32());
                        } else
                            message.index.push(reader.int32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MDM_GR_EXECUTE_TASK_REQ message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.MDM_GR_EXECUTE_TASK_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.MDM_GR_EXECUTE_TASK_REQ} MDM_GR_EXECUTE_TASK_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_EXECUTE_TASK_REQ.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MDM_GR_EXECUTE_TASK_REQ message.
         * @function verify
         * @memberof tg.MDM_GR_EXECUTE_TASK_REQ
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MDM_GR_EXECUTE_TASK_REQ.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isString(message.account))
                    return "account: string expected";
            if (message.index != null && message.hasOwnProperty("index")) {
                if (!Array.isArray(message.index))
                    return "index: array expected";
                for (var i = 0; i < message.index.length; ++i)
                    if (!$util.isInteger(message.index[i]))
                        return "index: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a MDM_GR_EXECUTE_TASK_REQ message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.MDM_GR_EXECUTE_TASK_REQ
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.MDM_GR_EXECUTE_TASK_REQ} MDM_GR_EXECUTE_TASK_REQ
         */
        MDM_GR_EXECUTE_TASK_REQ.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.MDM_GR_EXECUTE_TASK_REQ)
                return object;
            var message = new $root.tg.MDM_GR_EXECUTE_TASK_REQ();
            if (object.account != null)
                message.account = String(object.account);
            if (object.index) {
                if (!Array.isArray(object.index))
                    throw TypeError(".tg.MDM_GR_EXECUTE_TASK_REQ.index: array expected");
                message.index = [];
                for (var i = 0; i < object.index.length; ++i)
                    message.index[i] = object.index[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a MDM_GR_EXECUTE_TASK_REQ message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.MDM_GR_EXECUTE_TASK_REQ
         * @static
         * @param {tg.MDM_GR_EXECUTE_TASK_REQ} message MDM_GR_EXECUTE_TASK_REQ
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MDM_GR_EXECUTE_TASK_REQ.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.index = [];
            if (options.defaults)
                object.account = "";
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            if (message.index && message.index.length) {
                object.index = [];
                for (var j = 0; j < message.index.length; ++j)
                    object.index[j] = message.index[j];
            }
            return object;
        };

        /**
         * Converts this MDM_GR_EXECUTE_TASK_REQ to JSON.
         * @function toJSON
         * @memberof tg.MDM_GR_EXECUTE_TASK_REQ
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MDM_GR_EXECUTE_TASK_REQ.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MDM_GR_EXECUTE_TASK_REQ
         * @function getTypeUrl
         * @memberof tg.MDM_GR_EXECUTE_TASK_REQ
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MDM_GR_EXECUTE_TASK_REQ.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.MDM_GR_EXECUTE_TASK_REQ";
        };

        return MDM_GR_EXECUTE_TASK_REQ;
    })();

    tg.MDM_GR_EXECUTE_TASK_RSP = (function() {

        /**
         * Properties of a MDM_GR_EXECUTE_TASK_RSP.
         * @memberof tg
         * @interface IMDM_GR_EXECUTE_TASK_RSP
         * @property {number|null} [index] MDM_GR_EXECUTE_TASK_RSP index
         * @property {number|null} [total] MDM_GR_EXECUTE_TASK_RSP total
         * @property {number|null} [count] MDM_GR_EXECUTE_TASK_RSP count
         * @property {number|null} [code] MDM_GR_EXECUTE_TASK_RSP code
         * @property {string|null} [reason] MDM_GR_EXECUTE_TASK_RSP reason
         * @property {string|null} [sender] MDM_GR_EXECUTE_TASK_RSP sender
         * @property {string|null} [receiver] MDM_GR_EXECUTE_TASK_RSP receiver
         */

        /**
         * Constructs a new MDM_GR_EXECUTE_TASK_RSP.
         * @memberof tg
         * @classdesc Represents a MDM_GR_EXECUTE_TASK_RSP.
         * @implements IMDM_GR_EXECUTE_TASK_RSP
         * @constructor
         * @param {tg.IMDM_GR_EXECUTE_TASK_RSP=} [properties] Properties to set
         */
        function MDM_GR_EXECUTE_TASK_RSP(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MDM_GR_EXECUTE_TASK_RSP index.
         * @member {number} index
         * @memberof tg.MDM_GR_EXECUTE_TASK_RSP
         * @instance
         */
        MDM_GR_EXECUTE_TASK_RSP.prototype.index = 0;

        /**
         * MDM_GR_EXECUTE_TASK_RSP total.
         * @member {number} total
         * @memberof tg.MDM_GR_EXECUTE_TASK_RSP
         * @instance
         */
        MDM_GR_EXECUTE_TASK_RSP.prototype.total = 0;

        /**
         * MDM_GR_EXECUTE_TASK_RSP count.
         * @member {number} count
         * @memberof tg.MDM_GR_EXECUTE_TASK_RSP
         * @instance
         */
        MDM_GR_EXECUTE_TASK_RSP.prototype.count = 0;

        /**
         * MDM_GR_EXECUTE_TASK_RSP code.
         * @member {number} code
         * @memberof tg.MDM_GR_EXECUTE_TASK_RSP
         * @instance
         */
        MDM_GR_EXECUTE_TASK_RSP.prototype.code = 0;

        /**
         * MDM_GR_EXECUTE_TASK_RSP reason.
         * @member {string} reason
         * @memberof tg.MDM_GR_EXECUTE_TASK_RSP
         * @instance
         */
        MDM_GR_EXECUTE_TASK_RSP.prototype.reason = "";

        /**
         * MDM_GR_EXECUTE_TASK_RSP sender.
         * @member {string} sender
         * @memberof tg.MDM_GR_EXECUTE_TASK_RSP
         * @instance
         */
        MDM_GR_EXECUTE_TASK_RSP.prototype.sender = "";

        /**
         * MDM_GR_EXECUTE_TASK_RSP receiver.
         * @member {string} receiver
         * @memberof tg.MDM_GR_EXECUTE_TASK_RSP
         * @instance
         */
        MDM_GR_EXECUTE_TASK_RSP.prototype.receiver = "";

        /**
         * Creates a new MDM_GR_EXECUTE_TASK_RSP instance using the specified properties.
         * @function create
         * @memberof tg.MDM_GR_EXECUTE_TASK_RSP
         * @static
         * @param {tg.IMDM_GR_EXECUTE_TASK_RSP=} [properties] Properties to set
         * @returns {tg.MDM_GR_EXECUTE_TASK_RSP} MDM_GR_EXECUTE_TASK_RSP instance
         */
        MDM_GR_EXECUTE_TASK_RSP.create = function create(properties) {
            return new MDM_GR_EXECUTE_TASK_RSP(properties);
        };

        /**
         * Encodes the specified MDM_GR_EXECUTE_TASK_RSP message. Does not implicitly {@link tg.MDM_GR_EXECUTE_TASK_RSP.verify|verify} messages.
         * @function encode
         * @memberof tg.MDM_GR_EXECUTE_TASK_RSP
         * @static
         * @param {tg.IMDM_GR_EXECUTE_TASK_RSP} message MDM_GR_EXECUTE_TASK_RSP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_EXECUTE_TASK_RSP.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.index);
            if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.total);
            if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.count);
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.code);
            if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.reason);
            if (message.sender != null && Object.hasOwnProperty.call(message, "sender"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.sender);
            if (message.receiver != null && Object.hasOwnProperty.call(message, "receiver"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.receiver);
            return writer;
        };

        /**
         * Encodes the specified MDM_GR_EXECUTE_TASK_RSP message, length delimited. Does not implicitly {@link tg.MDM_GR_EXECUTE_TASK_RSP.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.MDM_GR_EXECUTE_TASK_RSP
         * @static
         * @param {tg.IMDM_GR_EXECUTE_TASK_RSP} message MDM_GR_EXECUTE_TASK_RSP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_EXECUTE_TASK_RSP.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MDM_GR_EXECUTE_TASK_RSP message from the specified reader or buffer.
         * @function decode
         * @memberof tg.MDM_GR_EXECUTE_TASK_RSP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.MDM_GR_EXECUTE_TASK_RSP} MDM_GR_EXECUTE_TASK_RSP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_EXECUTE_TASK_RSP.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.MDM_GR_EXECUTE_TASK_RSP();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.index = reader.int32();
                        break;
                    }
                case 2: {
                        message.total = reader.int32();
                        break;
                    }
                case 3: {
                        message.count = reader.int32();
                        break;
                    }
                case 4: {
                        message.code = reader.int32();
                        break;
                    }
                case 5: {
                        message.reason = reader.string();
                        break;
                    }
                case 6: {
                        message.sender = reader.string();
                        break;
                    }
                case 7: {
                        message.receiver = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MDM_GR_EXECUTE_TASK_RSP message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.MDM_GR_EXECUTE_TASK_RSP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.MDM_GR_EXECUTE_TASK_RSP} MDM_GR_EXECUTE_TASK_RSP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_EXECUTE_TASK_RSP.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MDM_GR_EXECUTE_TASK_RSP message.
         * @function verify
         * @memberof tg.MDM_GR_EXECUTE_TASK_RSP
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MDM_GR_EXECUTE_TASK_RSP.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.index != null && message.hasOwnProperty("index"))
                if (!$util.isInteger(message.index))
                    return "index: integer expected";
            if (message.total != null && message.hasOwnProperty("total"))
                if (!$util.isInteger(message.total))
                    return "total: integer expected";
            if (message.count != null && message.hasOwnProperty("count"))
                if (!$util.isInteger(message.count))
                    return "count: integer expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code))
                    return "code: integer expected";
            if (message.reason != null && message.hasOwnProperty("reason"))
                if (!$util.isString(message.reason))
                    return "reason: string expected";
            if (message.sender != null && message.hasOwnProperty("sender"))
                if (!$util.isString(message.sender))
                    return "sender: string expected";
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (!$util.isString(message.receiver))
                    return "receiver: string expected";
            return null;
        };

        /**
         * Creates a MDM_GR_EXECUTE_TASK_RSP message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.MDM_GR_EXECUTE_TASK_RSP
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.MDM_GR_EXECUTE_TASK_RSP} MDM_GR_EXECUTE_TASK_RSP
         */
        MDM_GR_EXECUTE_TASK_RSP.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.MDM_GR_EXECUTE_TASK_RSP)
                return object;
            var message = new $root.tg.MDM_GR_EXECUTE_TASK_RSP();
            if (object.index != null)
                message.index = object.index | 0;
            if (object.total != null)
                message.total = object.total | 0;
            if (object.count != null)
                message.count = object.count | 0;
            if (object.code != null)
                message.code = object.code | 0;
            if (object.reason != null)
                message.reason = String(object.reason);
            if (object.sender != null)
                message.sender = String(object.sender);
            if (object.receiver != null)
                message.receiver = String(object.receiver);
            return message;
        };

        /**
         * Creates a plain object from a MDM_GR_EXECUTE_TASK_RSP message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.MDM_GR_EXECUTE_TASK_RSP
         * @static
         * @param {tg.MDM_GR_EXECUTE_TASK_RSP} message MDM_GR_EXECUTE_TASK_RSP
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MDM_GR_EXECUTE_TASK_RSP.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.index = 0;
                object.total = 0;
                object.count = 0;
                object.code = 0;
                object.reason = "";
                object.sender = "";
                object.receiver = "";
            }
            if (message.index != null && message.hasOwnProperty("index"))
                object.index = message.index;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            if (message.count != null && message.hasOwnProperty("count"))
                object.count = message.count;
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.reason != null && message.hasOwnProperty("reason"))
                object.reason = message.reason;
            if (message.sender != null && message.hasOwnProperty("sender"))
                object.sender = message.sender;
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                object.receiver = message.receiver;
            return object;
        };

        /**
         * Converts this MDM_GR_EXECUTE_TASK_RSP to JSON.
         * @function toJSON
         * @memberof tg.MDM_GR_EXECUTE_TASK_RSP
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MDM_GR_EXECUTE_TASK_RSP.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MDM_GR_EXECUTE_TASK_RSP
         * @function getTypeUrl
         * @memberof tg.MDM_GR_EXECUTE_TASK_RSP
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MDM_GR_EXECUTE_TASK_RSP.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.MDM_GR_EXECUTE_TASK_RSP";
        };

        return MDM_GR_EXECUTE_TASK_RSP;
    })();

    tg.MDM_GR_GET_TASK_LOG_REQ = (function() {

        /**
         * Properties of a MDM_GR_GET_TASK_LOG_REQ.
         * @memberof tg
         * @interface IMDM_GR_GET_TASK_LOG_REQ
         * @property {string|null} [account] MDM_GR_GET_TASK_LOG_REQ account
         * @property {number|null} [limit] MDM_GR_GET_TASK_LOG_REQ limit
         * @property {Array.<number>|null} [index] MDM_GR_GET_TASK_LOG_REQ index
         */

        /**
         * Constructs a new MDM_GR_GET_TASK_LOG_REQ.
         * @memberof tg
         * @classdesc Represents a MDM_GR_GET_TASK_LOG_REQ.
         * @implements IMDM_GR_GET_TASK_LOG_REQ
         * @constructor
         * @param {tg.IMDM_GR_GET_TASK_LOG_REQ=} [properties] Properties to set
         */
        function MDM_GR_GET_TASK_LOG_REQ(properties) {
            this.index = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MDM_GR_GET_TASK_LOG_REQ account.
         * @member {string} account
         * @memberof tg.MDM_GR_GET_TASK_LOG_REQ
         * @instance
         */
        MDM_GR_GET_TASK_LOG_REQ.prototype.account = "";

        /**
         * MDM_GR_GET_TASK_LOG_REQ limit.
         * @member {number} limit
         * @memberof tg.MDM_GR_GET_TASK_LOG_REQ
         * @instance
         */
        MDM_GR_GET_TASK_LOG_REQ.prototype.limit = 0;

        /**
         * MDM_GR_GET_TASK_LOG_REQ index.
         * @member {Array.<number>} index
         * @memberof tg.MDM_GR_GET_TASK_LOG_REQ
         * @instance
         */
        MDM_GR_GET_TASK_LOG_REQ.prototype.index = $util.emptyArray;

        /**
         * Creates a new MDM_GR_GET_TASK_LOG_REQ instance using the specified properties.
         * @function create
         * @memberof tg.MDM_GR_GET_TASK_LOG_REQ
         * @static
         * @param {tg.IMDM_GR_GET_TASK_LOG_REQ=} [properties] Properties to set
         * @returns {tg.MDM_GR_GET_TASK_LOG_REQ} MDM_GR_GET_TASK_LOG_REQ instance
         */
        MDM_GR_GET_TASK_LOG_REQ.create = function create(properties) {
            return new MDM_GR_GET_TASK_LOG_REQ(properties);
        };

        /**
         * Encodes the specified MDM_GR_GET_TASK_LOG_REQ message. Does not implicitly {@link tg.MDM_GR_GET_TASK_LOG_REQ.verify|verify} messages.
         * @function encode
         * @memberof tg.MDM_GR_GET_TASK_LOG_REQ
         * @static
         * @param {tg.IMDM_GR_GET_TASK_LOG_REQ} message MDM_GR_GET_TASK_LOG_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_GET_TASK_LOG_REQ.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.account);
            if (message.limit != null && Object.hasOwnProperty.call(message, "limit"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.limit);
            if (message.index != null && message.index.length) {
                writer.uint32(/* id 3, wireType 2 =*/26).fork();
                for (var i = 0; i < message.index.length; ++i)
                    writer.int32(message.index[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified MDM_GR_GET_TASK_LOG_REQ message, length delimited. Does not implicitly {@link tg.MDM_GR_GET_TASK_LOG_REQ.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.MDM_GR_GET_TASK_LOG_REQ
         * @static
         * @param {tg.IMDM_GR_GET_TASK_LOG_REQ} message MDM_GR_GET_TASK_LOG_REQ message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_GET_TASK_LOG_REQ.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MDM_GR_GET_TASK_LOG_REQ message from the specified reader or buffer.
         * @function decode
         * @memberof tg.MDM_GR_GET_TASK_LOG_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.MDM_GR_GET_TASK_LOG_REQ} MDM_GR_GET_TASK_LOG_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_GET_TASK_LOG_REQ.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.MDM_GR_GET_TASK_LOG_REQ();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.account = reader.string();
                        break;
                    }
                case 2: {
                        message.limit = reader.int32();
                        break;
                    }
                case 3: {
                        if (!(message.index && message.index.length))
                            message.index = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.index.push(reader.int32());
                        } else
                            message.index.push(reader.int32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MDM_GR_GET_TASK_LOG_REQ message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.MDM_GR_GET_TASK_LOG_REQ
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.MDM_GR_GET_TASK_LOG_REQ} MDM_GR_GET_TASK_LOG_REQ
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_GET_TASK_LOG_REQ.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MDM_GR_GET_TASK_LOG_REQ message.
         * @function verify
         * @memberof tg.MDM_GR_GET_TASK_LOG_REQ
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MDM_GR_GET_TASK_LOG_REQ.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isString(message.account))
                    return "account: string expected";
            if (message.limit != null && message.hasOwnProperty("limit"))
                if (!$util.isInteger(message.limit))
                    return "limit: integer expected";
            if (message.index != null && message.hasOwnProperty("index")) {
                if (!Array.isArray(message.index))
                    return "index: array expected";
                for (var i = 0; i < message.index.length; ++i)
                    if (!$util.isInteger(message.index[i]))
                        return "index: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a MDM_GR_GET_TASK_LOG_REQ message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.MDM_GR_GET_TASK_LOG_REQ
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.MDM_GR_GET_TASK_LOG_REQ} MDM_GR_GET_TASK_LOG_REQ
         */
        MDM_GR_GET_TASK_LOG_REQ.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.MDM_GR_GET_TASK_LOG_REQ)
                return object;
            var message = new $root.tg.MDM_GR_GET_TASK_LOG_REQ();
            if (object.account != null)
                message.account = String(object.account);
            if (object.limit != null)
                message.limit = object.limit | 0;
            if (object.index) {
                if (!Array.isArray(object.index))
                    throw TypeError(".tg.MDM_GR_GET_TASK_LOG_REQ.index: array expected");
                message.index = [];
                for (var i = 0; i < object.index.length; ++i)
                    message.index[i] = object.index[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a MDM_GR_GET_TASK_LOG_REQ message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.MDM_GR_GET_TASK_LOG_REQ
         * @static
         * @param {tg.MDM_GR_GET_TASK_LOG_REQ} message MDM_GR_GET_TASK_LOG_REQ
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MDM_GR_GET_TASK_LOG_REQ.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.index = [];
            if (options.defaults) {
                object.account = "";
                object.limit = 0;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            if (message.limit != null && message.hasOwnProperty("limit"))
                object.limit = message.limit;
            if (message.index && message.index.length) {
                object.index = [];
                for (var j = 0; j < message.index.length; ++j)
                    object.index[j] = message.index[j];
            }
            return object;
        };

        /**
         * Converts this MDM_GR_GET_TASK_LOG_REQ to JSON.
         * @function toJSON
         * @memberof tg.MDM_GR_GET_TASK_LOG_REQ
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MDM_GR_GET_TASK_LOG_REQ.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MDM_GR_GET_TASK_LOG_REQ
         * @function getTypeUrl
         * @memberof tg.MDM_GR_GET_TASK_LOG_REQ
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MDM_GR_GET_TASK_LOG_REQ.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.MDM_GR_GET_TASK_LOG_REQ";
        };

        return MDM_GR_GET_TASK_LOG_REQ;
    })();

    tg.TaskLogItem = (function() {

        /**
         * Properties of a TaskLogItem.
         * @memberof tg
         * @interface ITaskLogItem
         * @property {number|Long|null} [taskId] TaskLogItem taskId
         * @property {number|null} [idx] TaskLogItem idx
         * @property {string|null} [receiver] TaskLogItem receiver
         * @property {number|Long|null} [receiver_id] TaskLogItem receiver_id
         * @property {string|null} [message] TaskLogItem message
         * @property {number|Long|null} [sendTime] TaskLogItem sendTime
         * @property {number|null} [errCode] TaskLogItem errCode
         * @property {string|null} [errorMsg] TaskLogItem errorMsg
         * @property {string|null} [phone] TaskLogItem phone
         */

        /**
         * Constructs a new TaskLogItem.
         * @memberof tg
         * @classdesc Represents a TaskLogItem.
         * @implements ITaskLogItem
         * @constructor
         * @param {tg.ITaskLogItem=} [properties] Properties to set
         */
        function TaskLogItem(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TaskLogItem taskId.
         * @member {number|Long} taskId
         * @memberof tg.TaskLogItem
         * @instance
         */
        TaskLogItem.prototype.taskId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * TaskLogItem idx.
         * @member {number} idx
         * @memberof tg.TaskLogItem
         * @instance
         */
        TaskLogItem.prototype.idx = 0;

        /**
         * TaskLogItem receiver.
         * @member {string} receiver
         * @memberof tg.TaskLogItem
         * @instance
         */
        TaskLogItem.prototype.receiver = "";

        /**
         * TaskLogItem receiver_id.
         * @member {number|Long} receiver_id
         * @memberof tg.TaskLogItem
         * @instance
         */
        TaskLogItem.prototype.receiver_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * TaskLogItem message.
         * @member {string} message
         * @memberof tg.TaskLogItem
         * @instance
         */
        TaskLogItem.prototype.message = "";

        /**
         * TaskLogItem sendTime.
         * @member {number|Long} sendTime
         * @memberof tg.TaskLogItem
         * @instance
         */
        TaskLogItem.prototype.sendTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TaskLogItem errCode.
         * @member {number} errCode
         * @memberof tg.TaskLogItem
         * @instance
         */
        TaskLogItem.prototype.errCode = 0;

        /**
         * TaskLogItem errorMsg.
         * @member {string} errorMsg
         * @memberof tg.TaskLogItem
         * @instance
         */
        TaskLogItem.prototype.errorMsg = "";

        /**
         * TaskLogItem phone.
         * @member {string} phone
         * @memberof tg.TaskLogItem
         * @instance
         */
        TaskLogItem.prototype.phone = "";

        /**
         * Creates a new TaskLogItem instance using the specified properties.
         * @function create
         * @memberof tg.TaskLogItem
         * @static
         * @param {tg.ITaskLogItem=} [properties] Properties to set
         * @returns {tg.TaskLogItem} TaskLogItem instance
         */
        TaskLogItem.create = function create(properties) {
            return new TaskLogItem(properties);
        };

        /**
         * Encodes the specified TaskLogItem message. Does not implicitly {@link tg.TaskLogItem.verify|verify} messages.
         * @function encode
         * @memberof tg.TaskLogItem
         * @static
         * @param {tg.ITaskLogItem} message TaskLogItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TaskLogItem.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.taskId != null && Object.hasOwnProperty.call(message, "taskId"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.taskId);
            if (message.idx != null && Object.hasOwnProperty.call(message, "idx"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.idx);
            if (message.receiver != null && Object.hasOwnProperty.call(message, "receiver"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.receiver);
            if (message.receiver_id != null && Object.hasOwnProperty.call(message, "receiver_id"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.receiver_id);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.message);
            if (message.sendTime != null && Object.hasOwnProperty.call(message, "sendTime"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.sendTime);
            if (message.errCode != null && Object.hasOwnProperty.call(message, "errCode"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.errCode);
            if (message.errorMsg != null && Object.hasOwnProperty.call(message, "errorMsg"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.errorMsg);
            if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.phone);
            return writer;
        };

        /**
         * Encodes the specified TaskLogItem message, length delimited. Does not implicitly {@link tg.TaskLogItem.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.TaskLogItem
         * @static
         * @param {tg.ITaskLogItem} message TaskLogItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TaskLogItem.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TaskLogItem message from the specified reader or buffer.
         * @function decode
         * @memberof tg.TaskLogItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.TaskLogItem} TaskLogItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TaskLogItem.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.TaskLogItem();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.taskId = reader.uint64();
                        break;
                    }
                case 2: {
                        message.idx = reader.int32();
                        break;
                    }
                case 3: {
                        message.receiver = reader.string();
                        break;
                    }
                case 4: {
                        message.receiver_id = reader.uint64();
                        break;
                    }
                case 5: {
                        message.message = reader.string();
                        break;
                    }
                case 6: {
                        message.sendTime = reader.int64();
                        break;
                    }
                case 7: {
                        message.errCode = reader.int32();
                        break;
                    }
                case 8: {
                        message.errorMsg = reader.string();
                        break;
                    }
                case 9: {
                        message.phone = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TaskLogItem message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.TaskLogItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.TaskLogItem} TaskLogItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TaskLogItem.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TaskLogItem message.
         * @function verify
         * @memberof tg.TaskLogItem
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TaskLogItem.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.taskId != null && message.hasOwnProperty("taskId"))
                if (!$util.isInteger(message.taskId) && !(message.taskId && $util.isInteger(message.taskId.low) && $util.isInteger(message.taskId.high)))
                    return "taskId: integer|Long expected";
            if (message.idx != null && message.hasOwnProperty("idx"))
                if (!$util.isInteger(message.idx))
                    return "idx: integer expected";
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (!$util.isString(message.receiver))
                    return "receiver: string expected";
            if (message.receiver_id != null && message.hasOwnProperty("receiver_id"))
                if (!$util.isInteger(message.receiver_id) && !(message.receiver_id && $util.isInteger(message.receiver_id.low) && $util.isInteger(message.receiver_id.high)))
                    return "receiver_id: integer|Long expected";
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            if (message.sendTime != null && message.hasOwnProperty("sendTime"))
                if (!$util.isInteger(message.sendTime) && !(message.sendTime && $util.isInteger(message.sendTime.low) && $util.isInteger(message.sendTime.high)))
                    return "sendTime: integer|Long expected";
            if (message.errCode != null && message.hasOwnProperty("errCode"))
                if (!$util.isInteger(message.errCode))
                    return "errCode: integer expected";
            if (message.errorMsg != null && message.hasOwnProperty("errorMsg"))
                if (!$util.isString(message.errorMsg))
                    return "errorMsg: string expected";
            if (message.phone != null && message.hasOwnProperty("phone"))
                if (!$util.isString(message.phone))
                    return "phone: string expected";
            return null;
        };

        /**
         * Creates a TaskLogItem message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.TaskLogItem
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.TaskLogItem} TaskLogItem
         */
        TaskLogItem.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.TaskLogItem)
                return object;
            var message = new $root.tg.TaskLogItem();
            if (object.taskId != null)
                if ($util.Long)
                    (message.taskId = $util.Long.fromValue(object.taskId)).unsigned = true;
                else if (typeof object.taskId === "string")
                    message.taskId = parseInt(object.taskId, 10);
                else if (typeof object.taskId === "number")
                    message.taskId = object.taskId;
                else if (typeof object.taskId === "object")
                    message.taskId = new $util.LongBits(object.taskId.low >>> 0, object.taskId.high >>> 0).toNumber(true);
            if (object.idx != null)
                message.idx = object.idx | 0;
            if (object.receiver != null)
                message.receiver = String(object.receiver);
            if (object.receiver_id != null)
                if ($util.Long)
                    (message.receiver_id = $util.Long.fromValue(object.receiver_id)).unsigned = true;
                else if (typeof object.receiver_id === "string")
                    message.receiver_id = parseInt(object.receiver_id, 10);
                else if (typeof object.receiver_id === "number")
                    message.receiver_id = object.receiver_id;
                else if (typeof object.receiver_id === "object")
                    message.receiver_id = new $util.LongBits(object.receiver_id.low >>> 0, object.receiver_id.high >>> 0).toNumber(true);
            if (object.message != null)
                message.message = String(object.message);
            if (object.sendTime != null)
                if ($util.Long)
                    (message.sendTime = $util.Long.fromValue(object.sendTime)).unsigned = false;
                else if (typeof object.sendTime === "string")
                    message.sendTime = parseInt(object.sendTime, 10);
                else if (typeof object.sendTime === "number")
                    message.sendTime = object.sendTime;
                else if (typeof object.sendTime === "object")
                    message.sendTime = new $util.LongBits(object.sendTime.low >>> 0, object.sendTime.high >>> 0).toNumber();
            if (object.errCode != null)
                message.errCode = object.errCode | 0;
            if (object.errorMsg != null)
                message.errorMsg = String(object.errorMsg);
            if (object.phone != null)
                message.phone = String(object.phone);
            return message;
        };

        /**
         * Creates a plain object from a TaskLogItem message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.TaskLogItem
         * @static
         * @param {tg.TaskLogItem} message TaskLogItem
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TaskLogItem.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.taskId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.taskId = options.longs === String ? "0" : 0;
                object.idx = 0;
                object.receiver = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.receiver_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiver_id = options.longs === String ? "0" : 0;
                object.message = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.sendTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.sendTime = options.longs === String ? "0" : 0;
                object.errCode = 0;
                object.errorMsg = "";
                object.phone = "";
            }
            if (message.taskId != null && message.hasOwnProperty("taskId"))
                if (typeof message.taskId === "number")
                    object.taskId = options.longs === String ? String(message.taskId) : message.taskId;
                else
                    object.taskId = options.longs === String ? $util.Long.prototype.toString.call(message.taskId) : options.longs === Number ? new $util.LongBits(message.taskId.low >>> 0, message.taskId.high >>> 0).toNumber(true) : message.taskId;
            if (message.idx != null && message.hasOwnProperty("idx"))
                object.idx = message.idx;
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                object.receiver = message.receiver;
            if (message.receiver_id != null && message.hasOwnProperty("receiver_id"))
                if (typeof message.receiver_id === "number")
                    object.receiver_id = options.longs === String ? String(message.receiver_id) : message.receiver_id;
                else
                    object.receiver_id = options.longs === String ? $util.Long.prototype.toString.call(message.receiver_id) : options.longs === Number ? new $util.LongBits(message.receiver_id.low >>> 0, message.receiver_id.high >>> 0).toNumber(true) : message.receiver_id;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            if (message.sendTime != null && message.hasOwnProperty("sendTime"))
                if (typeof message.sendTime === "number")
                    object.sendTime = options.longs === String ? String(message.sendTime) : message.sendTime;
                else
                    object.sendTime = options.longs === String ? $util.Long.prototype.toString.call(message.sendTime) : options.longs === Number ? new $util.LongBits(message.sendTime.low >>> 0, message.sendTime.high >>> 0).toNumber() : message.sendTime;
            if (message.errCode != null && message.hasOwnProperty("errCode"))
                object.errCode = message.errCode;
            if (message.errorMsg != null && message.hasOwnProperty("errorMsg"))
                object.errorMsg = message.errorMsg;
            if (message.phone != null && message.hasOwnProperty("phone"))
                object.phone = message.phone;
            return object;
        };

        /**
         * Converts this TaskLogItem to JSON.
         * @function toJSON
         * @memberof tg.TaskLogItem
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TaskLogItem.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for TaskLogItem
         * @function getTypeUrl
         * @memberof tg.TaskLogItem
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        TaskLogItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.TaskLogItem";
        };

        return TaskLogItem;
    })();

    tg.MDM_GR_GET_TASK_LOG_RSP = (function() {

        /**
         * Properties of a MDM_GR_GET_TASK_LOG_RSP.
         * @memberof tg
         * @interface IMDM_GR_GET_TASK_LOG_RSP
         * @property {number|null} [code] MDM_GR_GET_TASK_LOG_RSP code
         * @property {string|null} [reason] MDM_GR_GET_TASK_LOG_RSP reason
         * @property {Array.<tg.ITaskLogItem>|null} [list] MDM_GR_GET_TASK_LOG_RSP list
         */

        /**
         * Constructs a new MDM_GR_GET_TASK_LOG_RSP.
         * @memberof tg
         * @classdesc Represents a MDM_GR_GET_TASK_LOG_RSP.
         * @implements IMDM_GR_GET_TASK_LOG_RSP
         * @constructor
         * @param {tg.IMDM_GR_GET_TASK_LOG_RSP=} [properties] Properties to set
         */
        function MDM_GR_GET_TASK_LOG_RSP(properties) {
            this.list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MDM_GR_GET_TASK_LOG_RSP code.
         * @member {number} code
         * @memberof tg.MDM_GR_GET_TASK_LOG_RSP
         * @instance
         */
        MDM_GR_GET_TASK_LOG_RSP.prototype.code = 0;

        /**
         * MDM_GR_GET_TASK_LOG_RSP reason.
         * @member {string} reason
         * @memberof tg.MDM_GR_GET_TASK_LOG_RSP
         * @instance
         */
        MDM_GR_GET_TASK_LOG_RSP.prototype.reason = "";

        /**
         * MDM_GR_GET_TASK_LOG_RSP list.
         * @member {Array.<tg.ITaskLogItem>} list
         * @memberof tg.MDM_GR_GET_TASK_LOG_RSP
         * @instance
         */
        MDM_GR_GET_TASK_LOG_RSP.prototype.list = $util.emptyArray;

        /**
         * Creates a new MDM_GR_GET_TASK_LOG_RSP instance using the specified properties.
         * @function create
         * @memberof tg.MDM_GR_GET_TASK_LOG_RSP
         * @static
         * @param {tg.IMDM_GR_GET_TASK_LOG_RSP=} [properties] Properties to set
         * @returns {tg.MDM_GR_GET_TASK_LOG_RSP} MDM_GR_GET_TASK_LOG_RSP instance
         */
        MDM_GR_GET_TASK_LOG_RSP.create = function create(properties) {
            return new MDM_GR_GET_TASK_LOG_RSP(properties);
        };

        /**
         * Encodes the specified MDM_GR_GET_TASK_LOG_RSP message. Does not implicitly {@link tg.MDM_GR_GET_TASK_LOG_RSP.verify|verify} messages.
         * @function encode
         * @memberof tg.MDM_GR_GET_TASK_LOG_RSP
         * @static
         * @param {tg.IMDM_GR_GET_TASK_LOG_RSP} message MDM_GR_GET_TASK_LOG_RSP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_GET_TASK_LOG_RSP.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
            if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.reason);
            if (message.list != null && message.list.length)
                for (var i = 0; i < message.list.length; ++i)
                    $root.tg.TaskLogItem.encode(message.list[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified MDM_GR_GET_TASK_LOG_RSP message, length delimited. Does not implicitly {@link tg.MDM_GR_GET_TASK_LOG_RSP.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.MDM_GR_GET_TASK_LOG_RSP
         * @static
         * @param {tg.IMDM_GR_GET_TASK_LOG_RSP} message MDM_GR_GET_TASK_LOG_RSP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_GET_TASK_LOG_RSP.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MDM_GR_GET_TASK_LOG_RSP message from the specified reader or buffer.
         * @function decode
         * @memberof tg.MDM_GR_GET_TASK_LOG_RSP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.MDM_GR_GET_TASK_LOG_RSP} MDM_GR_GET_TASK_LOG_RSP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_GET_TASK_LOG_RSP.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.MDM_GR_GET_TASK_LOG_RSP();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.code = reader.int32();
                        break;
                    }
                case 2: {
                        message.reason = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.tg.TaskLogItem.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MDM_GR_GET_TASK_LOG_RSP message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.MDM_GR_GET_TASK_LOG_RSP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.MDM_GR_GET_TASK_LOG_RSP} MDM_GR_GET_TASK_LOG_RSP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_GET_TASK_LOG_RSP.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MDM_GR_GET_TASK_LOG_RSP message.
         * @function verify
         * @memberof tg.MDM_GR_GET_TASK_LOG_RSP
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MDM_GR_GET_TASK_LOG_RSP.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code))
                    return "code: integer expected";
            if (message.reason != null && message.hasOwnProperty("reason"))
                if (!$util.isString(message.reason))
                    return "reason: string expected";
            if (message.list != null && message.hasOwnProperty("list")) {
                if (!Array.isArray(message.list))
                    return "list: array expected";
                for (var i = 0; i < message.list.length; ++i) {
                    var error = $root.tg.TaskLogItem.verify(message.list[i]);
                    if (error)
                        return "list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a MDM_GR_GET_TASK_LOG_RSP message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.MDM_GR_GET_TASK_LOG_RSP
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.MDM_GR_GET_TASK_LOG_RSP} MDM_GR_GET_TASK_LOG_RSP
         */
        MDM_GR_GET_TASK_LOG_RSP.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.MDM_GR_GET_TASK_LOG_RSP)
                return object;
            var message = new $root.tg.MDM_GR_GET_TASK_LOG_RSP();
            if (object.code != null)
                message.code = object.code | 0;
            if (object.reason != null)
                message.reason = String(object.reason);
            if (object.list) {
                if (!Array.isArray(object.list))
                    throw TypeError(".tg.MDM_GR_GET_TASK_LOG_RSP.list: array expected");
                message.list = [];
                for (var i = 0; i < object.list.length; ++i) {
                    if (typeof object.list[i] !== "object")
                        throw TypeError(".tg.MDM_GR_GET_TASK_LOG_RSP.list: object expected");
                    message.list[i] = $root.tg.TaskLogItem.fromObject(object.list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a MDM_GR_GET_TASK_LOG_RSP message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.MDM_GR_GET_TASK_LOG_RSP
         * @static
         * @param {tg.MDM_GR_GET_TASK_LOG_RSP} message MDM_GR_GET_TASK_LOG_RSP
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MDM_GR_GET_TASK_LOG_RSP.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.list = [];
            if (options.defaults) {
                object.code = 0;
                object.reason = "";
            }
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.reason != null && message.hasOwnProperty("reason"))
                object.reason = message.reason;
            if (message.list && message.list.length) {
                object.list = [];
                for (var j = 0; j < message.list.length; ++j)
                    object.list[j] = $root.tg.TaskLogItem.toObject(message.list[j], options);
            }
            return object;
        };

        /**
         * Converts this MDM_GR_GET_TASK_LOG_RSP to JSON.
         * @function toJSON
         * @memberof tg.MDM_GR_GET_TASK_LOG_RSP
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MDM_GR_GET_TASK_LOG_RSP.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MDM_GR_GET_TASK_LOG_RSP
         * @function getTypeUrl
         * @memberof tg.MDM_GR_GET_TASK_LOG_RSP
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MDM_GR_GET_TASK_LOG_RSP.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.MDM_GR_GET_TASK_LOG_RSP";
        };

        return MDM_GR_GET_TASK_LOG_RSP;
    })();

    tg.MDM_GR_GET_TASK_LOG_EVENT = (function() {

        /**
         * Properties of a MDM_GR_GET_TASK_LOG_EVENT.
         * @memberof tg
         * @interface IMDM_GR_GET_TASK_LOG_EVENT
         * @property {string|null} [account] MDM_GR_GET_TASK_LOG_EVENT account
         * @property {string|null} [session] MDM_GR_GET_TASK_LOG_EVENT session
         */

        /**
         * Constructs a new MDM_GR_GET_TASK_LOG_EVENT.
         * @memberof tg
         * @classdesc Represents a MDM_GR_GET_TASK_LOG_EVENT.
         * @implements IMDM_GR_GET_TASK_LOG_EVENT
         * @constructor
         * @param {tg.IMDM_GR_GET_TASK_LOG_EVENT=} [properties] Properties to set
         */
        function MDM_GR_GET_TASK_LOG_EVENT(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MDM_GR_GET_TASK_LOG_EVENT account.
         * @member {string} account
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT
         * @instance
         */
        MDM_GR_GET_TASK_LOG_EVENT.prototype.account = "";

        /**
         * MDM_GR_GET_TASK_LOG_EVENT session.
         * @member {string} session
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT
         * @instance
         */
        MDM_GR_GET_TASK_LOG_EVENT.prototype.session = "";

        /**
         * Creates a new MDM_GR_GET_TASK_LOG_EVENT instance using the specified properties.
         * @function create
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT
         * @static
         * @param {tg.IMDM_GR_GET_TASK_LOG_EVENT=} [properties] Properties to set
         * @returns {tg.MDM_GR_GET_TASK_LOG_EVENT} MDM_GR_GET_TASK_LOG_EVENT instance
         */
        MDM_GR_GET_TASK_LOG_EVENT.create = function create(properties) {
            return new MDM_GR_GET_TASK_LOG_EVENT(properties);
        };

        /**
         * Encodes the specified MDM_GR_GET_TASK_LOG_EVENT message. Does not implicitly {@link tg.MDM_GR_GET_TASK_LOG_EVENT.verify|verify} messages.
         * @function encode
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT
         * @static
         * @param {tg.IMDM_GR_GET_TASK_LOG_EVENT} message MDM_GR_GET_TASK_LOG_EVENT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_GET_TASK_LOG_EVENT.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.account);
            if (message.session != null && Object.hasOwnProperty.call(message, "session"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.session);
            return writer;
        };

        /**
         * Encodes the specified MDM_GR_GET_TASK_LOG_EVENT message, length delimited. Does not implicitly {@link tg.MDM_GR_GET_TASK_LOG_EVENT.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT
         * @static
         * @param {tg.IMDM_GR_GET_TASK_LOG_EVENT} message MDM_GR_GET_TASK_LOG_EVENT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_GET_TASK_LOG_EVENT.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MDM_GR_GET_TASK_LOG_EVENT message from the specified reader or buffer.
         * @function decode
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.MDM_GR_GET_TASK_LOG_EVENT} MDM_GR_GET_TASK_LOG_EVENT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_GET_TASK_LOG_EVENT.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.MDM_GR_GET_TASK_LOG_EVENT();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.account = reader.string();
                        break;
                    }
                case 2: {
                        message.session = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MDM_GR_GET_TASK_LOG_EVENT message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.MDM_GR_GET_TASK_LOG_EVENT} MDM_GR_GET_TASK_LOG_EVENT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_GET_TASK_LOG_EVENT.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MDM_GR_GET_TASK_LOG_EVENT message.
         * @function verify
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MDM_GR_GET_TASK_LOG_EVENT.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isString(message.account))
                    return "account: string expected";
            if (message.session != null && message.hasOwnProperty("session"))
                if (!$util.isString(message.session))
                    return "session: string expected";
            return null;
        };

        /**
         * Creates a MDM_GR_GET_TASK_LOG_EVENT message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.MDM_GR_GET_TASK_LOG_EVENT} MDM_GR_GET_TASK_LOG_EVENT
         */
        MDM_GR_GET_TASK_LOG_EVENT.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.MDM_GR_GET_TASK_LOG_EVENT)
                return object;
            var message = new $root.tg.MDM_GR_GET_TASK_LOG_EVENT();
            if (object.account != null)
                message.account = String(object.account);
            if (object.session != null)
                message.session = String(object.session);
            return message;
        };

        /**
         * Creates a plain object from a MDM_GR_GET_TASK_LOG_EVENT message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT
         * @static
         * @param {tg.MDM_GR_GET_TASK_LOG_EVENT} message MDM_GR_GET_TASK_LOG_EVENT
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MDM_GR_GET_TASK_LOG_EVENT.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.account = "";
                object.session = "";
            }
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            if (message.session != null && message.hasOwnProperty("session"))
                object.session = message.session;
            return object;
        };

        /**
         * Converts this MDM_GR_GET_TASK_LOG_EVENT to JSON.
         * @function toJSON
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MDM_GR_GET_TASK_LOG_EVENT.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MDM_GR_GET_TASK_LOG_EVENT
         * @function getTypeUrl
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MDM_GR_GET_TASK_LOG_EVENT.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.MDM_GR_GET_TASK_LOG_EVENT";
        };

        return MDM_GR_GET_TASK_LOG_EVENT;
    })();

    tg.MDM_GR_GET_TASK_LOG_EVENT_RSP = (function() {

        /**
         * Properties of a MDM_GR_GET_TASK_LOG_EVENT_RSP.
         * @memberof tg
         * @interface IMDM_GR_GET_TASK_LOG_EVENT_RSP
         * @property {tg.ITaskLogItem|null} [data] MDM_GR_GET_TASK_LOG_EVENT_RSP data
         */

        /**
         * Constructs a new MDM_GR_GET_TASK_LOG_EVENT_RSP.
         * @memberof tg
         * @classdesc Represents a MDM_GR_GET_TASK_LOG_EVENT_RSP.
         * @implements IMDM_GR_GET_TASK_LOG_EVENT_RSP
         * @constructor
         * @param {tg.IMDM_GR_GET_TASK_LOG_EVENT_RSP=} [properties] Properties to set
         */
        function MDM_GR_GET_TASK_LOG_EVENT_RSP(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MDM_GR_GET_TASK_LOG_EVENT_RSP data.
         * @member {tg.ITaskLogItem|null|undefined} data
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT_RSP
         * @instance
         */
        MDM_GR_GET_TASK_LOG_EVENT_RSP.prototype.data = null;

        /**
         * Creates a new MDM_GR_GET_TASK_LOG_EVENT_RSP instance using the specified properties.
         * @function create
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT_RSP
         * @static
         * @param {tg.IMDM_GR_GET_TASK_LOG_EVENT_RSP=} [properties] Properties to set
         * @returns {tg.MDM_GR_GET_TASK_LOG_EVENT_RSP} MDM_GR_GET_TASK_LOG_EVENT_RSP instance
         */
        MDM_GR_GET_TASK_LOG_EVENT_RSP.create = function create(properties) {
            return new MDM_GR_GET_TASK_LOG_EVENT_RSP(properties);
        };

        /**
         * Encodes the specified MDM_GR_GET_TASK_LOG_EVENT_RSP message. Does not implicitly {@link tg.MDM_GR_GET_TASK_LOG_EVENT_RSP.verify|verify} messages.
         * @function encode
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT_RSP
         * @static
         * @param {tg.IMDM_GR_GET_TASK_LOG_EVENT_RSP} message MDM_GR_GET_TASK_LOG_EVENT_RSP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_GET_TASK_LOG_EVENT_RSP.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                $root.tg.TaskLogItem.encode(message.data, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified MDM_GR_GET_TASK_LOG_EVENT_RSP message, length delimited. Does not implicitly {@link tg.MDM_GR_GET_TASK_LOG_EVENT_RSP.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT_RSP
         * @static
         * @param {tg.IMDM_GR_GET_TASK_LOG_EVENT_RSP} message MDM_GR_GET_TASK_LOG_EVENT_RSP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MDM_GR_GET_TASK_LOG_EVENT_RSP.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MDM_GR_GET_TASK_LOG_EVENT_RSP message from the specified reader or buffer.
         * @function decode
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT_RSP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tg.MDM_GR_GET_TASK_LOG_EVENT_RSP} MDM_GR_GET_TASK_LOG_EVENT_RSP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_GET_TASK_LOG_EVENT_RSP.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.tg.MDM_GR_GET_TASK_LOG_EVENT_RSP();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.data = $root.tg.TaskLogItem.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MDM_GR_GET_TASK_LOG_EVENT_RSP message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT_RSP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tg.MDM_GR_GET_TASK_LOG_EVENT_RSP} MDM_GR_GET_TASK_LOG_EVENT_RSP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MDM_GR_GET_TASK_LOG_EVENT_RSP.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MDM_GR_GET_TASK_LOG_EVENT_RSP message.
         * @function verify
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT_RSP
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MDM_GR_GET_TASK_LOG_EVENT_RSP.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.data != null && message.hasOwnProperty("data")) {
                var error = $root.tg.TaskLogItem.verify(message.data);
                if (error)
                    return "data." + error;
            }
            return null;
        };

        /**
         * Creates a MDM_GR_GET_TASK_LOG_EVENT_RSP message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT_RSP
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tg.MDM_GR_GET_TASK_LOG_EVENT_RSP} MDM_GR_GET_TASK_LOG_EVENT_RSP
         */
        MDM_GR_GET_TASK_LOG_EVENT_RSP.fromObject = function fromObject(object) {
            if (object instanceof $root.tg.MDM_GR_GET_TASK_LOG_EVENT_RSP)
                return object;
            var message = new $root.tg.MDM_GR_GET_TASK_LOG_EVENT_RSP();
            if (object.data != null) {
                if (typeof object.data !== "object")
                    throw TypeError(".tg.MDM_GR_GET_TASK_LOG_EVENT_RSP.data: object expected");
                message.data = $root.tg.TaskLogItem.fromObject(object.data);
            }
            return message;
        };

        /**
         * Creates a plain object from a MDM_GR_GET_TASK_LOG_EVENT_RSP message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT_RSP
         * @static
         * @param {tg.MDM_GR_GET_TASK_LOG_EVENT_RSP} message MDM_GR_GET_TASK_LOG_EVENT_RSP
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MDM_GR_GET_TASK_LOG_EVENT_RSP.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.data = null;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = $root.tg.TaskLogItem.toObject(message.data, options);
            return object;
        };

        /**
         * Converts this MDM_GR_GET_TASK_LOG_EVENT_RSP to JSON.
         * @function toJSON
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT_RSP
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MDM_GR_GET_TASK_LOG_EVENT_RSP.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MDM_GR_GET_TASK_LOG_EVENT_RSP
         * @function getTypeUrl
         * @memberof tg.MDM_GR_GET_TASK_LOG_EVENT_RSP
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MDM_GR_GET_TASK_LOG_EVENT_RSP.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tg.MDM_GR_GET_TASK_LOG_EVENT_RSP";
        };

        return MDM_GR_GET_TASK_LOG_EVENT_RSP;
    })();

    return tg;
})();

module.exports = $root;
